/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */
export type ChirpVoid = {};

export type Tier =
  | 'MARKETING_STARTER'
  | 'MARKETING_PROFESSIONAL'
  | 'MARKETING_ENTERPRISE'
  | 'SALES_STARTER'
  | 'SALES_PROFESSIONAL'
  | 'SALES_ENTERPRISE'
  | 'SERVICE_STARTER'
  | 'SERVICE_PROFESSIONAL'
  | 'SERVICE_ENTERPRISE'
  | 'CMS_STANDALONE'
  | 'HUBSPOT_FREE'
  | 'CMS_ENTERPRISE'
  | 'OPS_ENTERPRISE'
  | 'OPS_PROFESSIONAL'
  | 'OPS_STARTER'
  | 'CMS_STARTER'
  | 'CONTENT_STARTER'
  | 'CONTENT_PROFESSIONAL'
  | 'CONTENT_ENTERPRISE'
  | unhandledEnumCase;

export type GetInstallExemptionStatusRequest = { productId: number };

export type GetInstallExemptionStatusResponse = {
  installExemption?: InstallExemption;
};

export type InstallCountBatchRequest = {
  listingIds: Default<number[]>;
  slugs: Default<string[]>;
};

export type InstallCountBatchResponse = {
  countsByListingId: Default<Record<string, number>>;
  countsBySlug: Default<Record<string, number>>;
};

export type InstallCountRequest = {
  listingId?: number;
  /** @deprecated please query by listing ID rather than slug where possible */
  slug?: string;
};

export type InstallCountResponse = { count: number };

export type InstallExemption = {
  productId: number;
  state: InstallExemptionState;
  updatedAt: number;
};

export type InstallExemptionState =
  | 'SUBMITTED'
  | 'UNDER_REVIEW'
  | 'APPROVED'
  | 'REJECTED'
  | unhandledEnumCase;

export type InstallIntentRequest = { slug: string };

export type InstallsError = {
  errorType: ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type OAuthUrlRequest = {
  listingId: number;
  published: Default<boolean>;
};

export type OAuthUrlResponse = { oauthUrl: string };

export type ScopeGroupMessage = {
  id: number;
  name: string;
  shortDescription: string;
  longDescription?: string;
  pictoIcon?: string;
  whitelisted?: boolean;
  visibility: string;
  version: string;
};

export type ErrorType =
  | 'UNSUPPORTED'
  | 'NOT_FOUND'
  | 'MISSING_INPUT'
  | 'UNEXPECTED'
  | 'UNAUTHORIZED'
  | unhandledEnumCase;

export const AgentSpecificUninstallableReasonTypename =
  'com.hubspot.marketplace.installs.models.compatibility.AgentSpecificUninstallableReason';
export const AgentSpecificUninstallableReasonDiscriminant = 'agent';
export const AgentSpecificUninstallableReasonDiscriminantKey = '@type';
export type AgentSpecificUninstallableReason = {
  missingAiAccessControls: Default<string[]>;
  __typename: 'com.hubspot.marketplace.installs.models.compatibility.AgentSpecificUninstallableReason';
} & { '@type'?: 'agent' };

export const AppSpecificUninstallableReasonTypename =
  'com.hubspot.marketplace.installs.models.compatibility.AppSpecificUninstallableReason';
export const AppSpecificUninstallableReasonDiscriminant = 'app';
export const AppSpecificUninstallableReasonDiscriminantKey = '@type';
export type AppSpecificUninstallableReason = {
  missingPortalScopeGroups: Default<string[]>;
  missingUserScopeGroups: Default<string[]>;
  incompatiblePortalInstalledApps: Default<number[]>;
  incompatibleUserInstalledApps: Default<number[]>;
  missingPortalInternalScopes: Default<Scope[][]>;
  missingUserInternalScopes: Default<Scope[][]>;
  __typename: 'com.hubspot.marketplace.installs.models.compatibility.AppSpecificUninstallableReason';
} & { '@type'?: 'app' };

export const AppSpecificUninstallableReasonV2Typename =
  'com.hubspot.marketplace.installs.models.compatibility.AppSpecificUninstallableReasonV2';
export const AppSpecificUninstallableReasonV2Discriminant = 'app';
export const AppSpecificUninstallableReasonV2DiscriminantKey = '@type';
export type AppSpecificUninstallableReasonV2 = {
  missingPortalScopeGroups: Default<string[]>;
  missingUserScopeGroups: Default<string[]>;
  incompatiblePortalInstalledAppIds: Default<number[]>;
  incompatibleUserInstalledAppIds: Default<number[]>;
  missingPortalInternalScopes: Default<string[][]>;
  missingUserInternalScopes: Default<string[][]>;
  sensitiveDataRequired: Default<boolean>;
  __typename: 'com.hubspot.marketplace.installs.models.compatibility.AppSpecificUninstallableReasonV2';
} & { '@type'?: 'app' };

export type FeatureCompatibility = {
  featureName: string;
  compatibleTiers: Default<Tier[]>;
};

export type InstallCompatibilityRequest = {
  listingId: number;
  published: boolean;
  listingLanguage?: string;
};

export type InstallCompatibilityResponse = {
  productInstallCompatibility: ProductInstallCompatibility;
};

export type InstallabilityRequest = {
  listingId: number;
  published: boolean;
  listingLanguage?: string;
};

export type InstallabilityResponse = {
  installed: boolean;
  installability: ProductInstallabilityV2;
  derivedMissingUserRoles?: string[];
};

export type ProductInstallCompatibility = {
  installed: boolean;
  installability: ProductInstallability;
  portalTiers: Default<Tier[]>;
  featureCompatibilities: Default<FeatureCompatibility[]>;
  missingUserRoles: Default<RoleName[]>;
};

export type ProductInstallability = {
  portalInstallable: boolean;
  userInstallable: boolean;
  uninstallableReason?: UninstallableReason;
};

export type ProductInstallabilityV2 = {
  portalInstallable: boolean;
  userInstallable: boolean;
  uninstallableReason?: UninstallableReasonV2;
};

export const ProductSpecificUninstallableReasonDiscriminantKey = '@type';
export type ProductSpecificUninstallableReason = AppSpecificUninstallableReason;

export const ProductSpecificUninstallableReasonV2DiscriminantKey = '@type';
export type ProductSpecificUninstallableReasonV2 =
  | AppSpecificUninstallableReasonV2
  | AgentSpecificUninstallableReason;

export type RequiredScopeGroupInSyncRequest = { listingVersionId: number };

export type RequiredScopeGroupInSyncResponse = { inSync: boolean };

export type RequiredScopeGroupRequest = { appId?: number; listingId?: number };

export type RequiredScopeGroupResponse = {
  scopeGroups: Default<ScopeGroupMessage[]>;
};

export type UninstallableReason = {
  missingPortalScopes: Default<Scope[]>;
  missingUserScopes: Default<Scope[]>;
  productSpecificUninstallableReason?: ProductSpecificUninstallableReason;
};

export type UninstallableReasonV2 = {
  missingPortalScopes: Default<string[]>;
  missingUserScopes: Default<string[]>;
  betaListingGate?: string;
  productSpecificUninstallableReason?: ProductSpecificUninstallableReasonV2;
};

export type RoleName =
  | 'ACADEMY_STUDIO_LMS_CONTENT_WRITER'
  | 'ACCESS_GROUPS_ACCESSOR'
  | 'ACCOUNT_DEFAULTS_SETTINGS_WRITE'
  | 'ADMIN_BASE'
  | 'ADS_PUBLISHER'
  | 'ADS_READ'
  | 'AEO_EDITOR_ACCESSOR'
  | 'ANALYTICS_SETTINGS_WRITE'
  | 'APOLLO_SALES_PRO_BUSINESS_USER'
  | 'APOLLO_SALES_PRO_POWER_USER'
  | 'APOLLO_SALES_PRO_ENTERPRISE'
  | 'APP_ACCESS'
  | 'AVAILABILITY_MANAGEMENT_WRITER'
  | 'AUDIENCES_EDITOR'
  | 'AUDIENCES_VIEWER'
  | 'BET_ACCESS_PROFILES_ASSIGNER'
  | 'BET_ACTIVITY_TYPE_SERVICE_CONSULTANTS_ACCESSOR'
  | 'BET_ACTIVITY_TYPE_NAM_CORP_SALES'
  | 'BET_ACTIVITY_TYPE_PARTNER_ACCESSOR'
  | 'BET_ALL_DOMAINS_ASSIGNER'
  | 'BET_ALL_DOMAINS_TO_ANY_USER_ASSIGNER'
  | 'BET_ASSIGN_TO_ME_ACCESSOR'
  | 'BET_ALL_DOMAINS_RECYCLER'
  | 'BET_ASSOCIATED_COMPANY_WRITER'
  | 'BET_BAD_FIT_MARKER'
  | 'BET_BDR_ACTIVITY_TYPE_LOGGER'
  | 'BET_BIZCO_UI_ACCESSOR'
  | 'BET_BOOK_IMA_ACCESSOR'
  | 'BET_CHANGE_DOMAIN_URL_ACCESSOR'
  | 'BET_CLEARBIT_ACTIVITY_TYPE_LOGGER'
  | 'BET_COMPANIES_CREATOR'
  | 'BET_COMPANIES_MERGE_ACCESSOR'
  | 'BET_CONVERT_CONTACT_SUPER_ACCESSOR'
  | 'BET_CONTRACT_CHANGE_FILTERS_ACCESSOR'
  | 'BET_CRM_CARDS'
  | 'BET_CRM_PRIVILEGED_USER'
  | 'BET_CUSTOM_DEAL_CREATOR'
  | 'BET_CUSTOMER_SUMMARY_ACCESSOR'
  | 'BET_DEAL_STAGE_MANAGER'
  | 'BET_DELIVERABLE_SERVICE_ASSOCIATION_ACCESSER'
  | 'BET_DOMAIN_OWNER_RECYCLER'
  | 'BET_ENRICH_DOMAIN_ACCESSOR'
  | 'BET_DOMAIN_CONTROLS'
  | 'BET_HUB_DECISION_MAKER'
  | 'BET_HUB_PRIMARY_POC'
  | 'BET_IBDR_ASSIGNER'
  | 'BET_IBDR_RECYCLER'
  | 'BET_IBDR_RECYCLER_ELEVATED'
  | 'BET_INTEGRATION_WRITER'
  | 'BET_INTERNAL_BOTS_ADMIN'
  | 'BET_INTERNAL_CONVERSATIONS_ADMIN'
  | 'BET_IQL_CREATOR'
  | 'BET_PARTNER_COLL_ACCESSOR'
  | 'BET_PARTNER_DOMAIN_ASSIGNER'
  | 'BET_PARTNER_SPECIALIST_OWNER_ASSIGNER'
  | 'BET_PARTNER_SPECIALIST_OWNER_TO_ALL_DOMAINS_ASSIGNER'
  | 'BET_PIN_DOMAIN_ACCESSOR'
  | 'BET_QL_REJECTER'
  | 'BET_RAISE_DISPUTE_DOMAIN_ACCESSOR'
  | 'BET_RECARVE_HOLDOVER_ACCESSOR'
  | 'BET_RESOLVE_DOMAIN_ACCESSOR'
  | 'BET_SALES_ENGINEER_ACTIVITY_TYPE_LOGGER'
  | 'BET_SERVICES_ENGINEER_ACTIVITY_TYPE_LOGGER'
  | 'BET_SINGLE_DELETE_ACCESS'
  | 'BET_SUCCESS_USER'
  | 'BET_VERIFY_DOMAIN_STATUS_ACCESSOR'
  | 'BET_VIEWS_PUBLIC_SHARE'
  | 'BILLING_WRITE'
  | 'BLOG_POSTS_APPROVER'
  | 'BLOG_PRIVATE_CONTENT_MANAGER'
  | 'BLOG_PUBLISHER_NEW'
  | 'BLOG_READ'
  | 'BLOG_WRITER'
  | 'BREEZE_AGENT_EDITOR'
  | 'CALLS_TO_ACTION_EDITOR'
  | 'CALLS_TO_ACTION_PUBLISHER'
  | 'CALLS_TO_ACTION_VIEWER'
  | 'CAMPAIGNS_READ'
  | 'CAMPAIGNS_WRITE'
  | 'CARTS_EDITOR'
  | 'CARTS_VIEWER'
  | 'CASE_STUDIES_EDITOR'
  | 'CASE_STUDIES_PUBLISHER'
  | 'CASE_STUDIES_VIEWER'
  | 'CASE_STUDY_ADMIN'
  | 'CASE_STUDY_READER'
  | 'CASE_STUDY_WRITER'
  | 'CHATFLOWS_MANAGER'
  | 'CHATSPOT_ACCESSOR'
  | 'CMS_ACCESS_GROUPS_WRITER'
  | 'COACHING_ACCESSOR'
  | 'COBJECT_ALL_EDITOR_1'
  | 'COBJECT_ALL_VIEWER_1'
  | 'COBJECT_OWNED_EDITOR_1'
  | 'COBJECT_TEAM_OWNED_EDITOR_1'
  | 'COBJECT_TEAM_OWNED_VIEWER_1'
  | 'COBJECT_UNASSIGNED_EDITOR_1'
  | 'COBJECT_UNASSIGNED_VIEWER_1'
  | 'COBJECT_ALL_DELETER_1'
  | 'COBJECT_TEAM_DELETER_1'
  | 'COBJECT_OWNED_DELETER_1'
  | 'COBJECT_UNASSIGNED_DELETER_1'
  | 'COMPANIES_ALL_VIEWER'
  | 'COMPANIES_TEAM_VIEWER'
  | 'COMPANIES_UNASSIGNED_VIEWER'
  | 'COMPANIES_ALL_EDITOR'
  | 'COMPANIES_OWNED_EDITOR'
  | 'COMPANIES_TEAM_EDITOR'
  | 'COMPANIES_UNASSIGNED_EDITOR'
  | 'COMPANIES_ALL_DELETER'
  | 'COMPANIES_OWNED_DELETER'
  | 'COMPANIES_TEAM_DELETER'
  | 'COMPANIES_UNASSIGNED_DELETER'
  | 'COMPANIES_ALL_COMMUNICATOR'
  | 'COMPANIES_OWNED_COMMUNICATOR'
  | 'COMPANIES_TEAM_COMMUNICATOR'
  | 'COMPANIES_UNASSIGNED_COMMUNICATOR'
  | 'COMPANIES_WRITER'
  | 'CONNECTED_EMAIL_INBOX_ACCESSOR'
  | 'CONNECTED_EMAIL_SENDER'
  | 'CONTACTS_ALL_COMMUNICATOR'
  | 'CONTACTS_BASE'
  | 'CONTACTS_EDIT_OWNED_ONLY'
  | 'CONTACTS_OWNED_ONLY_COMMUNICATOR'
  | 'CONTACTS_TEAM_COMMUNICATOR'
  | 'CONTACTS_ALL_DELETER'
  | 'CONTACTS_GDPR_DELETER'
  | 'CONTACTS_TEAM_DELETER'
  | 'CONTACTS_OWNED_DELETER'
  | 'CONTACTS_UNASSIGNED_DELETER'
  | 'CONTACTS_WRITER'
  | 'CONTACT_ASSIGNED_TASK_ACCESSOR'
  | 'CONTENT_EMBEDS_VIEWER'
  | 'CONTENT_EMBEDS_EDITOR'
  | 'CONTENT_EMBEDS_PUBLISHER'
  | 'CONTENT_REMIX_VIEWER'
  | 'CONTENT_REMIX_EDITOR'
  | 'CONTENT_STAGING'
  | 'CONTENT_TEAM_ASSIGNER'
  | 'CONVERSATIONS_BETA_STARTER'
  | 'CORE_SEATS'
  | 'CORE_SEAT_BASE'
  | 'CRM_ALL_EDITOR'
  | 'CRM_ALL_VIEWER'
  | 'CRM_ALL_DEAL_EDITOR'
  | 'CRM_ALL_DEAL_VIEWER'
  | 'CRM_ALL_TICKET_EDITOR'
  | 'CRM_ALL_TICKET_VIEWER'
  | 'CRM_ASSOCIATIONS_WRITE_ACCESSOR'
  | 'CRM_BULK_DELETER'
  | 'CRM_EDIT_OWNED_ONLY_DEALS'
  | 'CRM_EDIT_OWNED_ONLY_TICKETS'
  | 'CRM_EMAILS_ALL_VIEWER'
  | 'CRM_EMAILS_TEAM_VIEWER'
  | 'CRM_EMAILS_UNASSIGNED_VIEWER'
  | 'CRM_EMAILS_ALL_EDITOR'
  | 'CRM_EMAILS_OWNED_EDITOR'
  | 'CRM_EMAILS_TEAM_EDITOR'
  | 'CRM_EMAILS_UNASSIGNED_EDITOR'
  | 'CRM_EMAILS_ALL_DELETER'
  | 'CRM_EMAILS_OWNED_DELETER'
  | 'CRM_EMAILS_TEAM_DELETER'
  | 'CRM_EMAILS_UNASSIGNED_DELETER'
  | 'CRM_EVENTS_ACCEPTANCE_TEST'
  | 'CRM_EXPORTER'
  | 'CRM_FEATURES_USER'
  | 'CRM_IMPORTER'
  | 'CRM_IMPORT_ALL_DELETER'
  | 'CRM_IMPORT_ALL_EDITOR'
  | 'CRM_IMPORT_ALL_VIEWER'
  | 'CRM_IMPORT_OWNED_DELETER'
  | 'CRM_IMPORT_OWNED_EDITOR'
  | 'CRM_IMPORT_OWNED_VIEWER'
  | 'CRM_IMPORT_TEAM_OWNED_DELETER'
  | 'CRM_IMPORT_TEAM_OWNED_EDITOR'
  | 'CRM_IMPORT_TEAM_OWNED_VIEWER'
  | 'CRM_IMPORT_UNASSIGNED_DELETER'
  | 'CRM_IMPORT_UNASSIGNED_EDITOR'
  | 'CRM_IMPORT_UNASSIGNED_VIEWER'
  | 'CRM_PROPERTY_SETTINGS_EDITOR'
  | 'CRM_NOTES_ALL_VIEWER'
  | 'CRM_NOTES_TEAM_VIEWER'
  | 'CRM_NOTES_UNASSIGNED_VIEWER'
  | 'CRM_NOTES_ALL_EDITOR'
  | 'CRM_NOTES_OWNED_EDITOR'
  | 'CRM_NOTES_TEAM_EDITOR'
  | 'CRM_NOTES_UNASSIGNED_EDITOR'
  | 'CRM_NOTES_ALL_DELETER'
  | 'CRM_NOTES_OWNED_DELETER'
  | 'CRM_NOTES_TEAM_DELETER'
  | 'CRM_NOTES_UNASSIGNED_DELETER'
  | 'CRM_TEAM_OWNED_DEAL_EDITOR'
  | 'CRM_TEAM_OWNED_DEAL_VIEWER'
  | 'CRM_TEAM_OWNED_TICKET_EDITOR'
  | 'CRM_TEAM_OWNED_TICKET_VIEWER'
  | 'CRM_TEAM_OWNED_EDITOR'
  | 'CRM_TEAM_OWNED_VIEWER'
  | 'CRM_UNASSIGNED_DEAL_EDITOR'
  | 'CRM_UNASSIGNED_DEAL_VIEWER'
  | 'CRM_UNASSIGNED_TICKET_EDITOR'
  | 'CRM_UNASSIGNED_TICKET_VIEWER'
  | 'CRM_UNASSIGNED_EDITOR'
  | 'CRM_UNASSIGNED_VIEWER'
  | 'CRM_VIEWS_CREATE_ACCESSOR'
  | 'CRM_RECORD_CUSTOMIZATION_ACCESSOR'
  | 'CONNECTED_ACCOUNT_DATA_VIEWER'
  | 'MULTI_ACCOUNT_REPORTS_VIEWER_ACCESSOR'
  | 'CUSTOM_LINE_ITEM_WRITE'
  | 'CUSTOM_OBJECT_DELETER'
  | 'CUSTOM_OBJECT_WRITER'
  | 'CUSTOM_TRANSLATIONS_ACCESSOR'
  | 'CUSTOM_VIEWS_EDITOR'
  | 'CUSTOMER_AGENT_ACCESSOR'
  | 'CUSTOMER_PORTAL_CONFIG_WRITE'
  | 'CUSTOMER_SUCCESS_WORKSPACE_ACCESSOR'
  | 'DATA_AGENT_ACCESSOR'
  | 'DATA_COMMAND_CENTER_READER'
  | 'DATA_COMMAND_CENTER_WRITER'
  | 'DATA_ENRICHMENT_ACCESSOR'
  | 'DATA_MODEL_WRITER'
  | 'DEACTIVATED_USER'
  | 'DEALS_ALL_DELETER'
  | 'DEALS_TEAM_DELETER'
  | 'DEALS_OWNED_DELETER'
  | 'DEALS_UNASSIGNED_DELETER'
  | 'DEALS_APPROVER'
  | 'DEALS_WRITER'
  | 'DEVELOPER_ACCESS'
  | 'DEVELOPER_TOOLS_ACCESSOR'
  | 'DOCUMENTS_WRITE'
  | 'DOMAINS_SETTINGS_WRITE'
  | 'ELEVATED_JITA'
  | 'EMAIL_PUBLISHER_NEW'
  | 'EMAIL_WRITER'
  | 'EMAIL_READ'
  | 'FILE_MANAGER_DELETER'
  | 'FILE_MANAGER_EDITOR'
  | 'FILE_MANAGER_VIEWER'
  | 'FILE_MANAGER_WRITER'
  | 'FEEDBACK_SURVEYS_VIEWER'
  | 'FEEDBACK_SURVEYS_WRITER'
  | 'FLYWHEEL_RECENT_CONVERSIONS_CARD_ACCESSOR'
  | 'FLYWHEEL_TALKING_POINTS_CARD_ACCESSOR'
  | 'FORMS_PUBLISHER'
  | 'FORMS_WRITER'
  | 'FORMS_VIEWER'
  | 'FORMS_READER'
  | 'FORM_SUBMISSION_DELETER'
  | 'GLOBAL_CONTENT_WRITE_ACCESS'
  | 'GOALS_ALL_VIEWER'
  | 'GOALS_ALL_EDITOR'
  | 'GOALS_OWNED_VIEWER'
  | 'GOALS_OWNED_EDITOR'
  | 'GOALS_TEAM_VIEWER'
  | 'GOALS_TEAM_EDITOR'
  | 'GOALS_NONE_EDITOR'
  | 'GOAL_FORECAST_ALL_EDITOR'
  | 'GOAL_FORECAST_ALL_VIEWER'
  | 'GOAL_FORECAST_OWNED_EDITOR'
  | 'GOAL_FORECAST_TEAM_EDITOR'
  | 'GOAL_FORECAST_TEAM_VIEWER'
  | 'HELP_DESK_MACROS_WRITES_ACCESSOR'
  | 'HIDE_INSIDER_INFO'
  | 'HUBDB_MANAGER'
  | 'HUBDB_PUBLISHER'
  | 'HUBDB_READER'
  | 'HUBDB_WRITER'
  | 'HSOC_CORE_SALES_SERVICE'
  | 'HUBSPOTTER_BOTS_USER'
  | 'HUBSPOTTER_SALES_PRO_USER'
  | 'INBOUNDDB_PRODUCT_LIBRARY_WRITE'
  | 'INTEGRATIONS_MANAGEMENT'
  | 'INTEGRATIONS_MANAGEMENT_UNINSTALL_ACCESSOR'
  | 'INVOICES_EDITOR'
  | 'INVOICES_VIEWER'
  | 'JITA'
  | 'JOURNEYS_VIEWER'
  | 'JOURNEYS_EDITOR'
  | 'JOURNEYS_CREATOR'
  | 'JOURNEYS_DELETER'
  | 'JOURNEYS_PUBLISHER'
  | 'KNOWLEDGE_BASE_PRIVATE_CONTENT_MANAGER'
  | 'KNOWLEDGE_CATEGORY_EDITOR'
  | 'LANDING_PAGES_APPROVER'
  | 'LANDINGPAGES_READ'
  | 'LANDINGPAGES_PRIVATE_CONTENT_MANAGER'
  | 'LANDING_PAGES_PUBLISHER'
  | 'LANDING_PAGES_WRITER'
  | 'LEADS_ALL_EDITOR'
  | 'LEADS_ALL_VIEWER'
  | 'LEADS_ALL_DELETER'
  | 'LEADS_TEAM_EDITOR'
  | 'LEADS_TEAM_VIEWER'
  | 'LEADS_OWNED_EDITOR'
  | 'LEADS_TEAM_DELETER'
  | 'LEADS_OWNED_DELETER'
  | 'LEADS_UNASSIGNED_EDITOR'
  | 'LEADS_UNASSIGNED_VIEWER'
  | 'LEADS_UNASSIGNED_DELETER'
  | 'LEADIN_ADMINISTRATOR'
  | 'LISTS_ACCESS'
  | 'LISTS_VIEWER'
  | 'MANAGE_SEQUENCES_LIBRARY_ACCESSOR'
  | 'MARKETABLE_CONTACTS_WRITE'
  | 'MARKETING_BASE'
  | 'MARKETING_EMAILS_APPROVER'
  | 'MARKETING_REPORTING_ACCESS'
  | 'MARKETING_SETTINGS_WRITE'
  | 'MARKETING_TEMPLATES'
  | 'MARKETING_EVENTS_WRITER'
  | 'MARKETPLACE_ASSET_ACCESS'
  | 'MARKETS_EDIT'
  | 'MEETING_CREATION_ACCESSOR'
  | 'MH_LEAD_SCORING_VIEWER'
  | 'MH_LEAD_SCORING_EDITOR'
  | 'MIGRATION_TECH'
  | 'ORDER_EDITOR'
  | 'ORDER_VIEWER'
  | 'ORDERS_ALL_VIEWER'
  | 'ORDERS_TEAM_VIEWER'
  | 'ORDERS_UNASSIGNED_VIEWER'
  | 'ORDERS_ALL_EDITOR'
  | 'ORDERS_TEAM_EDITOR'
  | 'ORDERS_OWNED_EDITOR'
  | 'ORDERS_UNASSIGNED_EDITOR'
  | 'ORDERS_ALL_DELETER'
  | 'ORDERS_TEAM_DELETER'
  | 'ORDERS_OWNED_DELETER'
  | 'ORDERS_UNASSIGNED_DELETER'
  | 'PAGES_READ'
  | 'PAGES_PRIVATE_CONTENT_MANAGER'
  | 'PAGE_PUBLISHER'
  | 'PAGE_WRITER'
  | 'PARTNER_ADMIN'
  | 'PARTNER_EMPLOYEE'
  | 'PARTNER_BASE'
  | 'PARTNER_BIGLYTICS_READ'
  | 'PARTNER_BIGLYTICS_WRITE'
  | 'PARTNER_CLIENT_OBJECT_READ'
  | 'PARTNER_CLIENT_OBJECT_WRITE'
  | 'PARTNER_CLIENT_OBJECT_EDITOR'
  | 'PARTNER_CLIENT_OBJECT_VIEWER'
  | 'PARTNER_ADMIN_USER_MANAGEMENT'
  | 'PARTNER_DASHBOARD_READ'
  | 'PARTNER_DASHBOARD_WRITE'
  | 'PARTNER_DIRECTORY_WRITE'
  | 'PARTNER_COMMISSION_ACCESSOR'
  | 'PARTNER_EMPLOYEES_ADMIN_READ'
  | 'PARTNER_EMPLOYEES_ADMIN_WRITE'
  | 'PARTNER_SALES_HUB_USER'
  | 'PARTNER_SALES_PRO'
  | 'PARTNER_SERVICE_HUB_USER'
  | 'PARTNER_SERVICE_OBJECT_VIEWER'
  | 'PARTNER_SERVICE_OBJECT_EDITOR'
  | 'PARTNER_COMMERCE_HUB_USER'
  | 'PAYMENT_LINKS_MANAGER'
  | 'PAYMENTS_MANAGER'
  | 'PERMISSIONS_TESTING_OWNED_VIEWER'
  | 'PERMISSIONS_TESTING_TEAM_VIEWER'
  | 'PERMISSIONS_TESTING_UNASSIGNED_VIEWER'
  | 'PERMISSIONS_TESTING_ALL_VIEWER'
  | 'PERMISSIONS_TESTING_OWNED_EDITOR'
  | 'PERMISSIONS_TESTING_TEAM_EDITOR'
  | 'PERMISSIONS_TESTING_UNASSIGNED_EDITOR'
  | 'PERMISSIONS_TESTING_ALL_EDITOR'
  | 'PERMISSIONS_TESTING_OWNED_DELETER'
  | 'PERMISSIONS_TESTING_TEAM_DELETER'
  | 'PERMISSIONS_TESTING_UNASSIGNED_DELETER'
  | 'PERMISSIONS_TESTING_ALL_DELETER'
  | 'PERSONALIZE_EDITOR'
  | 'PERSONALIZE_VIEWER'
  | 'PLAYBOOKS_MANAGER'
  | 'PLAYBOOKS_PUBLISHER'
  | 'PLAYBOOKS_WRITER'
  | 'PLAYBOOKS_READ'
  | 'PODCASTS_EDITOR'
  | 'PODCASTS_PUBLISHER'
  | 'PODCASTS_VIEWER'
  | 'PRESETS_EDITOR'
  | 'PRIVATE_APPS_DEVELOPER'
  | 'PROCESS_GUIDES_ACCESSOR'
  | 'PROCESS_GUIDES_EDITOR'
  | 'PROCESS_GUIDES_VIEWER'
  | 'PRODUCT_LIBRARY_ALL_DELETER'
  | 'PRODUCT_LIBRARY_ALL_EDITOR'
  | 'PRODUCT_LIBRARY_ALL_VIEWER'
  | 'PROJECTS_ALL_DELETER'
  | 'PROJECTS_ALL_EDITOR'
  | 'PROJECTS_ALL_VIEWER'
  | 'PROJECTS_OWNED_DELETER'
  | 'PROJECTS_OWNED_EDITOR'
  | 'PROJECTS_TEAM_DELETER'
  | 'PROJECTS_TEAM_EDITOR'
  | 'PROJECTS_TEAM_VIEWER'
  | 'PROJECTS_UNASSIGNED_DELETER'
  | 'PROJECTS_UNASSIGNED_EDITOR'
  | 'PROJECTS_UNASSIGNED_VIEWER'
  | 'PROSPECTING_AGENT_ACCESSOR'
  | 'PROSPECTING_AGENT_ADMIN_ACCESSOR'
  | 'PROSPECTING_AGENT_WRITE_ACCESSOR'
  | 'PROSPECTING_WORKSPACE_AS_OTHER_VIEW_ACCESSOR'
  | 'QUOTES_APPROVER'
  | 'QUOTE_APPROVER'
  | 'QUOTE_TEMPLATE_EDITOR'
  | 'QUOTE_WRITER'
  | 'READ_ONLY_JITA'
  | 'READ_WRITE_JITA'
  | 'REPLATFORMING_SPECIALIST'
  | 'REPORTING_ADMINISTRATOR'
  | 'REPORTING_BASE'
  | 'REPORTING_EDIT'
  | 'REPORTING_CREATE_AND_OWN'
  | 'REPORTING_DATASETS_READER'
  | 'REPORTING_DATASETS_SYNCER'
  | 'REPORTING_DATASETS_WRITER'
  | 'RESTRICTED_ELEVATED_JITA'
  | 'RESTRICTED_READ_ONLY_JITA'
  | 'RESTRICTED_READ_WRITE_JITA'
  | 'RESTRICTED_ELEVATED_JITA_BETA'
  | 'RESTRICTED_READ_ONLY_JITA_BETA'
  | 'RESTRICTED_READ_WRITE_JITA_BETA'
  | 'SALES_ALL_EDITOR'
  | 'SALES_ALL_VIEWER'
  | 'SALES_BASE'
  | 'SALES_BULK_DELETER'
  | 'SALES_EXPORTER'
  | 'SALES_IMPORTER'
  | 'SALES_PROPERTY_SETTINGS_EDITOR'
  | 'SALES_PRO_BUSINESS_USER'
  | 'SALES_PRO_POWER_USER'
  | 'SALES_PRO'
  | 'SALES_ENTERPRISE'
  | 'SALES_HELP_DESK_SENDER'
  | 'SALES_SETTINGS_WRITE'
  | 'SALES_STARTER'
  | 'SALES_TEMPLATES_WRITE'
  | 'SALES_UNASSIGNED_EDITOR'
  | 'SALES_UNASSIGNED_VIEWER'
  | 'SALES_USER'
  | 'SALESFORCE_ADMIN'
  | 'SALESFORCE_CAMPAIGN_IMPORTER'
  | 'SALESFORCE_IMPORTER'
  | 'SECURITY_ADMIN_ACCESSOR'
  | 'SEQUENCES_BULK_ENROLL_WRITE'
  | 'SEQUENCES_ENROLL_ON_BEHALF_ACCESSOR'
  | 'SEQUENCES_WRITE'
  | 'SEQUENCES_EDITOR'
  | 'SEQUENCES_VIEWER'
  | 'SEQUENCES_DELETER'
  | 'SERVICE_BASE'
  | 'SERVICE_STARTER'
  | 'SERVICE_PROFESSIONAL'
  | 'SERVICE_ENTERPRISE'
  | 'SERVICE_FEEDBACK_SURVEY_WRITER'
  | 'SERVICE_KNOWLEDGE_ADMINISTRATOR'
  | 'SERVICE_KNOWLEDGE_PUBLISHER'
  | 'SERVICE_KNOWLEDGE_WRITER'
  | 'SH_LEAD_SCORING_EDITOR'
  | 'SH_LEAD_SCORING_VIEWER'
  | 'SMS_VIEWER'
  | 'SMS_EDITOR'
  | 'SMS_PUBLISHER'
  | 'SMS_SETTINGS_MANAGER_ACCESSOR'
  | 'SOCIAL_DRAFT_ONLY'
  | 'SOCIAL_PUBLISH_ALL'
  | 'SOCIAL_PUBLISH_OWNED'
  | 'SOCIAL_BROADCAST_APPROVER'
  | 'SOCIAL_VIEWER'
  | 'SOCIAL_EDITOR'
  | 'SOCIAL_PUBLISHER'
  | 'SUBSCRIPTION_TYPE_EDIT_ALL_ACCESSOR'
  | 'SUPER_ADMIN'
  | 'TALLY_ACCESS'
  | 'TASKS_ALL_EDITOR'
  | 'TASKS_TEAM_EDITOR'
  | 'TASKS_UNASSIGNED_EDITOR'
  | 'TASKS_OWNED_EDITOR'
  | 'TASKS_ALL_DELETER'
  | 'TASKS_TEAM_DELETER'
  | 'TASKS_UNASSIGNED_DELETER'
  | 'TASKS_OWNED_DELETER'
  | 'TASKS_ALL_VIEWER'
  | 'TASKS_TEAM_VIEWER'
  | 'TASKS_UNASSIGNED_VIEWER'
  | 'TICKETS_ALL_DELETER'
  | 'TICKETS_TEAM_DELETER'
  | 'TICKETS_OWNED_DELETER'
  | 'TICKETS_UNASSIGNED_DELETER'
  | 'TICKETS_WRITER'
  | 'TEAMS_WRITE'
  | 'UNASSIGNED_OR_UNKNOWN_COMMUNICATOR'
  | 'URL_REDIRECTS_PUBLISHER'
  | 'URL_REDIRECTS_READER'
  | 'USER_AUDITS_ACCESSOR'
  | 'USERS_WRITE'
  | 'USER_PERMISSION_PAGE_VIEW'
  | 'WEBSITE_THEME_WRITE_ACCESS'
  | 'WEBSITE_PAGE_APPROVER'
  | 'WHATSAPP_VIEWER'
  | 'WHATSAPP_EDITOR'
  | 'WHATSAPP_PUBLISHER'
  | 'WHATSAPP_SETTINGS_MANAGER_ACCESSOR'
  | 'WORK_ACCESS'
  | 'WORK_EDITOR'
  | 'WORK_WORKSPACES_WRITER'
  | 'WORKFORCE_MANAGEMENT_SETTINGS_EDITOR'
  | 'WORKFORCE_MANAGEMENT_SETTINGS_VIEWER'
  | 'WORKFLOWS'
  | 'WORKFLOWS_DELETE_ALL'
  | 'WORKFLOWS_DELETE_TEAM_OWNED'
  | 'WORKFLOWS_EDIT_ALL'
  | 'WORKFLOWS_EDIT_TEAM_OWNED'
  | 'WORKFLOWS_MANUAL_ENROLL_TEAM_OWNED_ACCESSOR'
  | 'WORKFLOWS_PUBLISH_TEAM_OWNED_ACCESSOR'
  | 'KNOWLEDGE_ARTICLES_APPROVER'
  | 'CONVERSATIONS_AI_CHATBOT_USER'
  | 'MEETINGS_ALL_VIEWER'
  | 'MEETINGS_TEAM_VIEWER'
  | 'MEETINGS_UNASSIGNED_VIEWER'
  | 'CALLS_ALL_VIEWER'
  | 'CALLS_TEAM_VIEWER'
  | 'CALLS_UNASSIGNED_VIEWER'
  | 'COMMUNICATIONS_ALL_VIEWER'
  | 'COMMUNICATIONS_TEAM_VIEWER'
  | 'COMMUNICATIONS_UNASSIGNED_VIEWER'
  | 'JOURNEY_ACCESSOR'
  | 'CRM_EXPORTS_APPROVER'
  | 'CRM_EXPORTER_WITHOUT_APPROVAL'
  | 'CRM_COURSES_UNASSIGNED_VIEWER'
  | 'CRM_COURSES_ALL_VIEWER'
  | 'CRM_COURSES_OWNED_EDITOR'
  | 'CRM_COURSES_UNASSIGNED_EDITOR'
  | 'CRM_COURSES_UNASSIGNED_DELETER'
  | 'CRM_COURSES_ALL_DELETER'
  | 'CRM_COURSES_TEAM_EDITOR'
  | 'CRM_COURSES_ALL_EDITOR'
  | 'CRM_COURSES_OWNED_DELETER'
  | 'CRM_COURSES_TEAM_DELETER'
  | 'CRM_COURSES_TEAM_VIEWER'
  | 'CRM_SERVICES_ALL_DELETER'
  | 'CRM_SERVICES_ALL_VIEWER'
  | 'CRM_SERVICES_UNASSIGNED_VIEWER'
  | 'CRM_SERVICES_TEAM_EDITOR'
  | 'CRM_SERVICES_UNASSIGNED_EDITOR'
  | 'CRM_SERVICES_ALL_EDITOR'
  | 'CRM_SERVICES_TEAM_DELETER'
  | 'CRM_SERVICES_OWNED_DELETER'
  | 'CRM_SERVICES_TEAM_VIEWER'
  | 'CRM_SERVICES_OWNED_EDITOR'
  | 'CRM_SERVICES_UNASSIGNED_DELETER'
  | 'CRM_LISTINGS_ALL_VIEWER'
  | 'CRM_LISTINGS_TEAM_DELETER'
  | 'CRM_LISTINGS_ALL_DELETER'
  | 'CRM_LISTINGS_OWNED_EDITOR'
  | 'CRM_LISTINGS_TEAM_EDITOR'
  | 'CRM_LISTINGS_UNASSIGNED_EDITOR'
  | 'CRM_LISTINGS_UNASSIGNED_DELETER'
  | 'CRM_LISTINGS_OWNED_DELETER'
  | 'CRM_LISTINGS_TEAM_VIEWER'
  | 'CRM_LISTINGS_UNASSIGNED_VIEWER'
  | 'CRM_LISTINGS_ALL_EDITOR'
  | 'CRM_APPOINTMENTS_ALL_DELETER'
  | 'CRM_APPOINTMENTS_ALL_VIEWER'
  | 'CRM_APPOINTMENTS_OWNED_DELETER'
  | 'CRM_APPOINTMENTS_OWNED_EDITOR'
  | 'CRM_APPOINTMENTS_UNASSIGNED_DELETER'
  | 'CRM_APPOINTMENTS_UNASSIGNED_EDITOR'
  | 'CRM_APPOINTMENTS_ALL_EDITOR'
  | 'CRM_APPOINTMENTS_TEAM_EDITOR'
  | 'CRM_APPOINTMENTS_UNASSIGNED_VIEWER'
  | 'CRM_APPOINTMENTS_TEAM_DELETER'
  | 'CRM_APPOINTMENTS_TEAM_VIEWER'
  | 'SCOPE_IMPACT_TEST_ROLE_1'
  | 'SCOPE_IMPACT_TEST_ROLE_2A'
  | 'SCOPE_IMPACT_TEST_ROLE_2B'
  | 'SCOPE_IMPACT_TEST_ROLE_3'
  | 'SCOPE_IMPACT_TEST_ROLE_4'
  | 'CUSTOM_EVENTS_VIEWER'
  | 'CUSTOM_EVENTS_EDITOR'
  | 'CUSTOM_EVENTS_DELETER'
  | 'MAM_VIRTUAL_USER'
  | 'MAM_REPORTS_VIRTUAL_USER'
  | 'BUYER_INTENT_ACCESSOR'
  | 'BUYER_INTENT_EDITOR'
  | 'BUYER_INTENT_VIEWER'
  | 'APP_SERVICE_ACCOUNT_USER'
  | 'COMMERCE_SUBSCRIPTIONS_VIEWER'
  | 'COMMERCE_SUBSCRIPTIONS_EDITOR'
  | 'COMMERCE_SUBSCRIPTIONS_DELETER'
  | 'CS_REP'
  | 'INVOICES_ALL_EDITOR'
  | 'INVOICES_ALL_VIEWER'
  | 'INVOICES_ALL_DELETER'
  | 'INVOICES_TEAM_EDITOR'
  | 'INVOICES_TEAM_VIEWER'
  | 'INVOICES_TEAM_DELETER'
  | 'INVOICES_OWNED_EDITOR'
  | 'INVOICES_OWNED_DELETER'
  | 'INVOICES_UNASSIGNED_EDITOR'
  | 'INVOICES_UNASSIGNED_VIEWER'
  | 'INVOICES_UNASSIGNED_DELETER'
  | 'CREDIT_MEMOS_VIEWER'
  | 'CREDIT_MEMOS_EDITOR'
  | 'CONTRACTS_WRITER'
  | 'WAITLIST_WRITER'
  | 'COMMERCE_BASE'
  | 'COMMERCE_ENTERPRISE'
  | 'COMMERCE_PROFESSIONAL'
  | 'DEAL_PLAN_ACCESSOR'
  | 'MILESTONES_READER'
  | 'MILESTONES_WRITER'
  | unhandledEnumCase;

export type Scope =
  | 'ABM_REPORTS_ACCESS'
  | 'ABM_TARGET_ACCOUNT_OVERVIEW_ACCESS'
  | 'ABM_TARGET_ACCOUNTS_INDEX_ACCESS'
  | 'ABM_WORKFLOW_TEMPLATES_ACCESS'
  | 'ABUSEHUB_ACCOUNT_VERIFICATIONS_WRITE'
  | 'ABUSEHUB_ESCALATED_CASE_REVIEW_WRITE'
  | 'ABUSEHUB_READ'
  | 'ABUSEHUB_USERS_WRITE'
  | 'ABUSIVE_IMPORTS_WRITE'
  | 'ACCOUNT_COMPROMISE_WRITE'
  | 'ACADEMY_ADMIN_CONTENT_MANAGEMENT'
  | 'ACADEMY_ADMIN_CONTENT_MANAGEMENT_BATCH_TRANSLATIONS'
  | 'ACADEMY_ADMIN_GRADING_EXERCISES'
  | 'ACADEMY_ADMIN_VISIBILITY'
  | 'ACADEMY_CONTENT_MANAGEMENT'
  | 'ACADEMY_CONTENT_MANAGEMENT_BATCH_TRANSLATIONS'
  | 'ACADEMY_CONTENT_MANAGER_ACCESS'
  | 'ACADEMY_LAB_PORTAL_PROVISIONING_ACCESS'
  | 'ACADEMY_PARTNER_TRAINING_ACCESS'
  | 'ACADEMY_PLAYLIST_GLOBAL_ASSIGNMENT'
  | 'ACADEMY_STUDIO_CONTENT_MANAGEMENT'
  | 'ACADEMY_STUDIO_CONTENT_MANAGEMENT_ADVANCED'
  | 'ACADEMY_STUDIO_CONTENT_SEO'
  | 'ACADEMY_STUDIO_PUBLISH'
  | 'ACCOUNT_DEFAULTS_SETTINGS_READ'
  | 'ACCOUNT_DEFAULTS_SETTINGS_WRITE'
  | 'ACCOUNT_MAPS_READ'
  | 'ACCOUNT_MAPS_WRITE'
  | 'ACCOUNT_TAKEDOWN_WRITE'
  | 'ACCOUNTING_EXTENSION_READ'
  | 'ACCOUNTING_EXTENSION_WRITE'
  | 'ACTIONS_ACCESS'
  | 'ACTIVITY_FEED_ACCESS'
  | 'ACTIVITY_FEED_UNLIMITED_ACTIVITIES'
  | 'ADD_LINE_ITEM_FROM_LIBRARY'
  | 'ADD_PROPERTY_CARD_ACCESS'
  | 'ADD_PROPERTY_VIEW_ACCESS'
  | 'ADDONS_RO'
  | 'ADDONS_RW'
  | 'ADMIN_BASE_ACCESS'
  | 'ADMIN_ONLY_SENSITIVE_DATA_SETTINGS_CONTROL_SCOPE'
  | 'ADS_ACCESS'
  | 'ADS_ADV_WEB_AUDIENCES'
  | 'ADS_DEMO_ACCESS'
  | 'ADS_FREE'
  | 'ADS_MULTI_ATTRIBUTION'
  | 'ADS_PRO'
  | 'ADS_READ'
  | 'ADS_ROI_REPORTING'
  | 'ADS_TRUSTED'
  | 'ADS_WRITE'
  | 'ADVANCED_DEAL_SCORE'
  | 'ADVANCED_REPORT_BUILDER_ACCESS'
  | 'ADVANCED_SALES_GOAL_ASSIGNMENT'
  | 'ADVANCED_SALES_GOAL_MANAGER'
  | 'ADVANCED_SERVICE_GOAL_MANAGER'
  | 'ADVANCED_SERVICES_GOAL_ASSIGNMENT'
  | 'ADYEN_READ'
  | 'AI_EMAIL_ENRICHMENT_ADMIN'
  | 'AI_EMAIL_ENRICHMENT_REPORT'
  | 'AI_BLOG_POST_GENERATOR_CUSTOM_FEATURES'
  | 'ALLOW_EXCEPTIONAL_JITA'
  | 'ALL_DEFAULT_MODULES_AVAILABLE'
  | 'ALL_SUBSIDIARY_ACCESS'
  | 'ANALYTICS_FILTERS_API_ACCESS'
  | 'ANALYTICS_FILTERS_READ'
  | 'ANALYTICS_FILTERS_WRITE'
  | 'ANALYTICS_FILTERS_WRITE_USERS'
  | 'ANALYTICS_REPORTS_ACCESS'
  | 'ANALYTICS_SETTINGS_READ'
  | 'ANALYTICS_SETTINGS_WRITE'
  | 'ANALYTICS_ACTIVITY_SPAWN_WRITE'
  | 'API_ELIGIBLE'
  | 'API_KEY_TOOLS_READ'
  | 'APOLLO_BILLING_CANCEL'
  | 'APOLLO_BILLING_CANCEL_COMMITMENT_DATE'
  | 'APOLLO_BILLING_CANCEL_DUE_TO_NON_PAYMENT'
  | 'APOLLO_BILLING_CANCEL_PENDING_INVOICE_WRITE_OFF'
  | 'APOLLO_BILLING_CANCEL_SPECIFIC_DATE'
  | 'APOLLO_BILLING_CHANGE_CONTRACT_OWNER'
  | 'APOLLO_BILLING_CONTACTS'
  | 'APOLLO_BILLING_CREATE_CURRENCY_CHANGE'
  | 'APOLLO_BILLING_CREATE_IIA'
  | 'APOLLO_BILLING_CREATE_IIA_NON_WRITE_OFF'
  | 'APOLLO_BILLING_CREATE_IIA_WRITE_OFF'
  | 'APOLLO_BILLING_CREDIT_BALANCE_REFUND'
  | 'APOLLO_BILLING_CUSTOMER_DOCUMENTS_UPLOAD'
  | 'APOLLO_BILLING_DELINQUENCY_IGNORE'
  | 'APOLLO_BILLING_EDIT_MEMOS'
  | 'APOLLO_BILLING_EDIT_NOTES'
  | 'APOLLO_BILLING_INVOICE_ATTRIBUTES_EDIT'
  | 'APOLLO_BILLING_INVOICE_PAYMENT'
  | 'APOLLO_BILLING_INVOICE_PO_NUMBER_EDIT'
  | 'APOLLO_BILLING_INVOICE_REGENERATE'
  | 'APOLLO_BILLING_PAYMENT_REFUND'
  | 'APOLLO_BILLING_PORTAL_SWAP'
  | 'APOLLO_BILLING_SUBSCRIPTION_PO_NUMBER_EDIT'
  | 'APOLLO_BILLING_UNDING'
  | 'APOLLO_BILLING_VAT_NUMBER'
  | 'APOLLO_BILLING_STANDALONE_PAYMENTS'
  | 'APOLLO_QUOTES_AUTOMATION_RULE_ADMIN'
  | 'APOLLO_QUOTES_LEGACY_PRODUCT_MANAGEMENT'
  | 'APOLLO_QUOTES_MARKETING_ACCESS'
  | 'APOLLO_QUOTES_MARKETING_MANAGEMENT'
  | 'APOLLO_QUOTES_SERVICES_MANAGEMENT'
  | 'APOLLO_QUOTES_SUPER_USER'
  | 'APOLLO_QUOTES_VALIDATION_RULE_ADMIN'
  | 'APP_USER_AUDITS_READ'
  | 'APPROVALS_ADMIN'
  | 'ASSET_MARKETPLACE_LAYOUT_ACCESS'
  | 'ASSET_VERSION_WRITE'
  | 'ASSET_VERSION_TESTING'
  | 'ASSIGNMENT_BULK_ACTIONS_ACCESS'
  | 'ASSIGNMENTACTIONS_WRITE'
  | 'ASSOCIATED_CONTACTS_ACCESS'
  | 'ASSOCIATION_AUTOMATION_ACCESS'
  | 'ASSOCIATIONS_INTERNAL_WRITE'
  | 'ATLAS_53_USERS_WRITE'
  | 'ATLAS_ADMIN'
  | 'ATTRIBUTION_REPORTS_PRO_ACCESS'
  | 'ATTRIBUTION_REPORTS_ENTERPRISE_ACCESS'
  | 'AUDIENCE_TARGETING_ADVANCED_RULES'
  | 'AUDIENCE_TARGETING_ESSENTIAL_RULES'
  | 'AUDIENCES_READ'
  | 'AUDIENCES_WRITE'
  | 'AUTOMATION_ACCESS'
  | 'AUTOMATION_JOURNEYS_ACCESS'
  | 'AUTOMATION_OVERVIEW_ACCESS'
  | 'AUTOMATION_RO'
  | 'AUTOMATION_RW'
  | 'AVAILABILITY_MANAGEMENT_WRITE'
  | 'AVAILABLE_CREDIT_READ'
  | 'AVALARA_READ'
  | 'AVATARS_SIGNED_URI_ACCESS'
  | 'AVATARS_WRITE'
  | 'AVOID_INSIDER_INFO'
  | 'BASIC_SALES_GOAL_MANAGER'
  | 'BEAM_API_CUSTOM_FILTER_APPROVAL'
  | 'BEAM_READ'
  | 'BEHAVIORAL_EVENTS_EXTERNAL_API'
  | 'BEHAVIORAL_EVENTS_INGESTION'
  | 'BEHAVIORAL_EVENTS_READ'
  | 'BEHAVIORAL_EVENTS_WRITE'
  | 'BET_ADD_MARKETING_SALES_OWNER'
  | 'BET_ADD_MARKETING_SALES_OWNER_WHEN_NOT_OWNER'
  | 'BET_ADD_PARTNER_SPECIALIST_OWNER'
  | 'BET_ALERTS_BULK_ASSIGN'
  | 'BET_ALERTS_MANAGEMENT'
  | 'BET_ALERTS_READ'
  | 'BET_ALERTS_WRITE'
  | 'BET_ACCESS_PROFILES_ADMIN'
  | 'BET_ACCESS_PROFILES_REASSIGNMENT'
  | 'BET_ACTIVITY_TYPE_PARTNER_REP'
  | 'BET_ACTIVITY_TYPES_CLEARBIT'
  | 'BET_ACTIVITY_TYPES_CUSTOMER_SUCCESS'
  | 'BET_ACTIVITY_TYPES_CUSTOMER_SUPPORT'
  | 'BET_ACTIVITY_TYPES_INBOUND_SUCCESS'
  | 'BET_ACTIVITY_TYPES_INTERNAL_SOLUTIONS_ENGINEERS'
  | 'BET_ACTIVITY_TYPES_NAM_CORP_SALES'
  | 'BET_ACTIVITY_TYPES_RENEWAL_MANAGER'
  | 'BET_ACTIVITY_TYPES_SALES_ENGINEER'
  | 'BET_ACTIVITY_TYPES_SALES_SPECIALIST'
  | 'BET_ACTIVITY_TYPES_SERVICE_CONSULTANTS'
  | 'BET_ACTIVITY_TYPES_SERVICES_ENGINEER'
  | 'BET_ACTIVITY_TYPES_SOLUTIONS_ARCHITECT'
  | 'BET_ASSIGN_ALL_DOMAINS'
  | 'BET_ASSIGN_ALL_DOMAINS_TO_ANY_USER'
  | 'BET_ASSIGN_IBDR_OWNER'
  | 'BET_ASSIGN_PARTNER_SPECIALIST_OWNER'
  | 'BET_ASSIGN_PARTNER_SPECIALIST_OWNER_TO_ALL_DOMAINS'
  | 'BET_ASSIGN_TO_ME_ACCESS'
  | 'BET_ASSIGNMENT_RULES_READ'
  | 'BET_ASSIGNMENT_RULES_WRITE'
  | 'BET_ASSIGNMENT_WHEN_NOT_OWNER'
  | 'BET_BDR_LOG_ACTIVITY_CALL_DETAILS'
  | 'BET_BOOK_IMA_ACCESS'
  | 'BET_BYPASS_DEAL_STAGE_RESTRICTIONS'
  | 'BET_CHANGE_ASSOCIATED_COMPANY'
  | 'BET_CHANGE_DOMAIN_URL_ACCESS'
  | 'BET_CHANGE_MANAGEMENT_READ'
  | 'BET_CHANGE_MANAGEMENT_WRITE'
  | 'BET_COMPANIES_CREATE'
  | 'BET_COMPANIES_MERGE_ACCESS'
  | 'BET_COMPANY_GROUPING_VIEW'
  | 'BET_COMPANY_GROUPING_WRITER'
  | 'BET_CONTACT_SUMMARY_ACCESS'
  | 'BET_CONTROLLED_JITA_ACCESS'
  | 'BET_CONVERT_CONTACT_SUPER_ACCESS'
  | 'BET_CRM_BYPASS_VALIDATION'
  | 'BET_CRM_CARDS'
  | 'BET_CRM_CONNECTOR_READ'
  | 'BET_CRM_CONNECTOR_WRITE'
  | 'BET_CUSTOM_DEAL_FORM'
  | 'BET_CUSTOMER_SUCCESS_CARD_VIEW'
  | 'BET_CUSTOMER_SUMMARY_ACCESS'
  | 'BET_CUSTOMER_SUMMARY_CARD_VIEW'
  | 'BET_DEAL_SUPPORT_REQUESTS_PRESALES_MANAGER'
  | 'BET_DEAL_SUPPORT_REQUESTS_PRESALES_REP'
  | 'BET_DEAL_SUPPORT_REQUESTS_SALES_MANAGER'
  | 'BET_DEAL_SUPPORT_REQUESTS_SALES_REP'
  | 'BET_DEAL_SUPPORT_REQUESTS_SIDEBAR_CARD'
  | 'BET_DELIVERABLE_SERVICE_ASSOCIATION_ACCESS'
  | 'BET_DOMAIN_CONTROLS_ACCESS'
  | 'BET_DOMAIN_CONTROLS_BIZCO_UI'
  | 'BET_DOMAIN_EXCEPTIONS_ADVANCED_EDITOR'
  | 'BET_DOMAIN_EXCEPTIONS_EDITOR'
  | 'BET_DOMAIN_OWNER_RECYCLE_ACCESS'
  | 'BET_EMAIL_1_TO_1_SUBSCRIPTION_REQUEST_SEND'
  | 'BET_ENFORCE_DEAL_STAGE_RESTRICTIONS'
  | 'BET_ENRICH_DOMAIN_ACCESS'
  | 'BET_GROUPED_COMPANIES_READ'
  | 'BET_HAS_INTEGRATIONS_RESTRICTIONS'
  | 'BET_HIDE_LEAD_STAGE_TRACKER_CARD'
  | 'BET_HIDE_POPULATED_STAGE_CHANGE_PROPERTIES'
  | 'BET_HIDE_PRODUCTS_CARD'
  | 'BET_HIDE_QUOTES_CARD'
  | 'BET_HUB_CUSTOMER_ASSOCIATION_ACCESS'
  | 'BET_HUB_DOMAIN_WRITE'
  | 'BET_INTEGRATIONS_WRITE'
  | 'BET_MANUAL_ENRICHMENT_TEAM'
  | 'BET_MANUALLY_CHANGE_ASSOCIATED_COMPANY'
  | 'BET_MARK_BAD_FIT_ACCESS'
  | 'BET_PARTNER_ADMIN_APPROVED_EMAIL_DOMAIN_WRITE'
  | 'BET_PARTNER_ADMIN_CLIENT_ASSOCIATIONS_WRITE'
  | 'BET_PARTNER_ADMIN_DOCUMENT_APPROVE'
  | 'BET_PARTNER_ADMIN_FINANCE_WRITE'
  | 'BET_PARTNER_ADMIN_HUB_MANAGEMENT_WRITE'
  | 'BET_PARTNER_ADMIN_MARKETING_WRITE'
  | 'BET_PARTNER_ADMIN_WRITE'
  | 'BET_PARTNER_ASSIGN_DOMAN'
  | 'BET_PARTNER_COLLAB_CARD_VIEW'
  | 'BET_PIN_DOMAIN_ACCESS'
  | 'BET_PORTAL_ASSOCIATION_ACCESS'
  | 'BET_PROSPECTS_INTERNAL_API_ACCESS'
  | 'BET_QUOTE_CENTER_PUBLISH'
  | 'BET_QUOTE_READ'
  | 'BET_QUOTE_EDIT'
  | 'BET_RAISE_DISPUTE_DOMAIN'
  | 'BET_RAISE_IQL_ACCESS'
  | 'BET_RECARVE_HOLDOVER_ACCESS'
  | 'BET_RECYCLE_ALL_DOMAINS'
  | 'BET_RECYCLE_IBDR_OWNER'
  | 'BET_ELEVATED_RECYCLE_IBDR_OWNER'
  | 'BET_REJECT_QL'
  | 'BET_RELATED_CONTACTS_VIEW'
  | 'BET_RENEWAL_SUMMARY_ACCESS'
  | 'BET_RESOLVE_DOMAIN_ACCESS'
  | 'BET_SEGMENT_MANAGEMENT_WRITE'
  | 'BET_SUCCESS_HUBS_WRITE'
  | 'BET_SUCCESS_NOTES_WRITE'
  | 'BET_SUCCESS_OWNERS_WRITE'
  | 'BET_SUCCESS_PARTNER_MANAGED_ASSOCIATIONS_WRITE'
  | 'BET_SUCCESS_SHARED_VIEW_WRITE'
  | 'BET_TERRITORY_MANAGEMENT_RECARVE_WRITE'
  | 'BET_TERRITORY_MANAGEMENT_RECARVE_PUBLISH'
  | 'BET_TERRITORY_MANAGEMENT_WRITE'
  | 'BET_TRIGGERS_ACCESS'
  | 'BET_TRIGGERS_WRITE'
  | 'BET_USER_FLAGS_READ'
  | 'BET_USER_FLAGS_WRITE'
  | 'BET_USER_MANAGEMENT_READ'
  | 'BET_USER_MANAGEMENT_WRITE'
  | 'BET_VERIFY_DOMAIN_STATUS_ACCESS'
  | 'BET_VIEWS_PUBLIC_SHARE'
  | 'BET_WORKATO_ACCESS'
  | 'BET_WORKATO_LIMITED_ACCESS'
  | 'BETA_ADMIN_ACCESS'
  | 'BETA_JITA_ACCESS'
  | 'BILLING_ACCESS'
  | 'BILLING_ADMIN_ACCESS'
  | 'BILLING_ADMIN_HUBAPI_READ'
  | 'BILLING_ADMIN_LISTS_ACCESS'
  | 'BILLING_ADMIN_SUPER'
  | 'BILLING_ATTRIBUTION_ACCESS'
  | 'BILLING_BODIES_ACCESS'
  | 'BILLING_GATING_WRITE'
  | 'BILLING_NO_HUMAN_ACCESS_WRITE'
  | 'BILLING_PAYMENTS_READ'
  | 'BILLING_PAYMENTS_PROCESSOR_READ'
  | 'BILLING_PAYMENTS_PROCESSOR_WRITE'
  | 'BILLING_READ'
  | 'BILLING_READ_RESTRICTED'
  | 'BILLING_REFUNDS_READ'
  | 'BILLING_RESTRICTED_WRITE'
  | 'BILLING_SUPER'
  | 'BILLING_SYSTEM_REGISTRY_API_ALLOWLIST_BLOCKLIST_WRITE'
  | 'BILLING_WRITE'
  | 'BILLINGMANAGEMENT_READ'
  | 'BILLINGMANAGEMENT_WRITE'
  | 'BILLINGPUBLISHER_READ'
  | 'BILLINGPUBLISHER_WRITE'
  | 'BILLINGPUBLISHER_W9'
  | 'BILLING_TAX_READ'
  | 'BIZOPS_ROLES_WRITE'
  | 'BIZOPS_SAVED_SEARCH_EDIT_SHARED_ALERT_VIEWS'
  | 'BIZOPS_SAVED_SEARCH_EDIT_SHARED_HUB_VIEWS'
  | 'BIZOPS_SAVED_SEARCH_EDIT_SHARED_MIGRATION_VIEWS'
  | 'BIZOPS_SAVED_SEARCH_EDIT_SHARED_ONBOARDING_VIEWS'
  | 'BIZOPS_SAVED_SEARCH_WRITE_SHARED_ALERT_VIEWS'
  | 'BIZOPS_SAVED_SEARCH_WRITE_SHARED_HUB_VIEWS'
  | 'BIZOPS_SAVED_SEARCH_WRITE_SHARED_MIGRATION_VIEWS'
  | 'BIZOPS_SAVED_SEARCH_WRITE_SHARED_ONBOARDING_VIEWS'
  | 'BIZOPS_SUCCESS_HUBS_READ'
  | 'BI_JOB_EXECUTE'
  | 'BI_TEAM_DBT_JOB_EXECUTE'
  | 'BI_ORCH_AND_TOOLS_WRITE'
  | 'BI_ORCHESTRATION_WRITE'
  | 'BI_PROTECTION_WRITE'
  | 'BI_SNOWFLAKE_UPLOAD'
  | 'BI_APPROVE'
  | 'BLOG_ACCESS'
  | 'BLOG_AUTHORS_READ'
  | 'BLOG_AUTHORS_WRITE'
  | 'BLOG_APPROVAL_READ'
  | 'BLOG_APPROVAL_WRITE'
  | 'BLOG_BRAND_VOICE'
  | 'BLOG_POSTS_APPROVE'
  | 'BLOG_POSTS_AUTO_TRANSLATE'
  | 'BLOG_BULK_PUBLISH'
  | 'BLOG_CUSTOM_DOMAIN_ACCESS'
  | 'BLOG_CUSTOM_DOMAIN_WRITE'
  | 'BLOG_CUSTOM_DOMAIN_READ'
  | 'BLOG_HS_SITES_DOMAIN_WRITE'
  | 'BLOG_MULTILANGUAGE'
  | 'BLOG_REPORT_ACCESS'
  | 'BLOG_POST_READ'
  | 'BLOG_POSTS_PUBLISH'
  | 'BLOG_POSTS_SMARTCONTENT'
  | 'BLOG_POSTS_WRITE'
  | 'BLOG_PRIVATE_CONTENT_PUBLISH'
  | 'BLOG_PUBLISH'
  | 'BLOG_PUBLISH_SCHEDULED_UPDATE'
  | 'BLOG_RW'
  | 'BLOG_SCHEDULE'
  | 'BLOG_TAGS_READ'
  | 'BLOG_TAGS_WRITE'
  | 'BLOG_WRITE'
  | 'BLOG_SETTINGS_READ'
  | 'BLOG_SETTINGS_WRITE'
  | 'BLOG_LISTING_PAGE_ACCESS'
  | 'BLOG_LISTING_PAGE_READ'
  | 'BLOG_LISTING_PAGE_WRITE'
  | 'BLOG_LISTING_PAGE_PUBLISH'
  | 'BLOG_PAGES_NO_BRANDING'
  | 'BOOK_ON_BEHALF_ACCESS'
  | 'BOTS_READ'
  | 'BOTS_WRITE'
  | 'BRAND_VOICE'
  | 'BUSINESS_UNITS_VIEW_ALL'
  | 'BUSINESS_UNITS_ACCESS'
  | 'BUSINESS_UNITS_WRITE'
  | 'CALCULATED_FIELDS'
  | 'CALCULATED_SCORE'
  | 'CALENDARINTEGRATION_SUPPORT_HTML_DESCRIPTION_GRANDFATHERED'
  | 'CALENDAR_ACCESS'
  | 'CALENDAR_GOOGLE_EVENT_LIMIT_HTML_PARSING_GRANDFATHERED_SCOPE'
  | 'CALL_TOPIC_TAGGING'
  | 'CALL_TOPIC_TAGGING_ACCESS'
  | 'CALLING_ACCESS'
  | 'CALLING_CUSTOM_OUTCOMES'
  | 'CALLING_LEGACY_CONNECT_CALL_MY_PHONE'
  | 'CALLING_INTEGRATIONS'
  | 'CALLING_INTERNAL_BILLING_ADMIN'
  | 'CALLS_TO_ACTION_EDIT'
  | 'CALLS_TO_ACTION_NAV_ACCESS'
  | 'CALLS_TO_ACTION_READ'
  | 'CALLS_TO_ACTION_PUBLISH'
  | 'CALLS_TO_ACTION_WRITE'
  | 'CALL_SUMMARIES_ACCESS'
  | 'CAMPAIGNS_ACCESS'
  | 'CAMPAIGNS_ANALYTICS'
  | 'CAMPAIGNS_WRITE'
  | 'CAMPAIGNS_REVENUE_PRO'
  | 'CAN_SPAM_SETTINGS_ACCESS'
  | 'CAPACITY_LIMITS_ACCESS'
  | 'CAPACITY_LIMITS_READ'
  | 'CAPACITY_LIMITS_WRITE'
  | 'CARP_CONFIG_READ'
  | 'CARP_CONFIG_WRITE'
  | 'CARP_METADATA_READ'
  | 'CARP_METADATA_WRITE'
  | 'CASE_STUDY_ACCESS'
  | 'CCOM_ADMIN'
  | 'CCOM_READ'
  | 'CERTIFICATION_ADMIN'
  | 'CHANGE_EMAIL_ACCESS'
  | 'CHANNEL_INTEGRATION_CONFIGURE'
  | 'CHANNEL_INTEGRATION_READ'
  | 'CHANNEL_INTEGRATION_WRITE'
  | 'CHAT_WIDGET_CUSTOMIZATION'
  | 'CHATFLOWS_WRITE'
  | 'CHATFLOWS_URL_BRANCH_ACCESS'
  | 'CHATSPOT_ACCESS'
  | 'CHATSPOT_GLOBAL_ADMIN'
  | 'CHATSPOT_PORTAL_ADMIN'
  | 'CHECKER_OVERRIDE_READ'
  | 'CHECKER_OVERRIDE_WRITE'
  | 'CI_AUTO_ASSOCIATIONS_ACCESS'
  | 'CI_AUTO_ASSOCIATIONS_READ'
  | 'CI_AUTO_ASSOCIATIONS_WRITE'
  | 'CLONE_USER_PERMISSIONS_ACCESS'
  | 'CLOSING_AGENT_CONFIGURE'
  | 'CMS_ACCESS_GROUPS_WRITE'
  | 'CMS_ACCESS_GROUPS_READ'
  | 'CMS_ANALYTICS_API_ACCESS'
  | 'CMS_APPROVALS_CREATE'
  | 'CMS_APPROVALS_READ'
  | 'CMS_APPROVALS_WRITE'
  | 'CMS_APP_INTEGRATIONS_READ'
  | 'CMS_APP_INTEGRATIONS_WRITE'
  | 'CMS_AUDIT_LOGGING'
  | 'CMS_AUDIT_LOGS_READ'
  | 'CMS_LAMBDA'
  | 'CMS_DND_TEMPLATES'
  | 'CMS_MEMBERSHIP'
  | 'CMS_MULTI_LANGUAGE'
  | 'CMS_PERFORMANCE_API'
  | 'CMS_PERFORMANCE_READ'
  | 'CMS_URL_REDIRECTS_DELETE'
  | 'CMS_URL_REDIRECTS_READ'
  | 'CMS_URL_REDIRECTS_WRITE'
  | 'COACHING_CONTENT_USER'
  | 'COACHING_CONTENT_ADMIN'
  | 'CODE_ALERTS'
  | 'COLLECTED_FORMS_ACCESS'
  | 'COLLECTIONS_EDIT_INVOICE_TAGS'
  | 'COLLECTIONS_READ_INVOICE_TAGS'
  | 'COLLECTOR_CODE_EDIT'
  | 'COLLECTOR_DATA_QUERY_DELETE'
  | 'COLLECTOR_DATA_QUERY_READ'
  | 'COLLECTOR_DATA_QUERY_WRITE'
  | 'COLLECTOR_DATA_QUERY_EXECUTE'
  | 'COLLECTOR_GRAPHQL_QUERY_EXECUTE'
  | 'COLLECTOR_GRAPHQL_SCHEMA_READ'
  | 'COMMENTING_ACCESS_CMS_HUB'
  | 'COMMENTING_ACCESS_MARKETING_HUB'
  | 'COMMENTING_ACCESS_OPS_HUB'
  | 'COMMENTING_ACCESS_SALES_HUB'
  | 'COMMENTING_ACCESS_SERVICE_HUB'
  | 'COMMENTS_READ'
  | 'COMMENTS_WRITE'
  | 'COMMERCE_INVOICES_PAYMENTS_ACCESS'
  | 'COMMERCE_PAYMENTS_ACCESS'
  | 'COMMERCE_PAYMENTS_ENROLLED'
  | 'COMMERCE_PAYMENTS_READ'
  | 'COMMERCE_PAYMENTS_WRITE'
  | 'COMMUNITY_ACCESS'
  | 'COMMUNICATES_UNASSIGNED_OR_UNKNOWN'
  | 'COMPANIES_READ'
  | 'COMPANIES_SENSITIVE_DATA_READ'
  | 'COMPANIES_SENSITIVE_DATA_WRITE'
  | 'COMPANIES_WRITE'
  | 'COMPANY_OVERVIEW_ACCESS'
  | 'COMPETITORS_ACCESS'
  | 'COMPLIANCE_RESPONSIBILITIES_CARP_ONLY'
  | 'COMPLIANCE_RESPONSIBILITIES_VIEW_ALL'
  | 'CONDITIONAL_PROPERTY_CARD_ACCESS'
  | 'CONDITIONAL_PROPERTY_OPTIONS_ACCESS'
  | 'CONNECTED_EMAIL_ACCOUNTS_ADMIN_READ'
  | 'CONNECTED_EMAIL_CUSTOM_TRACKING_DOMAINS'
  | 'CONNECTED_EMAIL_DATA_ACCESS'
  | 'CONNECTED_EMAIL_EVENTS_ACCESS'
  | 'CONNECTED_EMAIL_INBOX_ACCESS'
  | 'CONNECTED_EMAIL_LINK_WRAPPING'
  | 'CONNECTED_EMAIL_PAID_LINK_WRAPPING'
  | 'CONNECTED_EMAIL_PORTAL_SEND_LIMIT_READ'
  | 'CONNECTED_EMAIL_PORTAL_SEND_LIMIT_WRITE'
  | 'CONNECTED_EMAIL_OUTGOING_ACCESS'
  | 'CONNECT_STARTER_COMMUNITY_ACCESS'
  | 'CONTACT_ANALYTICS'
  | 'CONTACT_CREATE_DATE_ATTRIBUTION_READ'
  | 'CONTACTS_ACCESS_NONAV'
  | 'CONTACTS_ACCESS'
  | 'CONTACTS_COMMUNICATES_ALL'
  | 'CONTACTS_COMMUNICATES_OWNED'
  | 'CONTACTS_COMMUNICATES_TEAM'
  | 'CONTACTS_EDIT_OWNER_OWNED'
  | 'CONTACTS_GDPR_DELETE'
  | 'CONTACTS_PREDICTIVE_SCORING_WRITE'
  | 'CONTACTS_PREDICTIVE_SCORING'
  | 'CONTACTS_LIST_READ'
  | 'CONTACTS_LIST_ACCESS'
  | 'CONTACTS_LIST_CREATE_SIMPLE'
  | 'CONTACTS_LIST_CREATE_ADVANCED'
  | 'CONTACTS_LIST_TEAMS_ADMIN'
  | 'CONTACTS_MANAGE_LEGAL_BASIS'
  | 'CONTACTS_READ'
  | 'CONTACTS_RO'
  | 'CONTACTS_RW'
  | 'CONTACTS_SECURITY_WRITE'
  | 'CONTACTS_SENSITIVE_DATA_READ'
  | 'CONTACTS_SENSITIVE_DATA_WRITE'
  | 'CONTACTS_SETTINGS_ACCESS'
  | 'CONTACTS_TEAM_READ'
  | 'CONTACTS_TEAM_WRITE'
  | 'CONTACTS_TIMELINE_LIMITED_ANALYTICS'
  | 'CONTACTS_TIMELINE_UNLIMITED_ANALYTICS'
  | 'CONTACTS_WRITE'
  | 'CONTENT_AB_TESTING'
  | 'CONTENT_ACCESS'
  | 'CONTENT_ACCESS_KNOWLEDGE_BASE'
  | 'CONTENT_ASSISTANCE_SETTINGS_WRITE'
  | 'CONTENT_CORE_API_ACCESS'
  | 'CONTENT_CUSTOM_DOMAIN_READ'
  | 'CONTENT_CUSTOM_DOMAIN_WRITE'
  | 'CONTENT_EDITOR_ACCESS'
  | 'CONTENT_EDITOR_WRITE'
  | 'CONTENT_EDITOR_ADVANCED_FEATURES'
  | 'CONTENT_EMBED_READ'
  | 'CONTENT_EMBED_WRITE'
  | 'CONTENT_EMBEDS_VIEW'
  | 'CONTENT_EMBEDS_EDIT'
  | 'CONTENT_EMBEDS_PUBLISH'
  | 'CONTENT_HOME_ACCESS'
  | 'CONTENT_INTERNAL_DOMAIN_CREATE'
  | 'CONTENT_MAB_TESTING'
  | 'CONTENT_MIGRATIONS_STATUS_VIEW'
  | 'CONTENT_MIGRATIONS_STATUS_INITIATE'
  | 'CONTENT_NARRATION_ACCESS'
  | 'CONTENT_RECOMMENDATIONS'
  | 'CONTENT_REMIX_ACCESS'
  | 'CONTENT_REMIX_READ'
  | 'CONTENT_REMIX_WRITE'
  | 'CONTENT_REPORTS_ACCESS'
  | 'CONTENT_REVIEW_WRITE'
  | 'CONTENT_SCANNING_AUTOMATIC_REVIEW'
  | 'CONTENT_SETTINGS_ACCESS'
  | 'CONTENT_SITE_TREE'
  | 'CONTENT_SSL'
  | 'CONTENT_STAGING'
  | 'CONTENT_STAGING_CUSTOM_DOMAIN_ACCESS'
  | 'CONTENT_TEAM_ASSIGNMENT'
  | 'CONTENT_SECURITY_HEADERS_READ'
  | 'CONTENT_SECURITY_HEADERS_WRITE'
  | 'CONTRACT_ACCESS'
  | 'CONVERSATIONS_ACCESS'
  | 'CONVERSATIONS_ADMIN'
  | 'CONVERSATIONS_API_READ'
  | 'CONVERSATIONS_API_WRITE'
  | 'CONVERSATIONS_INTERACT'
  | 'CONVERSATIONS_GRR_PANEL'
  | 'CONVERSATIONS_HOSTED_EMAIL_ACCESS'
  | 'CONVERSATIONS_HOSTED_EMAIL_PREMIUM'
  | 'CONVERSATIONS_MULTI_INBOX'
  | 'CONVERSATIONS_NO_BRANDING'
  | 'CONVERSATIONS_ROUTING'
  | 'CONVERSATIONS_ROUTING_ASSIGN_TO_AVAILABLE'
  | 'CONVERSATIONS_TAXONOMY_CARD_ACCESS'
  | 'CONVERSATIONS_TICKET_AUTOMATION_DEFAULT_ON'
  | 'CONVERSATIONS_UNASSIGNED_CHAT_QUEUE_LIMIT'
  | 'CONVERSATIONS_UNASSIGNED_QUEUE_CARD_ACCESS'
  | 'CONVERSATIONS_VISITOR_SANDBOX_ACCESS'
  | 'CONVERSIONASSISTS_ACCESS'
  | 'CONVERSIONS_HQ_ACCESS'
  | 'COOKIE_BANNER_CUSTOMIZATION'
  | 'COOKIE_BANNER_GPC_ACCESS'
  | 'COOKIE_BANNER_SETTINGS_READ'
  | 'COOKIE_BANNER_SETTINGS_WRITE'
  | 'COOKIE_SCANNING_ACCESS'
  | 'CORE_EASTER_EGG'
  | 'CORP_READ'
  | 'CORPORATE_SENSITIVE'
  | 'CREATE_MEETINGS_FROM_CONTACT'
  | 'CREATE_MORE_DOCUMENTS'
  | 'CREATE_MORE_SNIPPETS'
  | 'CREATE_MORE_TEMPLATES'
  | 'CREATE_SEQUENCES'
  | 'CREATE_TEMPLATE_ACCESS'
  | 'CREDENTIALS_DEFINITION_MANAGEMENT'
  | 'CREDIT_APPLICATION_READ'
  | 'CREDIT_BALANCE_ADJUSTMENT_WRITE'
  | 'CRITICAL_ACTIONS_ACCESS'
  | 'CRM_ACCESS'
  | 'CRM_AUTO_ASSOCIATION_SETTINGS_READ'
  | 'CRM_AUTO_ASSOCIATION_SETTINGS_WRITE'
  | 'CRM_BOARD_CARD_CUSTOMIZATION_ACCESS'
  | 'CRM_BOARD_CARD_CUSTOMIZATION_READ'
  | 'CRM_BOARD_CARD_CUSTOMIZATION_WRITE'
  | 'CRM_BOARD_CARD_CUSTOMIZATION_PER_PIPELINE'
  | 'CRM_ACTIVITY_TYPES'
  | 'CRM_BULK_DELETE'
  | 'CRM_CONDITIONAL_PROPERTIES'
  | 'CRM_CONTACT_DELETE'
  | 'CRM_CUSTOMIZE_ASSOCIATION_TABLES_DEFAULT_ACCESS'
  | 'CRM_CUSTOMIZE_ASSOCIATION_TABLES_TEAMS_ACCESS'
  | 'CRM_CUSTOMIZE_ASSOCIATION_TABLES_EDIT'
  | 'CRM_CUSTOMIZE_DATA_HIGHLIGHTS_DEFAULT_ACCESS'
  | 'CRM_CUSTOMIZE_DATA_HIGHLIGHTS_TEAMS_ACCESS'
  | 'CRM_CUSTOMIZE_DATA_HIGHLIGHTS_EDIT'
  | 'CRM_CUSTOMIZE_RIGHT_SIDEBAR_DEFAULT_ACCESS'
  | 'CRM_CUSTOMIZE_RIGHT_SIDEBAR_TEAMS_ACCESS'
  | 'CRM_CUSTOMIZE_RIGHT_SIDEBAR_EDIT'
  | 'CRM_CUSTOMIZE_OVERVIEW_TAB_EDIT'
  | 'CRM_CUSTOMIZE_CUSTOM_TAB_EDIT'
  | 'CRM_CUSTOM_ENGAGEMENT_PROPERTY_SETTINGS_WRITE'
  | 'CRM_DATA_ENTRY_SUGGESTIONS_ACCESS'
  | 'CRM_EMAIL_TEMPLATE_ACCESS'
  | 'CRM_EMAIL_TEMPLATE_DEFAULT_ACCESS'
  | 'CRM_EMAIL_TEMPLATE_FULL_ACCESS'
  | 'CRM_EMAILS_VIEW_ALL'
  | 'CRM_EMAILS_VIEW_TEAM'
  | 'CRM_EMAILS_VIEW_UNASSIGNED'
  | 'CRM_PAGE_EDITOR_ADDITIONAL_TABS'
  | 'CRM_PAGE_EDITOR_ADMIN'
  | 'CRM_PAGE_EDITOR_FULL_ACCESS'
  | 'CRM_RECORD_CUSTOMIZATION_ACCESS'
  | 'CRM_DELETE_ALL_COMPANIES'
  | 'CRM_DELETE_ALL_CONTACTS'
  | 'CRM_DELETE_ALL_DEALS'
  | 'CRM_DELETE_ALL_ORDERS'
  | 'CRM_DELETE_ALL_TICKETS'
  | 'CRM_DELETE_ALL_USERS'
  | 'CRM_DELETE_OWNED_CONTACTS'
  | 'CRM_DELETE_OWNED_DEALS'
  | 'CRM_DELETE_OWNED_TICKETS'
  | 'CRM_DELETE_OWNED_USERS'
  | 'CRM_DELETE_TEAM_OWNED_CONTACTS'
  | 'CRM_DELETE_TEAM_OWNED_DEALS'
  | 'CRM_DELETE_TEAM_OWNED_TICKETS'
  | 'CRM_DELETE_TEAM_OWNED_USERS'
  | 'CRM_DELETE_UNASSIGNED_COMPANIES'
  | 'CRM_DELETE_UNASSIGNED_CONTACTS'
  | 'CRM_DELETE_UNASSIGNED_DEALS'
  | 'CRM_DELETE_UNASSIGNED_TICKETS'
  | 'CRM_DELETE_UNASSIGNED_USERS'
  | 'CRM_EDIT_ALL'
  | 'CRM_EDIT_ALL_CAMPAIGNS'
  | 'CRM_EDIT_ALL_DEALS'
  | 'CRM_EDIT_ALL_TICKETS'
  | 'CRM_EDIT_ALL_USERS'
  | 'CRM_EDIT_OWNED_DEALS'
  | 'CRM_EDIT_OWNED_TICKETS'
  | 'CRM_EDIT_OWNED_USERS'
  | 'CRM_EDIT_TEAM_OWNED'
  | 'CRM_EDIT_TEAM_OWNED_DEALS'
  | 'CRM_EDIT_TEAM_OWNED_TICKETS'
  | 'CRM_EDIT_TEAM_OWNED_USERS'
  | 'CRM_EDIT_UNASSIGNED'
  | 'CRM_EDIT_UNASSIGNED_DEALS'
  | 'CRM_EDIT_UNASSIGNED_TICKETS'
  | 'CRM_EDIT_UNASSIGNED_USERS'
  | 'CRM_EVENTS_BACKEND_ADMIN'
  | 'CRM_EXPORT'
  | 'CRM_EXPORT_READ'
  | 'CRM_EXPORT_SETTINGS_READ'
  | 'CRM_EXPORT_SETTINGS_WRITE'
  | 'CRM_PUBLIC_EXPORT'
  | 'CRM_EXPORT_AUDIT_ACCESS'
  | 'CRM_EXPORT_FILE_ACCESS'
  | 'CRM_FORMS_FILTERING'
  | 'CRM_IMPORT'
  | 'CRM_IMPORT_DELETE_ALL'
  | 'CRM_IMPORT_DELETE_OWNED'
  | 'CRM_IMPORT_DELETE_TEAM_OWNED'
  | 'CRM_IMPORT_DELETE_UNASSIGNED'
  | 'CRM_IMPORT_EDIT_ALL'
  | 'CRM_IMPORT_EDIT_OWNED'
  | 'CRM_IMPORT_EDIT_TEAM_OWNED'
  | 'CRM_IMPORT_EDIT_UNASSIGNED'
  | 'CRM_IMPORT_JITA_ACCESS'
  | 'CRM_IMPORT_READ'
  | 'CRM_IMPORT_ROLLBACK'
  | 'CRM_IMPORT_VIEW_ALL'
  | 'CRM_IMPORT_VIEW_OWNED'
  | 'CRM_IMPORT_VIEW_TEAM_OWNED'
  | 'CRM_IMPORT_VIEW_UNASSIGNED'
  | 'CRM_MIGRATIONS_WRITE'
  | 'CRM_MIGRATIONS_READ'
  | 'CRM_MULTIPLE_PIPELINES'
  | 'CRM_NOTES_VIEW_ALL'
  | 'CRM_NOTES_VIEW_TEAM'
  | 'CRM_NOTES_VIEW_UNASSIGNED'
  | 'CRM_OBJECT_TYPES_READ'
  | 'CRM_OBJECT_TYPES_WRITE'
  | 'CRM_OBJECTS_LIFECYCLE_MIDDLEWARE_ADMIN'
  | 'CRM_OBJECTS_SECURITY_WRITE'
  | 'CRM_PIPELINE_DUMMY_TYPE_ACCESS'
  | 'CRM_PIPELINE_DUMMY_TYPE_CUSTOM'
  | 'CRM_PIPELINES_CUSTOMOBJECT_LABEL_ACCESS'
  | 'CRM_PIPELINES_CUSTOMOBJECT_LABEL_PER_PIPELINE_ACCESS'
  | 'CRM_PIPELINES_CUSTOMOBJECT_LABEL_WRITE'
  | 'CRM_PIPELINES_DEAL_LABEL_ACCESS'
  | 'CRM_PIPELINES_DEAL_LABEL_PER_PIPELINE_ACCESS'
  | 'CRM_PIPELINES_DEAL_LABEL_WRITE'
  | 'CRM_PIPELINES_DEAL_TAG_READ'
  | 'CRM_PIPELINES_DEAL_TAG_READ_PRE_SEAT'
  | 'CRM_PIPELINES_LOCKED_STAGES_ACCESS'
  | 'CRM_PIPELINES_LOCKED_STAGES_BYPASS'
  | 'CRM_PIPELINES_LOCKED_STAGES_WRITE'
  | 'CRM_PIPELINES_TICKET_TAG_ACCESS'
  | 'CRM_PIPELINES_TICKET_TAG_PER_PIPELINE_ACCESS'
  | 'CRM_PIPELINES_TICKET_TAG_READ'
  | 'CRM_PIPELINES_TICKET_TAG_READ_PRE_SEAT'
  | 'CRM_PIPELINES_TICKET_TAG_WRITE'
  | 'CRM_PIPELINES_OBJECT_LABEL_ACCESS'
  | 'CRM_PIPELINES_OBJECT_LABEL_WRITE'
  | 'CRM_PIPELINES_OBJECT_LABEL_PER_PIPELINE_ACCESS'
  | 'CRM_PIPELINES_PREFERRED_CURRENCY_ACCESS'
  | 'CRM_PIPELINES_GOVERNANCE_READ'
  | 'CRM_PIPELINES_GOVERNANCE_WRITE'
  | 'CRM_PRIVATE_VIEWS_READ_ALL'
  | 'CRM_VIEWS_READ'
  | 'CRM_PROPERTY_SETTINGS'
  | 'CRM_PUBLIC_OBJECT_API_ACCESS'
  | 'CRM_REQUIRED_FIELDS'
  | 'CRM_PRODUCT_ACCESS'
  | 'CRM_PRODUCT'
  | 'CRM_RECYCLING_BIN_ACCESS'
  | 'CRM_SCP_CONTACTS_ACCESS'
  | 'CRM_SCP_CONTACTS_BACKFILL'
  | 'CRM_SCP_CONTACTS_BASE_ACCESS'
  | 'CRM_SCP_DEALS_ACCESS'
  | 'CRM_SCP_DEALS_BASE_ACCESS'
  | 'CRM_SCP_DEALS_BACKFILL'
  | 'CRM_SEARCH_ACCESS'
  | 'CRM_SECONDARY_PERMISSIONS'
  | 'CRM_SET_DEFAULT_PROPERTIES'
  | 'CRM_SUBSCRIPTION_MANAGER_ACCESS'
  | 'CRM_TRANSCRIPTION'
  | 'CRM_TRANSCRIPTION_ADMIN'
  | 'CRM_VIEW_DELETE'
  | 'CRM_VIEW_WRITE'
  | 'CRM_VIEWS_ALL'
  | 'CRM_VIEWS_ALL_CAMPAIGNS'
  | 'CRM_VIEWS_ALL_DEALS'
  | 'CRM_VIEWS_ALL_FORMS'
  | 'CRM_VIEWS_ALL_TICKETS'
  | 'CRM_VIEWS_ALL_USERS'
  | 'CRM_VIEWS_CREATE_ACCESS'
  | 'CRM_VIEWS_HUB_PINNED_ACCESS'
  | 'CRM_VIEWS_HUB_PINNED_READ'
  | 'CRM_VIEWS_HUB_PINNED_WRITE'
  | 'CRM_VIEWS_TEAM_OWNED'
  | 'CRM_VIEWS_TEAM_OWNED_CAMPAIGNS'
  | 'CRM_VIEWS_TEAM_OWNED_DEALS'
  | 'CRM_VIEWS_TEAM_OWNED_TICKETS'
  | 'CRM_VIEWS_TEAM_OWNED_USERS'
  | 'CRM_VIEWS_TEAM_PINNED_ACCESS'
  | 'CRM_VIEWS_TEAM_PINNED_READ'
  | 'CRM_VIEWS_TEAM_PINNED_WRITE'
  | 'CRM_VIEWS_UNASSIGNED'
  | 'CRM_VIEWS_UNASSIGNED_DEALS'
  | 'CRM_VIEWS_UNASSIGNED_TICKETS'
  | 'CRM_VIEWS_UNASSIGNED_USERS'
  | 'CTA_ACCESS'
  | 'CTA_WRITE'
  | 'CTA_TARGETED_ACCESS'
  | 'CTA_VARIATION_ACCESS'
  | 'CURATIONS_ADMIN'
  | 'CUSTOM_APEX_DOMAIN_HOSTING_WRITE'
  | 'CUSTOM_APEX_DOMAIN_REDIRECT_WRITE'
  | 'CUSTOM_ASSOCIATION_LABELS_WRITE'
  | 'CUSTOM_ASSOCIATION_LABELS'
  | 'CUSTOM_CARDS_ACCESS'
  | 'CUSTOM_CARDS_WRITE'
  | 'CUSTOM_GOALS_ACCESS'
  | 'CUSTOM_EVENTS_VISUAL_BUILDER'
  | 'AUTOCAPTURE_EVENTS_ACCESS'
  | 'CUSTOM_GOALS_CREATE'
  | 'CUSTOM_GOALS_VIEW'
  | 'CUSTOM_JAVASCRIPT_EVENTS_READ'
  | 'CUSTOM_JAVASCRIPT_EVENTS_WRITE'
  | 'CUSTOM_LEAD_SCORING'
  | 'CUSTOM_LINE_ITEM_WRITE'
  | 'CUSTOM_OBJECT_ACCESS'
  | 'CUSTOM_OBJECT_DELETE'
  | 'CUSTOM_OBJECT_READ'
  | 'CUSTOM_OBJECT_WRITE'
  | 'CUSTOM_OBJECTS_SENSITIVE_DATA_READ'
  | 'CUSTOM_OBJECTS_SENSITIVE_DATA_WRITE'
  | 'CUSTOM_REPORTING_ACCESS'
  | 'CUSTOM_SCHEMA_ACCESS'
  | 'CUSTOM_SCHEMA_DELETE'
  | 'CUSTOM_SCHEMA_READ'
  | 'CUSTOM_SCHEMA_WRITE'
  | 'CUSTOM_SSL'
  | 'CUSTOM_TRANSLATIONS_ACCESS'
  | 'CUSTOM_VIEWS_EDIT'
  | 'CUSTOMER_ACCESS'
  | 'CUSTOMER_FEEDBACK_ACCESS'
  | 'CUSTOMER_FEEDBACK_SURVEY_WRITE'
  | 'CUSTOMER_KNOWLEDGE_ACCESS'
  | 'CUSTOMER_KNOWLEDGE_ARTICLE_PUBLISH'
  | 'CUSTOMER_KNOWLEDGE_ARTICLE_READ'
  | 'CUSTOMER_KNOWLEDGE_ARTICLE_WRITE'
  | 'CUSTOMER_KNOWLEDGE_CUSTOM_DOMAIN_WRITE'
  | 'CUSTOMER_KNOWLEDGE_IMPORT_WRITE'
  | 'CUSTOMER_PORTAL_CONFIG_READ'
  | 'CUSTOMER_PORTAL_CONFIG_WRITE'
  | 'CUSTOMER_SUCCESS_ACCOUNT_PLAN_WRITE'
  | 'CUSTOMER_SUCCESS_MANAGER'
  | 'CUSTOMER_SUCCESS_WORKSPACE_ACCESS'
  | 'CUSTOMER_SUCCESS_WORKSPACE_WRITE'
  | 'CUSTOMERS_READ'
  | 'CUSTOMERSERVICES_MIGRATIONS_TECH'
  | 'CUSTOMERSERVICES_MIGRATIONS_TECH_MANAGE'
  | 'CUSTOMERSERVICES_MIGRATIONS_WRITE'
  | 'CUSTOMERSERVICES_ONBOARDING_ACCESS'
  | 'CUSTOMERSERVICES_ONBOARDING_PROVIDERS_ACCESS'
  | 'CUSTOMERSERVICES_ONBOARDING_SERVICING_PARTNER_WRITE'
  | 'CUSTOMERSERVICES_ONBOARDING_WRITE'
  | 'CUSTOMIZED_INTERACTION_ATTRIBUTION_READ'
  | 'CUSTOMIZED_INTERACTION_ATTRIBUTION_WRITE'
  | 'CV_CUSTOMER_PORTAL_FE_TESTING'
  | 'DASH_ACCESS'
  | 'DASHBOARD_ADVANCED_SALES_ACCESS'
  | 'DASHBOARD_ADVANCED_SERVICE_ACCESS'
  | 'DASHBOARD_DEMO_READ'
  | 'DASHBOARD_DEMO_WRITE'
  | 'DASHBOARD_PUBLIC_ACCESS'
  | 'DASHBOARD_TEMPLATE_WRITE'
  | 'DASHBOARD_SPECIFIC_PERMISSION_GRANTS'
  | 'DATA_COMMAND_CENTER_READ'
  | 'DATA_ENRICHMENT_ACCESS'
  | 'DATA_ENRICHMENT_CONTINUOUS_ACCESS'
  | 'DATA_ENRICHMENT_PLATFORM_ACCESS'
  | 'DATA_MIGRATION_COMPLETED'
  | 'DATA_MIGRATION_READ_ONLY'
  | 'DATA_PRIVACY_CONSENT_READ'
  | 'DATA_PRIVACY_CONSENT_WRITE'
  | 'DATA_PRIVACY_CONTACT_DATA_EXPORT_WRITE'
  | 'DATA_SYNC_STATE_READ'
  | 'DATA_SYNC_STATE_WRITE'
  | 'DEACTIVATED'
  | 'DEAL_CREATE_ATTRIBUTION_READ'
  | 'DEAL_JOURNEY_ANALYTICS_READ'
  | 'DEAL_LINE_ITEM_READ'
  | 'DEAL_LINE_ITEM_WRITE'
  | 'DEAL_SPLITS_ACCESS'
  | 'DEALS_READ'
  | 'DEALS_SENSITIVE_DATA_READ'
  | 'DEALS_SENSITIVE_DATA_WRITE'
  | 'DEALS_WRITE'
  | 'DEAL_APPROVAL_READ'
  | 'DEAL_APPROVAL_WRITE'
  | 'DEALS_APPROVE'
  | 'KNOWLEDGE_ARTICLE_APPROVAL_READ'
  | 'KNOWLEDGE_ARTICLE_APPROVAL_WRITE'
  | 'KNOWLEDGE_ARTICLES_APPROVE'
  | 'DEDICATED_IP'
  | 'DEDICATED_IP_CANDIDATE'
  | 'DEDICATED_IP_MARKETING'
  | 'DEDICATED_IP_TRANSACTIONAL'
  | 'DEFAULT_DND_THEME_DELIVERY'
  | 'DEFAULT_CMS_QUOTES_THEME_DELIVERY'
  | 'CUSTOM_CMS_TEMPLATES_FOR_QUOTE_TEMPLATES_ACCESS'
  | 'DEFAULT_MARKETING_THEME_DELIVERY'
  | 'DEFAULT_SIMPLE_LP_THEME_DELIVERY'
  | 'DEFAULT_WEBSITE_THEME_DELIVERY'
  | 'DELETE_EXPORT_JITA_ACCESS'
  | 'DEMO_CONFIG_ADVANCED_ACCESS'
  | 'DESIGN_MANAGER_ACCESS'
  | 'DEVELOPER_CARDS_ACCESS'
  | 'DEVELOPER_PROJECTS_ACCEPTANCE_TEST_SCOPE'
  | 'DEVELOPER_PROJECTS_READ'
  | 'DEVELOPER_PROJECTS_WRITE'
  | 'DEVELOPER_TEST_ACCOUNT_READ'
  | 'DEVELOPER_TEST_ACCOUNT_WRITE'
  | 'DEVELOPER_TOOLS_ACCESS'
  | 'DEVELOPERS_READ'
  | 'DEVELOPERS_WRITE'
  | 'DEVELOPERS_CLIENT_SECRET_READ'
  | 'DEVELOPERS_CLIENT_SECRET_WRITE'
  | 'DEVELOPERS_HAPIKEY_READ'
  | 'DEVELOPERS_HAPIKEY_WRITE'
  | 'DEVELOPER_APPLICATION_SECRET_ACCESS'
  | 'DEVELOPER_SANDBOXES_READ'
  | 'DEVELOPER_SANDBOXES_WRITE'
  | 'DEVELOPER_WEBTICKET_ACCESS'
  | 'DISCOUNT_TEMPLATE_WRITE'
  | 'DISCOUNT_TEMPLATE_READ'
  | 'DISPUTE_BIDEN_WRITE'
  | 'DISPUTE_PEOPLE_WRITE'
  | 'DOCUMENTS_READ'
  | 'DOCUMENTS_REPORTS_ACCESS'
  | 'DOCUMENTS_SUPPORT_ADMIN'
  | 'DOCUMENTS_WRITE'
  | 'DONT_USE_DUMMY'
  | 'DOMAIN_CONTROLS_ASSIGN'
  | 'DOMAIN_CONTROLS_ASSIGN_ADMIN'
  | 'DOMAIN_CONTROLS_BULK_RECYCLE'
  | 'DOMAIN_CONTROLS_BULK_RECYCLE_ADMIN'
  | 'DOMAIN_CONTROLS_RECYCLE'
  | 'DOMAIN_CONTROLS_RECYCLE_ADMIN'
  | 'DOMAIN_CONTROLS_ROTATE'
  | 'DOMAIN_CONTROLS_ROTATE_ADMIN'
  | 'DOMAIN_HOSTING'
  | 'DOMAIN_SUFFIX_APPROVE'
  | 'DOMAIN_SUFFIX_WRITE'
  | 'DOMAIN_VERIFICATION_ACCESS'
  | 'DOMAINS_SETTINGS_WRITE'
  | 'DOUBLE_OPT_IN_ACCESS'
  | 'DUPLICATES_BULK_MERGE_ACCESS'
  | 'DUPLICATES_READ'
  | 'DUPLICATES_WRITE'
  | 'DUPLICATES_EXPORT'
  | 'DYNAMIC_PAGE_ACCESS'
  | 'DYNAMIC_PUBLIC_CONTENT'
  | 'ECOMM_REPORTS'
  | 'ECOMM_SETTINGS'
  | 'ECOMM_SYNC'
  | 'ECOSYSTEM_ADMIN'
  | 'ECOSYSTEM_ASSETS_ADMIN'
  | 'ECOSYSTEM_ASSETS_SUSPEND'
  | 'ECOSYSTEM_APPS_SUSPEND'
  | 'EDISON_READ'
  | 'EDISON_WRITE'
  | 'ELIGIBLE_FOR_JS_RENDERING_BETA'
  | 'ENGAGEMENTS_READ'
  | 'ENGAGEMENTS_WRITE'
  | 'ENGAGEMENTS_EMAIL_READ'
  | 'ELEVATED_JITA_ACCESS'
  | 'ELEVATED_JITA_PROLONGED_ACCESS'
  | 'EMAIL_ACCESS'
  | 'EMAIL_APPROVAL_READ'
  | 'EMAIL_APPROVAL_WRITE'
  | 'EMAIL_AUTO_TRANSLATE'
  | 'EMAIL_BATCH_AB'
  | 'EMAIL_BATCH_LOCALTIME'
  | 'EMAIL_BATCH_RSS_BLOG'
  | 'EMAIL_BATCH_STANDARD'
  | 'EMAIL_CLIENTS_ACCESS'
  | 'EMAIL_CLIENTS_READ'
  | 'EMAIL_CLIENTS_WRITE'
  | 'EMAIL_CORE_API_ACCESS'
  | 'EMAIL_CRM_VIEW_ALL'
  | 'EMAIL_DASHBOARD_ACCESS'
  | 'EMAIL_DETAILED_STATISTICS'
  | 'EMAIL_DETAILS_ACCESS'
  | 'EMAIL_EDITOR_ACCESS'
  | 'EMAIL_FULL_EDITING'
  | 'EMAIL_HEALTH_SCORE_READ'
  | 'EMAIL_HOSTING_DOMAINS_ACCESS'
  | 'EMAIL_HOSTING_CUSTOM_DOMAINS_WRITE'
  | 'EMAIL_HOSTING_CUSTOM_DOMAINS_READ'
  | 'EMAIL_HOSTING_HS_SITES_DOMAIN_WRITE'
  | 'EMAIL_INTERNAL_ADMIN'
  | 'EMAIL_LENIENT_SPAM_ENFORCEMENT'
  | 'EMAIL_LOCALTIME'
  | 'EMAIL_MARKETING_PRODUCT_ACCESS'
  | 'EMAIL_MULTI_SUBSCRIPTIONS_ACCESS'
  | 'EMAIL_QUARANTINE_ACCESS'
  | 'EMAIL_P53_PUBLISH'
  | 'EMAIL_PORTAL_GENERIC_SETTINGS_ACCESS'
  | 'EMAIL_PUBLISH'
  | 'EMAIL_RECIPIENT_FATIGUE_SUPPRESSION_ACCESS'
  | 'EMAIL_RECIPIENT_FATIGUE_SUPPRESSION_READ'
  | 'EMAIL_RECIPIENT_FATIGUE_SUPPRESSION_WRITE'
  | 'EMAIL_ROUTING_STANDARD'
  | 'EMAIL_ROUTING_STARTER'
  | 'EMAIL_SELECT_RECIPIENTS'
  | 'EMAIL_SELF_SERVE_UNBOUNCE'
  | 'EMAIL_SENDING_FREE'
  | 'EMAIL_SENDING_DOMAINS_ACCESS'
  | 'EMAIL_SENDING_DOMAINS_WRITE'
  | 'EMAIL_SENDING_SOFT_LIMIT'
  | 'EMAIL_SENDING_STANDARD'
  | 'EMAIL_SENDING_STARTER'
  | 'EMAIL_SUPPORT_ADMIN'
  | 'EMAIL_SUPPORT_VIEW'
  | 'EMAIL_TEST_SENDING_ACCESS'
  | 'EMAIL_TEST_SENDING_ANY_ADDRESS'
  | 'EMAIL_TRUSTED'
  | 'EMAIL_TYPE_AB_ACCESS'
  | 'EMAIL_TYPE_BATCH_ACCESS'
  | 'EMAIL_TYPE_BLOG_ACCESS'
  | 'EMAIL_TYPE_LOCALTIME_ACCESS'
  | 'EMAIL_TYPE_RSS_ACCESS'
  | 'EMAIL_TYPE_WORKFLOWS_ACCESS'
  | 'EMAIL_WEBVERSION_SETTINGS_ACCESS'
  | 'EMAIL_WRITE'
  | 'EMBEDDED_DEAL_AUTOMATION_ACCESS'
  | 'EMBEDDED_TICKET_AUTOMATION_ACCESS'
  | 'EMP_ADD_ADMIN_READ'
  | 'EMP_ADD_ADMIN_WRITE'
  | 'EMP_ADD_ADMIN'
  | 'ENRICHMENT_ADMIN_READ_WRITE'
  | 'ENRICHMENT_BULK_ACTIONS_ACCESS'
  | 'ESP_SYNC_ACCESS'
  | 'EVENTS_ANALYTICS'
  | 'EVENT_ANALYTICS_API_ACCESS'
  | 'EVENT_DETAIL_READ'
  | 'EVENT_MANAGEMENT_ACCESS'
  | 'EVENT_MANAGEMENT_EVENT_ADMIN'
  | 'EVENT_MANAGEMENT_LOCATION_ADMIN'
  | 'EVENT_MANAGEMENT_PURCHASE'
  | 'EVENT_MANAGEMENT_REGISTRATION_ADMIN'
  | 'EXPEDITED_CONTENT_SCANNING'
  | 'EXTERNAL_INTEGRATIONS_LIVECHAT_ACCESS'
  | 'EXTERNAL_MARKETING_EMAIL_OBJECT_ACCESS'
  | 'EXTERNAL_MARKETING_EMAIL_OBJECT_READ'
  | 'EXTERNAL_MARKETING_EMAIL_OBJECT_WRITE'
  | 'EXTERNAL_SETTINGS_ACCESS'
  | 'EXTRA_SSL_DOMAINS'
  | 'FACSIMILE_UPPER_SEND_LIMIT_ACCESS'
  | 'FACSIMILE_UPPER_SEND_LIMIT_SHARED_ACCESS'
  | 'FAQ_CATALOG_ADMIN'
  | 'FAQ_CATALOG_ACCESS'
  | 'FEATURE_SCOPE_WRITE'
  | 'FEATURE_WRITE'
  | 'FEEDBACK_REPORTS_ACCESS'
  | 'FIELD_LEVEL_PERMISSIONS_ACCESS'
  | 'FIELD_LEVEL_PERMISSIONS_BYPASS'
  | 'FIELD_LEVEL_PERMISSIONS_WRITE'
  | 'FILE_HOSTING_PAID_DOMAINS_ACCESS'
  | 'FILE_MANAGER_ACCESS'
  | 'FILE_MANAGER_DASHBOARD_UI_ACCESS'
  | 'FILE_MANAGER_DELETE'
  | 'FILE_MANAGER_GDPR_DELETE'
  | 'FILE_MANAGER_HIDDEN_FILES_READ'
  | 'FILE_MANAGER_HIDDEN_FILES_WRITE'
  | 'FILE_MANAGER_RISK_ANALYSIS'
  | 'FILE_MANAGER_VIDYARD_CONNECTION_REMOVAL'
  | 'FILE_MANAGER_VIEW'
  | 'FILE_MANAGER_WRITE'
  | 'FILE_MANAGER_INTERNAL_CRM_OBJECTS_VIEW'
  | 'FILE_MANAGER_INTERNAL_CRM_OBJECTS_EDIT'
  | 'FILE_MANAGER_INTERNAL_CRM_OBJECTS_DELETE'
  | 'FILE_MANAGER_BYPASS_FOLDER_PERMISSION'
  | 'FILE_MANAGER_NO_UPLOAD_LIMIT'
  | 'FINTECH_PARTNER_QUOTING_WRITE'
  | 'FINTECH_TESTING_SUBSCRIPTION_TEMPLATE_WRITE'
  | 'FINTECH_SUBSCRIPTIONS_READ'
  | 'FINTECH_SUBSCRIPTIONS_WRITE'
  | 'FINTECH_INVOICES_AND_CREDITS_READ'
  | 'FINTECH_INVOICES_AND_CREDITS_BILL_RUNS_READ'
  | 'FINTECH_INVOICES_AND_CREDITS_BILL_RUNS_WRITE'
  | 'FINTECH_INVOICES_AND_CREDITS_BILLING_TRANSACTIONS_READ'
  | 'FINTECH_INVOICES_AND_CREDITS_BILLING_TRANSACTIONS_WRITE'
  | 'FINTECH_INVOICES_AND_CREDITS_INVOICE_WORKFLOW_ENGINE_READ'
  | 'FINTECH_INVOICES_AND_CREDITS_INVOICE_WORKFLOW_ENGINE_WRITE'
  | 'FINTECH_INVOICES_AND_CREDITS_MEMOS_READ'
  | 'FINTECH_INVOICES_AND_CREDITS_MEMOS_WRITE'
  | 'FIRESTATION_ADMIN'
  | 'FLYWHEEL_PARTNER_ACCOUNT_ADMIN_WRITE'
  | 'FLYWHEEL_PROSPECTING_WORKSPACE_ADMIN'
  | 'FLYWHEEL_PROSPECTING_WORKSPACE_BDR_ACCESS'
  | 'FLYWHEEL_PROSPECTING_WORKSPACE_GS_ACCESS'
  | 'FLYWHEEL_RECENT_CONVERSIONS_CARD_ACCESS'
  | 'FLYWHEEL_TALKING_POINTS_CARD_ACCESS'
  | 'FOLLOW_ME_ACCESS'
  | 'FORECAST_OBJECT_ACCESS'
  | 'FORECAST_READ'
  | 'FORECASTING_ACCESS'
  | 'FORECASTING_EDIT'
  | 'FORECASTING_SUPPORT_ADMIN'
  | 'FORM_ANALYTICS_API_ACCESS'
  | 'FORM_CUSTOM_STYLE'
  | 'FORM_SHORTENING_ACCESS'
  | 'FORM_UPLOADED_FILE_ACCESS'
  | 'FORM_SUBMISSION_EMAIL_DOMAIN_BLOCKING_ACCESS'
  | 'FORM_SUBMISSION_PROCESSING'
  | 'FORM_SUBMISSIONS'
  | 'FORM_SUBMISSIONS_DELETE'
  | 'FORM_SUBMISSIONS_WRITE'
  | 'FORMS_ACCESS'
  | 'FORMS_DEPENDENT_FIELDS_ACCESS'
  | 'FORMS_ROUTING_ACCESS'
  | 'FORMS_MULTI_KICKBACK_ACCESS'
  | 'FORMS_PROGRESSIVE_PROFILING_ACCESS'
  | 'FORMS_RAW_HTML_ACCESS'
  | 'FORMS_READ'
  | 'FORMS_SMART_FIELDS_ACCESS'
  | 'FORMS_SUBMISSIONS_NOTIFICATIOINS'
  | 'FORMS_V2_TEMP'
  | 'FORMS_WRITE'
  | 'FRONT_HUBS_READ'
  | 'FTE_API_ACCESS'
  | 'FULL_ACTIVITY_HISTORY_ACCESS'
  | 'FULL_CRM_ACCESS'
  | 'FUNNEL_JOURNEY_ANALYTICS_READ'
  | 'GATES_PROTECTED_ACCESS'
  | 'GATING_MANAGER_ACCESS'
  | 'GENIE_ADMIN'
  | 'GIBBERISH_DETECTION_ACCESS'
  | 'GTMDS_ML_OPS_RO'
  | 'GLOBAL_CONTENT_WRITE_ACCESS'
  | 'GOALS_VIEW_ALL'
  | 'GOALS_VIEW_OWNED_ALL_ROLES'
  | 'GOALS_VIEW_TEAM'
  | 'GOALS_VIEW_UNASSIGNED_ALL_ROLES'
  | 'GOALS_EDIT_ALL'
  | 'GOALS_EDIT_OWNED'
  | 'GOALS_EDIT_TEAM'
  | 'GOALS_EDIT_UNASSIGNED'
  | 'GOALS_READ'
  | 'GOALS_WRITE'
  | 'GOALS_ALL_VIEW'
  | 'GOALS_ALL_EDIT'
  | 'GOALS_ALL_DELETE'
  | 'GOALS_FY_BACKFILL'
  | 'GOALS_MIGRATION_CLEANUP_GATE_ACCESS'
  | 'GOALS_MIGRATION_KPI_GATE_ACCESS'
  | 'GOALS_OWNED_VIEW'
  | 'GOALS_OWNED_VIEW_ALL_ROLES'
  | 'GOALS_OWNED_EDIT'
  | 'GOALS_OWNED_DELETE'
  | 'GOALS_TEAM_OWNED_VIEW'
  | 'GOALS_TEAM_OWNED_EDIT'
  | 'GOALS_TEAM_OWNED_DELETE'
  | 'GOALS_UNASSIGNED_VIEW'
  | 'GOALS_UNASSIGNED_EDIT'
  | 'GOALS_UNASSIGNED_DELETE'
  | 'GOALS_ADS_ACCESS'
  | 'GOALS_NON_REVENUE_MIGRATION_ACCESS'
  | 'GOALS_PERMANENT_ACCESS'
  | 'GOAL_FORECAST_EDIT_ALL'
  | 'GOAL_FORECAST_EDIT_OWNED'
  | 'GOAL_FORECAST_EDIT_TEAM'
  | 'GOAL_FORECAST_VIEW_ALL'
  | 'GOAL_FORECAST_VIEW_TEAM'
  | 'GOOGLE_ARMAGEDDON_FREE'
  | 'GOOGLE_ARMAGEDDON_PAID'
  | 'GOOGLE_CALENDAR_RECONNECT'
  | 'GOOGLE_RECONNECT'
  | 'GOOGLE_VOICE_ASSISTANT_ACCESS'
  | 'GOOGLE_SEARCH_CONSOLE_ACCESS'
  | 'GRANTED_CREDIT_APPROVERS'
  | 'GREENHOUSE_DATA_READ_ACCESS'
  | 'GROWTH_CMS_THEME_ENTERPRISE'
  | 'GROWTH_CMS_THEME_PROFESSIONAL'
  | 'GROWTH_MARKETING_THEME_PROFESSIONAL'
  | 'GROWTH_OVERRIDE_MAX_TRIAL_DURATION'
  | 'HAPIKEYS_ACCESS'
  | 'HAPIKEYS_READ'
  | 'HAPIKEYS_WRITE'
  | 'HAS_CRM_PORTAL_OBJECT'
  | 'HAWKEYE_WRITE'
  | 'HAWKEYE_READ'
  | 'HELP_DESK_ACCESS'
  | 'HELP_DESK_SEND'
  | 'HELP_DESK_VIEWS'
  | 'HELP_DESK_SIDEBAR_SETTINGS_VIEW'
  | 'HELP_DESK_JIRA_INTEGRATION'
  | 'HIGH_VOLUME_API'
  | 'HISTORICAL_QUEUE_READ'
  | 'HISTORICAL_QUEUE_WRITE'
  | 'HS_FLYWHEEL_ADM'
  | 'HS_SITES_DOMAIN_WRITE'
  | 'HSFX_ELIGIBILITY_ADMIN'
  | 'HSFX_PARTNER_HOME_ACCESS'
  | 'HUB_ACTIVE'
  | 'HUB_CONTACT_ROLES_WRITE'
  | 'HUB_CRM_PRODUCT'
  | 'HUB_GPT_ADMIN_ACCESS'
  | 'HUB_JITA_SETTINGS_READ'
  | 'HUB_JITA_SETTINGS_WRITE'
  | 'HUB_LIMITS_WRITE'
  | 'HUB_MARKETING_PRODUCT'
  | 'HUB_OWNER'
  | 'HUB_PARCEL_WRITE'
  | 'HUB_REACTIVATE'
  | 'HUB_TYPE_PROTECTED_WRITE'
  | 'HUB_TYPE_WRITE'
  | 'HUB_USERS_REMOVE'
  | 'HUBDB_CUSTOM_DOMAIN_ACCESS'
  | 'HUBDB_EMAIL_TEMPLATE_ACCESS'
  | 'HUBDB_PAGE_TEMPLATE_ACCESS'
  | 'HUBDB_DATA_APPEND'
  | 'HUBDB_DATA_READ'
  | 'HUBDB_DATA_WRITE'
  | 'HUBDB_PUBLISH'
  | 'HUBDB_SCHEMAS_READ'
  | 'HUBDB_SCHEMAS_WRITE'
  | 'HUBDB_UNPUBLISH'
  | 'HUBFINDER_COMPANY_NAME_CHANGE_ACCESS'
  | 'HUBFINDER_CONVERT_COMMUNITY_ACCESS'
  | 'HUBFINDER_DEACTIVATE_FREE_PORTAL_ACCESS'
  | 'HUBFINDER_DEACTIVATE_PAID_PORTAL_ACCESS'
  | 'HUBFINDER_FAF_ADMIN_ACCESS'
  | 'HUBFINDER_FAF_SEARCH_ACCESS'
  | 'HUBFINDER_FLUSH_PARCELS_ACCESS'
  | 'HUBFINDER_PAID_SUPPORT_OVERRIDE_ACCESS'
  | 'HUBGPT_SALES_OPS_ASSISTANCE'
  | 'HUBGPT_SALES_OPS_ASSISTANCE_BETA'
  | 'HUBS_ACCEPTANCE_TEST_SCOPE'
  | 'HUBS_CREATE_INTERNAL'
  | 'HUBS_DELETE'
  | 'HUBS_PURGE'
  | 'HUBS_READ'
  | 'HUBS_SUSPEND'
  | 'HUBS_TRIAL_WRITE'
  | 'HUBS_WRITE'
  | 'HUBSPOT_NETWORK_ADMIN'
  | 'HUBSPOT_NEXT'
  | 'HUBSPOT_ON_CREDITS_UBB_ENABLED_METRONOME_INTEGRATION'
  | 'IMPERSONATE'
  | 'IMPERSONATE_REQUEST'
  | 'IMPORT_DOWNLOAD_ORIGINALS'
  | 'IMPORT_OPT_OUT_LIST'
  | 'ILS_LISTS_READ'
  | 'ILS_LISTS_TEAMS_EDIT_ALL'
  | 'ILS_LISTS_TEAMS_READ_ALL'
  | 'ILS_LISTS_TEAMS_READ_TEAM_OWNED'
  | 'ILS_LISTS_WRITE'
  | 'IN_APP_IMPERSONATION'
  | 'INBOUNDDB_PRODUCT_LIBRARY_ACCESS'
  | 'INBOUNDDB_PRODUCT_LIBRARY_READ'
  | 'INBOUNDDB_PRODUCT_LIBRARY_WRITE'
  | 'INBOUND_CERTIFICATION_ACCESS'
  | 'INCIDENTS_READ'
  | 'INCIDENTS_WRITE'
  | 'INSTANCE_LAYOUT_PAGE_READ'
  | 'INSTANCE_LAYOUT_PAGE_WRITE'
  | 'INSTANCE_LAYOUT_PAGE_PUBLISH'
  | 'INTEGRATIONS_MANAGEMENT_READ'
  | 'INTEGRATIONS_MANAGEMENT_WRITE'
  | 'INTEGRATIONS_SETTINGS_ACCESS'
  | 'INTEGRATIONS_SLACK_SETTINGS_WRITE'
  | 'INTEGRATIONS_SYNC_ACCESS'
  | 'INTEGRATIONS_SYNC_SETTINGS_READ'
  | 'INTEGRATIONS_ZOOM_SETTINGS_WRITE'
  | 'INTERNAL_RELEASE_READ'
  | 'INTERNAL_RELEASE_WRITE'
  | 'INTERVIEW_ADMIN_DATA_READ_ACCESS'
  | 'INVITE_SINGLE_USER_READ'
  | 'INVITE_SINGLE_USER_WRITE'
  | 'INVITE_DOMAIN_BASED_READ'
  | 'INVITE_DOMAIN_BASED_WRITE'
  | 'INVOICE_REPORTING'
  | 'INVOICES_ACCESS'
  | 'INVOICES_READ'
  | 'INVOICES_WRITE'
  | 'INVOICES_SETTINGS_WRITE'
  | 'IP_RESTRICTIONS_READ'
  | 'IP_RESTRICTIONS_WRITE'
  | 'IS_LEGACY_SALES_PRO'
  | 'IS_MARKETING_LARGE'
  | 'IS_MARKETING_MEDIUM'
  | 'IS_MARKETING_PRO_OR_ENT'
  | 'IS_MARKETING_SMALL'
  | 'IS_SALES_PROFESSIONAL'
  | 'JITA_ACCESS'
  | 'JITA_AUDIT_ACCESS'
  | 'JITA_CAPS_READ'
  | 'JITA_CAPS_WRITE'
  | 'JITA_OVERRIDES_READ'
  | 'JITA_OVERRIDES_WRITE'
  | 'JITA_SCOPE_ROLES_MAPPING_READ'
  | 'JITA_SCOPE_ROLES_MAPPING_WRITE'
  | 'JITA_USER'
  | 'JS_RENDERING_IN_DEVELOPER_SANDBOXES'
  | 'JOURNEY_ANALYTICS_READ'
  | 'JOURNEY_ANALYTICS_WRITE'
  | 'KEYS_READ'
  | 'KEYS_WRITE'
  | 'KEYWORDS_ACCESS'
  | 'KNOWLEDGE_BASE_PRIVATE_CONTENT_PUBLISH'
  | 'KNOWLEDGE_BASE_READ'
  | 'KNOWLEDGE_BASE_WRITE'
  | 'KNOWLEDGE_CATEGORY_EDIT'
  | 'KNOWLEDGE_REPORTS_ACCESS'
  | 'KNOWLEDGE_MULTI_DOMAIN_PUBLISHING'
  | 'LABEL_MANAGEMENT_WRITE'
  | 'LANDINGPAGES_ACCESS'
  | 'LANDINGPAGES_ADVANCED_WRITE'
  | 'LANDINGPAGES_APPROVAL_READ'
  | 'LANDINGPAGES_APPROVAL_WRITE'
  | 'LANDING_PAGES_APPROVE'
  | 'LANDINGPAGES_AUTO_TRANSLATE'
  | 'LANDINGPAGES_BULK_DOMAIN_CHANGE'
  | 'LANDINGPAGES_BULK_PUBLISH'
  | 'LANDINGPAGES_CUSTOM_DOMAIN_ACCESS'
  | 'LANDINGPAGES_CUSTOM_DOMAIN_WRITE'
  | 'LANDINGPAGES_CUSTOM_DOMAIN_READ'
  | 'LANDINGPAGES_HS_SITES_DOMAIN_WRITE'
  | 'LANDINGPAGES_MULTILANGUAGE'
  | 'LANDINGPAGES_NO_BRANDING'
  | 'LANDINGPAGES_PASSWORD_PROTECTION'
  | 'LANDINGPAGES_PRIVATE_CONTENT_PUBLISH'
  | 'LANDINGPAGES_PUBLISH'
  | 'LANDINGPAGES_PUBLISH_SCHEDULED_UPDATE'
  | 'LANDINGPAGES_REPORT_ACCESS'
  | 'LANDINGPAGES_SCHEDULE'
  | 'LANDINGPAGES_SMARTCONTENT'
  | 'LANDINGPAGES_TRUSTED'
  | 'LANDINGPAGES_WRITE'
  | 'LANDINGPAGES_ANALYTICS_API_ACCESS'
  | 'LANGUAGE_SETTINGS_READ'
  | 'LANGUAGE_SETTINGS_WRITE'
  | 'LEAD_FLOWS_ACCESS'
  | 'LEAD_FLOWS_BANDIT_TESTING_ACCESS'
  | 'LEAD_FLOWS_CUSTOM_FIELDS_ACCESS'
  | 'LEAD_FLOWS_SCHEDULING'
  | 'LEAD_FLOWS_WRITE'
  | 'LEAD_QUALIFICATION_ACCESS'
  | 'LEAD_REVISIT_EMAIL'
  | 'LEAD_REVISIT_NOTIFICATIONS_ACCESS'
  | 'LEADIN_NO_BRANDING'
  | 'LEADS_EDIT_ALL'
  | 'LEADS_VIEW_ALL'
  | 'LEADS_EDIT_TEAM'
  | 'LEADS_VIEW_TEAM'
  | 'LEADS_DELETE_ALL'
  | 'LEADS_EDIT_OWNED'
  | 'LEADS_DELETE_TEAM'
  | 'LEADS_DELETE_OWNED'
  | 'LEADS_EDIT_UNASSIGNED'
  | 'LEADS_VIEW_UNASSIGNED'
  | 'LEADS_DELETE_UNASSIGNED'
  | 'LEGACYING_MIGRATIONS_READ'
  | 'LEGACYING_MIGRATIONS_WRITE'
  | 'LEGACY_BRANDING_ACCESS'
  | 'LEGACY_DEAL_AMOUNT_CALCULATION'
  | 'LEGACY_DESIGN_MANAGER_ACCESS'
  | 'LEGACY_PRODUCT_LIBRARY_ACCESS'
  | 'LEGACY_PRODUCT_LIBRARY_FOLDERS'
  | 'LEGACY_SALES_NAVIGATOR'
  | 'LEGACY_QUOTAS_ACCESS'
  | 'LEGAL_BUILDER_LEGAL_ADJUSTMENTS'
  | 'LEGAL_BUILDER_READ'
  | 'LEGAL_BUILDER_SPECIAL_TERMS'
  | 'LEGAL_BUILDER_STANDARD_ADJUSTMENTS'
  | 'LEGAL_BUILDER_WRITE'
  | 'LEGAL_TERMS_READ'
  | 'LEGAL_TERMS_WRITE'
  | 'LEGAL_TERMS_TRANSLATIONS'
  | 'LINE_ITEM_REPORTS_ACCESS'
  | 'LINKEDIN_RECRUITING_DATA_READ_ACCESS'
  | 'LIST_PERFORMANCE_ACCESS'
  | 'LISTS_ACCESS'
  | 'LISTS_EDIT'
  | 'LISTS_NOTIFICATIONS_ACCESS'
  | 'LISTS_NOTIFICATIONS_WRITE'
  | 'LISTS_RANDOM_SAMPLE_WRITE'
  | 'LISTS_SPLIT_LISTS_WRITE'
  | 'LISTS_VIEW'
  | 'LIVE_AFTER_WRITE'
  | 'LIMITS_MANAGEMENT_ADMIN'
  | 'LOGIN_AUDIT_ACCESS'
  | 'LOVABLE_APP_DELETE'
  | 'LOVABLE_APP_PUT'
  | 'MANAGE_DATA_ENRICHMENT'
  | 'MANAGE_DEVELOPERS_USERS'
  | 'MANAGE_REPORTING_USERS'
  | 'MANAGE_SALES_USERS'
  | 'MANAGE_SALES_PRO_USERS'
  | 'MANAGE_SEQUENCES_LIBRARY_ACCESS'
  | 'MANAGE_USERS_ACCESS'
  | 'MARKETABLE_CONTACTS_ACCESS'
  | 'MARKETABLE_CONTACTS_WRITE'
  | 'MARKETING_BILLING_ACCESS'
  | 'MARKETING_CONTENT_RESTRICTED_WRITE'
  | 'MARKETING_EMAIL_API'
  | 'MARKETING_EMAILS_APPROVE'
  | 'MARKETING_EMAIL_NO_BRANDING'
  | 'MARKETING_EMAIL_NOT_DEMO'
  | 'MARKETING_EMAIL_PUBLISH_API_ACCESS'
  | 'MARKETING_EVENTS_READ'
  | 'MARKETING_EVENTS_WRITE'
  | 'MARKETING_FREE_PRODUCT'
  | 'MARKETING_PRODUCT_ACCESS'
  | 'MARKETING_SETTINGS_READ'
  | 'MARKETING_SETTINGS_WRITE'
  | 'MARKETING_STARTER_PRODUCT'
  | 'MARKETING_TASKS_WRITE'
  | 'MARKETING_TIER_1'
  | 'MARKETING_VIDEO'
  | 'MARKETPLACE_ADMIN'
  | 'MARKETPLACE_AGENT_PROVIDER'
  | 'MARKETPLACE_APP_PROVIDER'
  | 'MARKETPLACE_ASSET_ACCESS'
  | 'MARKETPLACE_ASSET_PROVIDER'
  | 'MARKETPLACE_SELF_SERVE_ADMIN'
  | 'MARKETPLACE_URLS_ADMIN'
  | 'MARS_WRITE_ACCESS'
  | 'MARS_ADMIN_ACCESS'
  | 'MEDIA_BRIDGE_READ'
  | 'MEDIA_BRIDGE_WRITE'
  | 'MEDIA_CAPTURE'
  | 'MEETING_CREATION_ACCESS'
  | 'MEETINGS_EDIT_ALL_LINKS'
  | 'MEETINGS_LINK_CUSTOMIZATION'
  | 'MEETINGS_LINK_EMBED'
  | 'MEETINGS_PERSONAL_LINK_CREATE'
  | 'MEETINGS_TEAM_LINK_CREATE'
  | 'MEETINGS_INSERT_TIMES_NO_VIRAL_LINK'
  | 'MEMBERSHIP_PASSWORDLESS_AUTH'
  | 'MERCHANDISE_PUBLISH'
  | 'MERCHANDISE_READ'
  | 'MERCHANDISE_STAGE'
  | 'MERCHANDISE_WRITE'
  | 'MERCHANT_ABUSE_AUTH_LOG_READ'
  | 'MERCHANT_DOCUMENTS_REQUEST'
  | 'MERCHANT_RISK_REVIEW_NOTIFICATION_READ'
  | 'MERCHANT_RISK_REVIEW_NOTIFICATION_WRITE'
  | 'MERCHANT_UNDERWRITING_READ'
  | 'MERCHANT_UNDERWRITING_CORIS_READ'
  | 'MESSAGING_SUPPORT_TOOLS_ADMIN'
  | 'MESSENGER_FLOWS_ACCESS'
  | 'MARKETING_TRIAL'
  | 'MENUS_WRITE'
  | 'MESSAGING_ACCESS'
  | 'MESSAGING_INFRA_ADMIN'
  | 'MESSAGING_TRUSTED'
  | 'META_READ'
  | 'META_WRITE'
  | 'MIGRATION_RESOLUTION_WRITE'
  | 'MIGRATION_SPECIALIST'
  | 'MIGRATIONS_REPLATFORMING_SPECIALIST'
  | 'MOBILE_CTA_RULE_WRITE'
  | 'MONETIZATION_SERVICE_PURCHASE_MOTIONS_ADMIN'
  | 'MONTHLY_EMAIL'
  | 'MOVA_ADMIN'
  | 'MOVA_READ'
  | 'MOVA_WRITE'
  | 'MULTI_ACCOUNT_COPY_ASSETS_READ'
  | 'MULTI_ACCOUNT_COPY_ASSETS_WRITE'
  | 'MULTI_ACCOUNT_DATA_SHARING_CONTACT_READ'
  | 'MULTI_CURRENCY_READ'
  | 'MULTI_CURRENCY_WRITE'
  | 'CRM_MC_CENTRAL_FX_RATES_ENTERPRISE'
  | 'CRM_MC_CENTRAL_FX_RATES_PRO'
  | 'MULTI_DOMAIN_HOSTING'
  | 'MULTI_DOMAIN_PUBLISHING'
  | 'MULTIPLE_OFFICE_LOCATIONS'
  | 'MYACCOUNTS_VISIBLE'
  | 'MYSQL_SEAMLESS_PORTAL_MIGRATION_SERVICE'
  | 'NAMED_DISCOUNTS_ADMIN'
  | 'NAMED_DISCOUNT_TRANSLATIONS_ADMIN'
  | 'NAV_ELEVATED_JITA_ACCESS'
  | 'NAV_ELEVATED_JITA_ACTIVE'
  | 'NAVIGATION_OPT_IN'
  | 'NETSUITE_READ'
  | 'NO_ACCESS'
  | 'NON_REVENUE_SALES_GOALS_ACCESS'
  | 'NOTIFICATIONS_ACCESS'
  | 'NOTIFICATION_ACCOUNT_DEFAULTS_READ'
  | 'NOTIFICATION_ACCOUNT_DEFAULTS_WRITE'
  | 'NOTIFICATIONS_ADMIN'
  | 'NOTIFICATION_PROFILES_READ'
  | 'NOTIFICATION_PROFILES_WRITE'
  | 'NOTIFICATION_REPORTING_TOOL_ACCESS'
  | 'NOTIFICATION_TOOL_AUTOMATION_ACCESS'
  | 'NOTIFICATION_TOOL_SEND_ACCESS'
  | 'NOTIFICATIONS_ACCOUNT_DEFAULTS_AFFECTED_USER'
  | 'OAUTH'
  | 'OAUTH_ACCESS'
  | 'OAUTH_SCOPES_ADMIN'
  | 'OFFLINE'
  | 'ONBOARDING_CONTACT'
  | 'ONE_TO_ONE_VIDEO'
  | 'OPENID_ACCESS'
  | 'OPS_SYNC_FIELD_MAPPINGS_CUSTOMIZATION_ACCESS'
  | 'OPS_SYNC_USER_LEVEL_ACCESS'
  | 'ORDER_CART_REPORTS'
  | 'OVERRIDE_CRM_THREAD_PERMISSIONS_CHECK_GRANDFATHERED'
  | 'PAGE_SUBCATEGORY_MOVE'
  | 'PAGEBUILDER_DOMAIN_CREATE'
  | 'PAGEBUILDER_DOMAIN_WRITE'
  | 'PAGES_ACCESS'
  | 'PAGES_ANALYTICS'
  | 'PAGES_APPROVAL_READ'
  | 'PAGES_APPROVAL_WRITE'
  | 'WEBSITE_PAGES_APPROVE'
  | 'PAGES_BULK_PUBLISH'
  | 'PAGES_PRIVATE_CONTENT_PUBLISH'
  | 'PAGES_PUBLISH'
  | 'PAGES_PUBLISH_SCHEDULED_UPDATE'
  | 'PAGES_RO'
  | 'PAGES_SCHEDULE'
  | 'PAGES_WRITE'
  | 'PAID_SEAT_ASSIGNMENT_API_ACCESS'
  | 'PARCEL_WRITE'
  | 'PARTNERDB_INTERNAL_READ'
  | 'PARTNER_ACCESS'
  | 'PARTNER_ACCOUNT_OBJECT_ACCESS'
  | 'PARTNER_ACCOUNT_OBJECT_READ'
  | 'PARTNER_ACCOUNT_OBJECT_WRITE'
  | 'PARTNER_ACCOUNT_ONLY_ACCESS'
  | 'PARTNER_ADMIN'
  | 'PARTNER_ADMIN_USER_MANAGEMENT'
  | 'PARTNER_ATTRIBUTION_INTERNAL_READ'
  | 'PARTNER_CERTIFICATIONS'
  | 'PARTNER_CLIENT_OBJECT_ACCESS'
  | 'PARTNER_CLIENT_OBJECT_READ'
  | 'PARTNER_CLIENT_OBJECT_WRITE'
  | 'PARTNER_COMMISSIONS_WRITE'
  | 'PARTNER_COLLAB_CARD_APPROVE'
  | 'PARTNER_COLLAB_CARD_APPROVE_ADMIN'
  | 'PARTNER_COLLAB_CARD_OWNER'
  | 'PARTNER_COLLAB_CARD_WRITE'
  | 'PARTNER_COLLAB_CARD_WRITE_ADMIN'
  | 'PARTNER_DASHBOARD'
  | 'PARTNER_DASHBOARD_WRITE'
  | 'PARTNER_DEAL_REGISTRATION_READ'
  | 'PARTNER_DEAL_REGISTRATION_WRITE'
  | 'PARTNER_DEAL_REGISTRATION_INTERNAL_READ'
  | 'PARTNER_DEAL_REGISTRATION_INTERNAL_WRITE'
  | 'PARTNER_DEAL_REGISTRATION_INTERNAL_WRITE_ALL'
  | 'PARTNER_DIRECTORY'
  | 'PARTNER_DIRECTORY_WRITE'
  | 'PARTNER_DOCUMENTS'
  | 'PARTNER_DOCUMENT_READ'
  | 'PARTNER_DOCUMENT_WRITE'
  | 'PARTNER_DOCUMENT_DOCUMENTS_READ'
  | 'PARTNER_EMPLOYEES_ADMIN_READ'
  | 'PARTNER_EMPLOYEES_ADMIN_WRITE'
  | 'PARTNER_HOME_ACCESS'
  | 'PARTNER_COMMISSION_ACCESS'
  | 'PARTNER_LEAD_REGISTRATION'
  | 'PARTNER_PAYWALL_HIDE'
  | 'PARTNER_POI_INTERNAL_ACCESS'
  | 'PARTNER_PROVIDER_RW'
  | 'PARTNER_SALES_PRO_ACCESS'
  | 'PARTNER_SERVICE_PIPELINE_ACCESS'
  | 'PARTNER_SERVICE_OBJECT_ACCESS'
  | 'PARTNER_SERVICE_OBJECT_READ'
  | 'PARTNER_SERVICE_OBJECT_WRITE'
  | 'PARTNER_SHARED_SELLING_PIPELINE'
  | 'PARTNER_SHARED_VIEW_INTERNAL_ACCESS'
  | 'PARTNER_TOOLS_ACCESS'
  | 'PARTNER_SIGNUP_SALES'
  | 'PARTNER_BIGLYTICS_WRITE'
  | 'PARTNER_BIGLYTICS_READ'
  | 'PARTNER_JOIN_PROGRAM'
  | 'PARTNER_SEAT_ACCESS'
  | 'PAYMENT_LINKS_DELETE'
  | 'PAYMENT_LINKS_READ'
  | 'PAYMENT_LINKS_WRITE'
  | 'PARTNER_REGISTRATION_INTERNAL_READ'
  | 'PAYMENTS_ACCOUNT_WRITE'
  | 'PAYMENTS_CHECKOUT_COMPLETION'
  | 'PAYMENTS_CHECKOUT_SETTINGS_WRITE'
  | 'PAYMENTS_ELIGIBLE'
  | 'PAYMENTS_ENTITIES_WRITE'
  | 'PAYMENTS_EXPORTS'
  | 'PAYMENTS_FRAUD_WRITE'
  | 'PAYMENTS_INTERNAL_READ'
  | 'PAYMENTS_INTERNAL_TRIAGE'
  | 'PAYMENTS_INTERNAL_WRITE'
  | 'PAYMENTS_MANUAL_EMAILS'
  | 'PAYMENTS_PAYOUT_BANK_WRITE'
  | 'PAYMENTS_PAYOUTS'
  | 'PAYMENTS_READ'
  | 'PAYMENTS_SUBSCRIPTION_PROCESSING'
  | 'PAYMENTS_TRANSACTIONS_READ'
  | 'PAYMENTS_TRANSACTIONS_WRITE'
  | 'PAYMENTS_TRUST_READ'
  | 'PAYMENTS_TRUST_WRITE'
  | 'PAYMENTS_WRITE'
  | 'PERMISSION_SETS_APPLY'
  | 'PERMISSION_SETS_READ'
  | 'PERMISSION_SETS_WRITE'
  | 'PERMISSION_TEMPLATE_ACCESS'
  | 'PERMISSIONS_TESTING_ACCESS'
  | 'PERMISSIONS_TESTING_READ'
  | 'PERMISSIONS_TESTING_WRITE'
  | 'PERMISSIONS_TESTING_VIEW_OWNED'
  | 'PERMISSIONS_TESTING_VIEW_TEAM'
  | 'PERMISSIONS_TESTING_VIEW_UNASSIGNED'
  | 'PERMISSIONS_TESTING_VIEW_ALL'
  | 'PERMISSIONS_TESTING_EDIT_OWNED'
  | 'PERMISSIONS_TESTING_EDIT_TEAM'
  | 'PERMISSIONS_TESTING_EDIT_UNASSIGNED'
  | 'PERMISSIONS_TESTING_EDIT_ALL'
  | 'PERMISSIONS_TESTING_DELETE_OWNED'
  | 'PERMISSIONS_TESTING_DELETE_TEAM'
  | 'PERMISSIONS_TESTING_DELETE_UNASSIGNED'
  | 'PERMISSIONS_TESTING_DELETE_ALL'
  | 'PERSONAS_EDIT'
  | 'PERSONAL_ACCESS_KEYS'
  | 'PIPELINE_LEVEL_PERMISSIONS_ACCESS'
  | 'PIPELINE_LEVEL_PERMISSIONS_BYPASS'
  | 'PIPELINE_LEVEL_PERMISSIONS_WRITE'
  | 'PLAYBOOKS_LINKED_QUESTIONS'
  | 'PIPELINE_ORCHESTRATOR_ADMIN'
  | 'PLAYBOOKS_PUBLISH'
  | 'PLAYBOOKS_READ'
  | 'PLAYBOOKS_WRITE'
  | 'PLAYLISTS_ACCESS'
  | 'PLS_ADMIN'
  | 'PLS_BUCKET_SCORE_READ'
  | 'PLS_DASHBOARD'
  | 'PLS_INFER_WITH_HUBSPOT_MODEL'
  | 'PLS_INFER_WITH_CUSTOM_MODEL'
  | 'PLS_NUMBER_SCORE_READ'
  | 'PLS_SCORE_EXPLANATION'
  | 'PODCAST_ACCESS'
  | 'PODCAST_CUSTOM_DOMAIN_READ'
  | 'PODCAST_CUSTOM_DOMAIN_WRITE'
  | 'PODCAST_HS_SITES_DOMAIN_WRITE'
  | 'PODCAST_MULTI_DOMAIN_PUBLISHING'
  | 'PODCAST_SECONDARY_BRAND_DOMAIN'
  | 'PODCASTS_PUBLISH'
  | 'PODCASTS_READ'
  | 'PODCASTS_WRITE'
  | 'PORTAL_DEVELOPERS_ACCESS'
  | 'PORTAL_SESSION_TIMEOUT_CONFIG_READ'
  | 'PORTAL_SESSION_TIMEOUT_CONFIG_WRITE'
  | 'PORTALS_READ'
  | 'PORTALS_WRITE'
  | 'PRECOG_ACCESS'
  | 'PREFERENCES_GROUPS_VIEW_ALL'
  | 'PREMIUM_SIGNALS_TRACKING_DOMAIN_ACCESS'
  | 'PRIVATE_APPS_READ'
  | 'PRIVATE_APPS_WRITE'
  | 'PRIVATE_APPS_TOKEN_READ'
  | 'PRIVATE_APPS_TOKEN_WRITE'
  | 'PRIVATE_APPS_TEMPORARY_TOKEN_READ'
  | 'PRIVATE_APPS_TEMPORARY_TOKEN_WRITE'
  | 'PRODUCT_READ'
  | 'PRODUCT_WRITE'
  | 'PRODUCT_ADMIN'
  | 'PRODUCTS_ADDONS_ACCESS'
  | 'PRODUCT_ASSOCIATION_WRITE'
  | 'PRODUCT_LIBRARY_ALL_DELETE'
  | 'PRODUCT_UPDATES_ADMIN'
  | 'PRODUCT_UPDATES_READ'
  | 'PRODUCT_UPDATES_WRITE'
  | 'PRODUCT_UPDATES_PUBLISH'
  | 'PROGRESSION_READ'
  | 'PROGRESSION_WRITE'
  | 'PROJECTS_ACCESS'
  | 'PROJECTS_GLOBAL_PUBLISHING'
  | 'PROPERTIES_SETTINGS_READ'
  | 'PROPERTIES_SETTINGS_WRITE'
  | 'PROPERTY_CHANGE_EVENT_BETA'
  | 'PROPERTY_FORMATTER_READ'
  | 'PROPERTY_FORMATTER_WRITE'
  | 'PROSPECTING_WORKSPACE_AS_OTHER_VIEW_ACCESS'
  | 'PROSPECTING_WORKSPACE_ACCESS'
  | 'PROTECTED_BY_PRODUCT_SECURITY_WRITE'
  | 'PROVIDER_ANALYTICS_API_ACCESS'
  | 'PROVIDER_NAV_MODE_ACCESS'
  | 'PUBLIC_CONTENT'
  | 'PUBLIC_USERS_READ'
  | 'PUBLIC_USERS_WRITE'
  | 'PUBLISHING_TASK_MIGRATION_PROD_NOTIFY'
  | 'QL_VISIBILITY_READ'
  | 'QL_VISIBILITY_WRITE'
  | 'QL_VISIBILITY_SUBMISSION_READ'
  | 'QL_VISIBILITY_SUBMISSION_WRITE'
  | 'QUOTAS_READ'
  | 'QUOTAS_WRITE'
  | 'QUOTE_ACCESS'
  | 'QUOTE_AUTOMATION'
  | 'QUOTE_APPROVAL_V1_ACCESS'
  | 'QUOTE_CREATE'
  | 'QUOTE_ESIGN_ACCESS'
  | 'QUOTE_ESIGN_LIMIT_INCREASE'
  | 'QUOTE_MANAGE'
  | 'QUOTE_PAYMENT'
  | 'QUOTE_PUBLISH'
  | 'QUOTE_READ'
  | 'QUOTE_TEMPLATES_READ'
  | 'QUOTE_TEMPLATES_WRITE'
  | 'QUOTE_TEMPLATES_CONTENT_WRITE'
  | 'QUOTE_TEMPLATE_LIBRARY_READ'
  | 'QUOTE_TEMPLATE_LIBRARY_WRITE'
  | 'RATE_CARD_EDIT'
  | 'READ_ONLY_JITA_ACCESS'
  | 'READ_ONLY_PIPELINE_STAGE_WRITE'
  | 'READ_WRITE_JITA_ACCESS'
  | 'RECAPTCHA_ANNOTATIONS_WRITE'
  | 'RECAPTCHA_ASSESSMENTS_READ'
  | 'RECAPTCHA_VERIFICATION_ACCESS'
  | 'RECOMMENDED_SEND_TIMES_ACCESS'
  | 'RECURRING_TASKS'
  | 'RECRUITHUB_DATA_READ_ACCESS'
  | 'RECRUITING_OFFERS_DATA_READ_ACCESS'
  | 'RECRUITING_OFFERS_DATA_WRITE_ACCESS'
  | 'REFRESH_TOKEN_READ'
  | 'REPORTING_ACCESS'
  | 'REPORTING_ADMIN'
  | 'REPORTING_BASE_READ'
  | 'REPORTING_CREATE_AND_OWN'
  | 'REPORTING_DATASETS_ACCESS'
  | 'REPORTING_DATASETS_READ'
  | 'REPORTING_DATASETS_WRITE'
  | 'REPORTING_EDIT'
  | 'REPORTING_TEMPLATE_PUBLISH'
  | 'REPORTING_EMAIL_EXTERNAL_RECIPIENTS_ACCESS'
  | 'REPORTS_HOME_READ'
  | 'REPORTS_HOME_WRITE'
  | 'REPORTS_PAGE_VIEW_FILTERING_ACCESS'
  | 'REPORTS_SALES_PRO_ACCESS'
  | 'REPORTS_SETTINGS_ACCESS'
  | 'REPORTS_TQ2_EXPORTS'
  | 'RESEND_INVITE_EMAILS'
  | 'RESTRICTED_DOMAINS_WRITE'
  | 'RESTRICTED_KEYWORDS_WRITE'
  | 'RESTRICTED_TERRITORY_MANAGEMENT_WRITE'
  | 'REVENUE_ANALYTICS'
  | 'REVENUE_ATTRIBUTION_LITE'
  | 'REVENUE_ATTRIBUTION_READ'
  | 'REVENUE_DEAL_SPLITS'
  | 'REVENUE_PROJECT_TEMPLATE_MAPPING_WRITE'
  | 'REVENUE_QUOTE_PARTNER_SEARCH_ACCESS'
  | 'REVERSE_PROXY_DOMAIN_WRITE'
  | 'REVENUE_GOALS_PROD_NOTIFY_SERVICE_ONLY'
  | 'REVENUE_GOALS_ACCESS'
  | 'RPA_EDD_CA'
  | 'RPA_EFTPS'
  | 'RPA_GREENHOUSE'
  | 'RPA_NY'
  | 'RPA_RECRUITHUB'
  | 'RPA_WORKDAY'
  | 'RPA_ACCESS'
  | 'RPA_OSV'
  | 'RPA_MONDAY'
  | 'RPA_LINKEDIN'
  | 'RISK_SIGNAL_READ'
  | 'RISK_SIGNAL_WRITE'
  | 'RISK_SIGNAL_TYPE_READ'
  | 'RISK_SIGNAL_TYPE_WRITE'
  | 'ROLE_META_WRITE'
  | 'SENSITIVE_DATA_ACCESS'
  | 'SENSITIVE_DATA_READ'
  | 'SENSITIVE_DATA_WRITE'
  | 'SENSITIVE_DATA_PROPERTY_CREATE'
  | 'SENSITIVE_DATA_PROPERTY_EDIT'
  | 'SENSITIVE_DATA_PROPERTY_DELETE'
  | 'SENSITIVE_DATA_OPT_IN_ACCESS'
  | 'TEAMS_CAMPAIGN_PARTITIONING'
  | 'TIME_BETWEEN_REPORTS'
  | 'TRANSACTIONSEXPERIENCE_READ'
  | 'TRANSACTIONSEXPERIENCE_WRITE'
  | 'TWO_FACTOR_ADMIN_RECOVERY_READ'
  | 'TWO_FACTOR_ADMIN_RECOVERY_WRITE'
  | 'TWO_FACTOR_AUTH_REQUIRED'
  | 'TWO_FACTOR_REQUIRED_HUBS_WRITE'
  | 'ROLES_READ'
  | 'ROLES_WRITE'
  | 'SALES_CALLING_ACCESS'
  | 'SALES_CALLING_LIMIT_HIGH'
  | 'SALES_CALLING_LIMIT_MEDIUM'
  | 'SALES_CALLING_TRANSCRIBE'
  | 'SALES_COMPANIES_ACCESS'
  | 'SALES_CONTACTS_ACCESS'
  | 'SALES_CONTENT_ADMIN_READ'
  | 'SALES_CONTENT_ADMIN_WRITE'
  | 'SALES_CONTENT_PARTITIONING'
  | 'SALES_CONTENT_TEAM_SHARING'
  | 'SALES_CLIENTS_SUPPORT_ADMIN'
  | 'SALES_DASHBOARD_ACCESS'
  | 'SALES_DEALS_ACCESS'
  | 'SALES_DIRECTORY_ACCESS'
  | 'SALES_DIRECTORY_REPORT_DATA_ACCESS'
  | 'SALES_DOCUMENT_ANALYTICS_API_ACCESS'
  | 'SALES_DOCUMENTS_ACCESS'
  | 'SALES_DOCUMENTS_ANALYTICS'
  | 'SALES_EMAIL_RECOMMENDATION_ACCESS'
  | 'SALES_EMAIL_METRICS'
  | 'SALES_ENTERPRISE_SEAT_ACCESS'
  | 'SALES_ENTERPRISE_TRIAL_SEAT_ACCESS'
  | 'SALES_FCC_ADMIN'
  | 'SALES_GOAL_ASSIGNMENT'
  | 'SALES_HUB_BRANDING'
  | 'SALES_INFRA_INTERNAL_API_ACCESS'
  | 'SALES_MEETINGS_ACCESS'
  | 'SALES_NAV_ACCESS'
  | 'SALES_NAV_MODE_ACCESS'
  | 'SALES_NAVIGATOR'
  | 'SALES_NAVIGATOR_INSTALL'
  | 'SALES_ORDER_CREATION_READ'
  | 'SALES_ORDER_CREATION_WRITE'
  | 'SALES_PRO_PAID'
  | 'SALES_PRO_PRODUCT'
  | 'SALES_PROFESSIONAL_SEAT_ACCESS'
  | 'SALES_PROFESSIONAL_TRIAL_SEAT_ACCESS'
  | 'SALES_PROSPECTS_ACCESS'
  | 'SALES_SETTINGS_ACCESS'
  | 'SALES_SETTINGS_READ'
  | 'SALES_SETTINGS_WRITE'
  | 'SALES_STARTER_SEAT_ACCESS'
  | 'SALES_STREAM_ACCESS'
  | 'SALES_STREAM_ADVANCED_ACCESS'
  | 'SALES_STREAM_PRIORITY'
  | 'SALES_TASKS_ACCESS'
  | 'SALES_TEAM_ANALYTICS'
  | 'SALES_TEMPLATES_ACCESS'
  | 'SALES_TEMPLATES_ANALYTICS'
  | 'SALES_TEMPLATES_PRIVATE_ACCESS'
  | 'SALES_TEMPLATES_SUPPORT_ADMIN'
  | 'SALES_TEMPLATES_API_READ'
  | 'SALES_TEMPLATES_API_WRITE'
  | 'SALESACCELERATOR_ACCESS'
  | 'SALESFORCE_ACCESS'
  | 'SALESFORCE_CAMPAIGN_IMPORT'
  | 'SALESFORCE_COB_SYNC_WRITE_ACCESS'
  | 'SALESFORCE_IMPORT'
  | 'SALESFORCE_SETTINGS_WRITE'
  | 'SANDBOXES_READ'
  | 'SANDBOXES_WRITE'
  | 'SCALED_INFRA_READ_WRITE'
  | 'SCALED_INFRA_READ_ONLY'
  | 'SCHEMAS_METADATA_READ'
  | 'SCHEMAS_METADATA_WRITE'
  | 'SCIM_ACCESS'
  | 'SCIM_SETTINGS_READ'
  | 'SCIM_SETTINGS_WRITE'
  | 'SEAMLESS_PORTAL_MIGRATION_WRITE'
  | 'SELF_REMOVE_USER'
  | 'SEARCH_CRM_CUSTOM_PROPERTIES_WRITE'
  | 'SEATS_ACCESS'
  | 'SEATS_GRACE_PERIOD'
  | 'SECURITY_CENTER_READ'
  | 'SEO_CONTENT_DETAILS_READ'
  | 'SEO_CONTENT_DETAILS_WRITE'
  | 'SEO_CONTENT_EDITOR_READ'
  | 'SEO_LINKS_READ'
  | 'SEO_LINKS_WRITE'
  | 'SEO_RECOMMENDATIONS_HOME_READ'
  | 'SEO_RECOMMENDATIONS_HOME_WRITE'
  | 'SEQUENCE_ANALYTICS_API_ACCESS'
  | 'SEQUENCE_SENDER_SCORE_REPORT'
  | 'SEQUENCES_AB_TESTING'
  | 'SEQUENCES_ANALYTICS'
  | 'SEQUENCES_BULK_ENROLL'
  | 'SEQUENCES_BULK_ENROLL_WRITE'
  | 'SEQUENCES_DEAL_REPORTS_ACCESS'
  | 'SEQUENCES_ENROLLMENTS_WRITE_ACCESS'
  | 'SEQUENCES_ENTERPRISE_DAILY_ENROLL_LIMIT'
  | 'SEQUENCES_PROFESSIONAL_DAILY_ENROLL_LIMIT'
  | 'SEQUENCES_PAUSING_STEPS'
  | 'SEQUENCES_READ'
  | 'SEQUENCES_REPORTS_ACCESS'
  | 'SEQUENCES_WORKFLOWS_ACTIONS'
  | 'SEQUENCES_WORKFLOWS_ACTIONS_CONTEXTUAL'
  | 'SEQUENCES_WRITE'
  | 'SEQUENCES_MAX_EMAIL_SEND_LIMIT'
  | 'SEQUENCES_SUPPORT_ADMIN'
  | 'SERVERLESS_APP_FUNCTIONS'
  | 'SERVERLESS_FUNCTIONS'
  | 'SERVERLESS_FUNCTIONS_LOGS'
  | 'SERVERLESS_FUNCTIONS_READ'
  | 'SERVERLESS_FUNCTIONS_WRITE'
  | 'SERVERLESS_FUNCTIONS_SECRETS_READ'
  | 'SERVERLESS_FUNCTIONS_SECRETS_WRITE'
  | 'SERVICE_ACCESS'
  | 'SERVICE_ARTICLES_ACCESS'
  | 'SERVICE_CATALOG_READ'
  | 'SERVICE_CATALOG_WRITE'
  | 'SERVICE_CONTENT_RESTRICTED_WRITE'
  | 'SERVICE_DELIVERY_ACCESS'
  | 'SERVICE_DELIVERY_BILLING_CRM_CREATE'
  | 'SERVICE_DELIVERY_HOURS_LOGGING_ENTRIES_READ'
  | 'SERVICE_DELIVERY_HOURS_LOGGING_ENTRIES_WRITE'
  | 'SERVICE_DELIVERY_HOURS_LOGGING_ENTRIES_ADMIN'
  | 'SERVICE_DELIVERY_HOURS_LOGGED_ENTRY_TYPE_ADMIN'
  | 'SERVICE_DELIVERY_INTERNAL_ADMIN'
  | 'SERVICE_ENTERPRISE_SEAT_ACCESS'
  | 'SERVICE_ENTERPRISE_TRIAL_SEAT_ACCESS'
  | 'SERVICE_FEEDBACK_SUBMIT'
  | 'SERVICE_FEEDBACK_ACCESS'
  | 'SERVICE_FEEDBACK_EDITOR_READ'
  | 'SERVICE_FEEDBACK_SURVEY_WRITE'
  | 'SERVICE_GOALS_ACCESS'
  | 'SERVICE_KNOWLEDGE_ACCESS'
  | 'SERVICE_KNOWLEDGE_ARTICLE_PUBLISH'
  | 'SERVICE_KNOWLEDGE_ARTICLE_SMARTCONTENT'
  | 'SERVICE_KNOWLEDGE_ARTICLE_WRITE'
  | 'SERVICE_KNOWLEDGE_CUSTOM_DOMAIN_WRITE'
  | 'SERVICE_KNOWLEDGE_CUSTOM_DOMAIN_READ'
  | 'SERVICE_KNOWLEDGE_HS_SITES_DOMAIN_WRITE'
  | 'SERVICE_PROFESSIONAL_SEAT_ACCESS'
  | 'SERVICE_PROFESSIONAL_TRIAL_SEAT_ACCESS'
  | 'SERVICE_STARTER_SEAT_ACCESS'
  | 'SERVICE_TEAM_ANALYTICS'
  | 'SERVICE_WIDGET_ACCESS'
  | 'SERVICEMARKETPLACE_ACCESS'
  | 'SETTINGS_ACCESS'
  | 'SETTINGS_PRODUCTS_ACCESS'
  | 'SHARED_DEALS_INDEX_PAGE_READ'
  | 'SHOW_MKTNG_LEAD_REVISIT_PREFS'
  | 'SIDEKICK_ADMIN'
  | 'SIDEKICK_CALENDAR_PRODUCT'
  | 'SIDEKICK_FEATURES_ACCESS'
  | 'SIDEKICK_JITA_ACCESS'
  | 'SIDEKICK_REVIEW_GUIDE_READ'
  | 'SINGLE_SEND_API_ONBOARDING'
  | 'SITEHEALTH_READ'
  | 'SITEHEALTH_WRITE'
  | 'SITEMAPS_READ'
  | 'SITEMAPS_WRITE'
  | 'SITE_EXPORT'
  | 'SITEPAGES_AUTO_TRANSLATE'
  | 'SITEPAGES_BULK_DOMAIN_CHANGE'
  | 'SITEPAGES_MULTILANGUAGE'
  | 'SITEPAGES_HS_SITES_DOMAIN_WRITE'
  | 'SITEPAGES_PASSWORD_PROTECTION'
  | 'SITEPAGES_SMARTCONTENT'
  | 'SITE_PAGES_ACCESS'
  | 'SITE_PAGES_CUSTOM_DOMAIN_ACCESS'
  | 'SITE_PAGES_CUSTOM_DOMAIN_WRITE'
  | 'SITE_PAGES_CUSTOM_DOMAIN_READ'
  | 'SITE_PAGES_USER_LIMIT'
  | 'SITE_SEARCH_READ'
  | 'SITE_SETTINGS_READ'
  | 'SITE_SETTINGS_WRITE'
  | 'SKILLS_ACCESS'
  | 'SKILLS_READ'
  | 'SKILLS_WRITE'
  | 'SKU_MIGRATION_CONFIDENTIAL_DATA_READ'
  | 'SLA_READ'
  | 'SLA_WRITE'
  | 'SLOW_ROLLOUT_ACCESS'
  | 'SMART_COMPOSE'
  | 'SMARTCONTENT'
  | 'SMS_PRODUCT_ACCESS'
  | 'SMS_MARKETING_ADDON'
  | 'SMS_PUBLISH'
  | 'SMS_READ'
  | 'SMS_VIEW'
  | 'SMS_CRM_VIEW_ALL'
  | 'SMS_WRITE'
  | 'SMS_EDIT'
  | 'SMS_SETTINGS_MANAGER_ACCESS'
  | 'SNIPPETS_ACCESS'
  | 'SNIPPETS_LIMITED_READ'
  | 'SNIPPETS_LIMITED_WRITE'
  | 'SNIPPETS_READ'
  | 'SNIPPETS_WRITE'
  | 'SNOWFLAKE_DATA_SHARING'
  | 'SNOWFLAKE_DATA_SHARING_WRITE'
  | 'SOCIAL_ACCESS'
  | 'SOCIAL_TRUSTED'
  | 'SOCIAL_ACCOUNTS_CONNECT'
  | 'SOCIAL_ACCOUNTS_SETUP'
  | 'SOCIAL_ALL_ACCOUNTS_CONFIGURE'
  | 'SOCIAL_ALL_ACCOUNTS_DRAFT'
  | 'SOCIAL_ALL_ACCOUNTS_PUBLISH'
  | 'SOCIAL_ALL_ACCOUNTS_READ'
  | 'SOCIAL_CORPORATE_ACCESS'
  | 'SOCIAL_DRAFT_ONLY_USER_ACCESS'
  | 'SOCIAL_FACEBOOK_PAGE_ACCESS'
  | 'SOCIAL_FACEBOOK_PERSONAL_ACCESS'
  | 'SOCIAL_GLOBAL_SETTINGS_CONFIGURE'
  | 'SOCIAL_GOOGLEPLUS_ACCESS'
  | 'SOCIAL_INSTAGRAM_PAGE_ACCESS'
  | 'SOCIAL_LINKEDIN_PAGE_ACCESS'
  | 'SOCIAL_LINKEDIN_PERSONAL_ACCESS'
  | 'SOCIAL_MARKETING'
  | 'SOCIAL_OWNED_ACCOUNTS_PUBLISH'
  | 'SOCIAL_PUBLISH'
  | 'SOCIAL_SHARE_ACCOUNTS'
  | 'SOCIAL_SHARED_ACCOUNTS_CONFIGURE'
  | 'SOCIAL_SHARED_ACCOUNTS_DRAFT'
  | 'SOCIAL_SHARED_ACCOUNTS_PUBLISH'
  | 'SOCIAL_TWITTER_ACCESS'
  | 'SOCIAL_WEEKLY_EMAIL'
  | 'SOCIAL_WRITE'
  | 'SOCIAL_YOUTUBE_ACCESS'
  | 'SOCIAL_ADMIN_TOOLS_ACCESS'
  | 'SOCIAL_MONITORING_FEATURES'
  | 'SOCIAL_NETWORK_REPORTING'
  | 'SOCIAL_BULK_UPLOAD'
  | 'SOLUTIONS_PARTNER_NAV_ACCESS'
  | 'SOLUTIONS_PROVIDER_NAV_ACCESS'
  | 'SOURCES_ACCESS'
  | 'SOURCES_ANALYTICS'
  | 'SOURCE_CODE_READ'
  | 'SOURCE_CODE_WRITE'
  | 'SPA_GENERAL_ACCESS'
  | 'SPM_READ'
  | 'SPM_WRITE'
  | 'SPM_PAID_ACCESS'
  | 'SSO_REQUIRE_WRITE'
  | 'SSO_SETTINGS_READ'
  | 'SSO_SETTINGS_WRITE'
  | 'STARTER_GROWTH_THEME_DELIVERY'
  | 'STRATEGIC_INTEGRATIONS_ADMIN'
  | 'STRUCTURED_CONTENT_READ'
  | 'SUBSCRIPTION_GROUPS_WRITE'
  | 'SUBSCRIPTION_STATUS_READ_WRITE'
  | 'SUBSCRIPTION_STATUS_READ'
  | 'SUBSCRIPTION_STATUS_WRITE'
  | 'SUBSCRIPTION_STATUS_RESUBSCRIBE_WRITE'
  | 'SUBSCRIPTION_DEFINITIONS_READ'
  | 'SUBSCRIPTION_TEAM_ANALYTICS'
  | 'SUBSCRIPTION_TYPE_EDIT_ALL_ACCESS'
  | 'SUBSCRIPTIONS_CRM_DATA_WRITE'
  | 'SUBSCRIPTIONS_ACCESS'
  | 'SUBSCRIPTIONS_READ'
  | 'SUBSCRIPTIONS_WRITE'
  | 'SUBSIDIARIES_READ'
  | 'SUBSIDIARIES_WRITE'
  | 'SUCCESS_ACCESS'
  | 'SUCCESS_ASSIGN_ACCESS'
  | 'SUCCESS_ASSIGN_WRITE'
  | 'SUCCESS_AUTOMATION_ACCESS'
  | 'SUCCESS_EMAIL_WRITE'
  | 'SUCCESS_FACEBOOK_WRITE'
  | 'SUCCESS_FOLDERS_WRITE'
  | 'SUCCESS_PLANS_PUBLISHING'
  | 'SUCCESS_REPLY_WRITE'
  | 'SUCCESS_SETTINGS_NPS_WRITE'
  | 'SUCCESS_SETTINGS_SOURCES_WRITE'
  | 'SUCCESS_SETTINGS_FOLDERS_AND_TAGS_WRITE'
  | 'SUCCESS_TAGS_READ'
  | 'SUCCESS_TAGS_WRITE'
  | 'SUCCESS_WIDGET_WRITE'
  | 'SUPER_ADMIN'
  | 'SUPER_JITA_ACCESS'
  | 'SUPER_USER'
  | 'SUSPENDED'
  | 'SUSPICIOUS_KEYWORDS_READ'
  | 'SUSPICIOUS_KEYWORDS_WRITE'
  | 'SYNC_ROLE_RULE_APPROVE'
  | 'SYSTEM_PAGES_NO_BRANDING'
  | 'TAGS_ADMIN'
  | 'TALLY_PRODUCT'
  | 'TASK_PIPELINES_ACCESS'
  | 'TASKS_EDIT_ALL'
  | 'TASKS_EDIT_OWNED_ONLY'
  | 'TASKS_EDIT_TEAM_ONLY'
  | 'TASKS_EDIT_UNASSIGNED'
  | 'TASKS_SUPPORT_WRITE'
  | 'TASKS_VIEW_ALL'
  | 'TASKS_VIEW_ALL_QUEUES'
  | 'TASKS_VIEW_TEAM_ONLY'
  | 'TASKS_VIEW_UNASSIGNED'
  | 'TAX_RATE_GROUP_ACCESS'
  | 'TAX_RATE_GROUP_READ'
  | 'TAX_RATE_GROUP_WRITE'
  | 'TEAMS_ACCESS'
  | 'TEAMS_ADVANCED_MODELING_ACCESS'
  | 'TEAMS_CONTENT_PARTITIONING'
  | 'TEAMS_FORM_PARTITIONING'
  | 'TEAMS_MARKETING_EMAIL_PARTITIONING'
  | 'TEAMS_MULTITEAM_ACCESS'
  | 'TEAMS_READ'
  | 'TEAMS_SOCIAL_PARTITIONING'
  | 'TEAMS_WRITE'
  | 'THEMED_CONTENT_CREATOR_ACCESS'
  | 'TEMPLATE_ACCESS'
  | 'TEMPLATES_LIMITED_READ'
  | 'TEMPLATES_LIMITED_WRITE'
  | 'TEMPLATES_READ'
  | 'TEMPLATES_WRITE'
  | 'TEMPLATES_REPORTS_ACCESS'
  | 'TERRITORY_MANAGEMENT_WRITE'
  | 'TERRITORY_WRITE'
  | 'TEST_SHORTER_FREQUENCY_SUBSCRIPTION_FLOW'
  | 'THEMES_ACCESS'
  | 'TICKETS_ACCESS'
  | 'TICKETS_READ'
  | 'TICKETS_SENSITIVE_DATA_READ'
  | 'TICKETS_SENSITIVE_DATA_WRITE'
  | 'TICKETS_WRITE'
  | 'TICKETS_REPORTS_ACCESS'
  | 'TIMELINE_EMBED_READ'
  | 'TIMELINE_EMBED_WRITE'
  | 'TIMELINE_READ'
  | 'TIMELINE_WRITE'
  | 'TOPIC_CLUSTERS_ACCESS'
  | 'TOPIC_CLUSTERS_REPORTS_ACCESS'
  | 'TRACKED_TERMS_ACCESS'
  | 'TRACKED_TERMS_READ'
  | 'TRACKED_TERMS_WRITE'
  | 'TRACKING_URLS_ACCESS'
  | 'TRACKING_URLS_WRITE'
  | 'TRAFFIC_ANALYTICS_API_ACCESS'
  | 'TRANSACTION_APPLICATIONS_READ'
  | 'TRANSACTIONAL_EMAIL_API'
  | 'TRANSACTIONAL_EMAIL_BULK'
  | 'TRANSACTIONAL_EMAIL_SMTP'
  | 'TRANSACTIONAL_EMAIL'
  | 'TRIALS_DELETE_ACCESS'
  | 'TRIALS_FREE_PRODUCT'
  | 'TRIALS_STARTER_PRODUCT'
  | 'TRUST_WRITE'
  | 'TWO_FACTOR_AUTH_ADMIN'
  | 'TWO_FACTOR_DIRECT_SUPPORT'
  | 'UNDERWRITER_CONFIG_READ'
  | 'UNDERWRITER_CONFIG_WRITE'
  | 'UNDERWRITER_REVIEWS_READ'
  | 'UNDERWRITER_REVIEWS_WRITE'
  | 'UNRESTRICTED_JITA_ACCESS'
  | 'UNTRUSTED_SCOPES_NAMESPACE_CONFIG_READ'
  | 'UNTRUSTED_SCOPES_NAMESPACE_CONFIG_WRITE'
  | 'URL_BLOCKLISTS_WRITE'
  | 'URL_REDIRECTS_READ'
  | 'URL_REDIRECTS_PUBLISH'
  | 'URL_TARGETTING_CONTAINS_RULE_ACCESS'
  | 'URL_TARGETTING_EXCLUSION_ACCESS'
  | 'URL_TARGETTING_QUERY_PARAM_ACCESS'
  | 'USER_ACTION_AUDITS_BASE_READ'
  | 'USER_ACTION_AUDITS_READ'
  | 'USER_ACTION_SINGLE_AUDIT_READ'
  | 'USER_ACTION_REPORTING_USER_PROFILE_BASE'
  | 'USER_ACTION_REPORTING_USER_PROFILE'
  | 'USER_GROUPS_READ'
  | 'USER_GROUPS_WRITE'
  | 'USERS_EXPORT'
  | 'USERS_GDPR_DELETE'
  | 'USERS_NON_PAID_ROLES_WRITE'
  | 'USER_OBJECT_ACCESS'
  | 'USER_OBJECT_READ'
  | 'USER_OBJECT_WRITE'
  | 'USER_IMPORT_READ'
  | 'USER_IMPORT_WRITE'
  | 'USERS_READ'
  | 'USERS_WRITE'
  | 'USERS_PERMISSION_WRITE'
  | 'USER_PERMISSION_PAGE_VIEW'
  | 'USER_PERMISSION_ANALYSIS_READ'
  | 'USER_DEACTIVATION'
  | 'USER_WRITE_INTERNAL_SIGNUP'
  | 'UTM_ANALYTICS'
  | 'UTM_ANALYTICS_API_ACCESS'
  | 'VALUE_OVERVIEW_ACCESS'
  | 'VAST_TEMPLATE_DELIVERY'
  | 'VERIFIED_EMAIL'
  | 'VETTING_TRUST_ADMIN'
  | 'VIDEO_ANALYTICS_API_ACCESS'
  | 'VIES_VAT_READ'
  | 'VIEW_DEAL_AMOUNT_CALCULATOR_SETTINGS'
  | 'VIEW_ONLY_SEAT_ACCESS'
  | 'VISITOR_EXPERIENCE_IP_BLOCKING'
  | 'VISITOR_IDENTIFICATION_ACCESS'
  | 'VISITOR_IDENTIFICATION_PROXY_ACCESS'
  | 'WEB_ANALYTICS_API_ACCESS'
  | 'WEBSITE_PAGES_NO_BRANDING'
  | 'WEBSITE_SETTINGS_ACCESS'
  | 'WEBSITE_SYSTEM_PAGES_WRITE'
  | 'WEBSITE_THEME_WRITE_ACCESS'
  | 'WORKATO_HIGH_RISK_ASSIGNMENT_MANAGE'
  | 'WORKATO_HIGH_RISK_PERMISSIONS_MANAGE'
  | 'WORKATO_HIGH_RISK_AI_ACCESS'
  | 'WORKFLOWS_ACTION_SETS_ACCESS'
  | 'WORKFLOWS_AB_TEST_BRANCH_ACCESS'
  | 'WORKFLOWS_ACCESS'
  | 'WORKFLOWS_ACCESS_PUBLIC_API'
  | 'WORKFLOWS_APP_ACCESS'
  | 'WORKFLOWS_ANOMALY_NOTIFICATIONS'
  | 'WORKFLOWS_ASSIGNMENT_ACCESS'
  | 'WORKFLOWS_ASSIGNMENT_ACCESS_GRANDFATHERED'
  | 'WORKFLOWS_ASSIGNMENT_ACCESS_LEGACY'
  | 'WORKFLOWS_CONTEXTUAL_MARKETING_FREE'
  | 'WORKFLOWS_CONTEXTUAL_MARKETING_STARTER'
  | 'WORKFLOWS_CONTEXTUAL_MARKETING_PRO'
  | 'WORKFLOWS_CONTEXTUAL_MARKETING_ENTERPRISE'
  | 'WORKFLOWS_CUSTOM_CODE_ACCESS'
  | 'WORKFLOWS_DEALS_ACCESS'
  | 'WORKFLOWS_DELETE_ALL'
  | 'WORKFLOWS_DELETE_TEAM_OWNED'
  | 'WORKFLOWS_EDIT_ALL'
  | 'WORKFLOWS_EDIT_TEAM_OWNED'
  | 'WORKFLOWS_EMAIL_ACCESS'
  | 'WORKFLOWS_FORMAT_DATA_ACCESS'
  | 'WORKFLOWS_INTERNAL_EMAIL_ACCESS'
  | 'WORKFLOWS_INTRO_ACCESS'
  | 'WORKFLOWS_MARKETING_EMAIL_ACCESS'
  | 'WORKFLOWS_PLATFORM_DEALS_ACCESS'
  | 'WORKFLOWS_RISK_NOTIFICATIONS'
  | 'WORKFLOWS_ROTATE_LEADS_ACCESS'
  | 'WORKFLOWS_SLACK_ACCESS'
  | 'WORKFLOWS_STATIC_LIST_ACCESS'
  | 'WORKFLOWS_TICKETS_ACCESS'
  | 'WORKFLOWS_QUOTES_ACCESS'
  | 'WORKFLOWS_VIEW_ALL'
  | 'WORKFLOWS_VIEW_TEAM_OWNED'
  | 'WORKFLOWS_ADMIN_ASSIGN_TEAMS'
  | 'WORKFLOWS_ASSIGN_TEAMS_ACCESS'
  | 'WORKFLOWS_WEBHOOK_ACCESS'
  | 'WORKFLOWS_WEBHOOK_TRIGGERS_ACCESS'
  | 'WORKFLOWS_PLATFORM_EMAIL_NOTIFICATION_ACCESS'
  | 'WORKFLOWS_PLATFORM_CREATE_TASK_ACCESS'
  | 'WORKFLOWS_BASELINE_ACTION_ACCESS'
  | 'WORKFLOWS_DEALS_BASELINE_ACTION_ACCESS'
  | 'WORKFLOWS_TICKETS_BASELINE_ACTION_ACCESS'
  | 'WORKFLOWS_QUOTES_BASELINE_ACTION_ACCESS'
  | 'WORKFLOWS_CONTEXTUAL_AUTOMATED_EMAIL_ACCESS'
  | 'WORKFLOWS_PERMISSION_DELETE_TEAM_OWNED'
  | 'WORKFLOWS_PERMISSION_EXPORT_TEAM_OWNED'
  | 'WORKFLOWS_PERMISSION_CLONE_TEAM_OWNED'
  | 'WORKFLOWS_PERMISSION_MOVE_TEAM_OWNED'
  | 'WORKFLOWS_PERMISSION_RESTORE_TEAM_OWNED'
  | 'WORKFLOWS_PERMISSION_ASSIGN_TEAM_OWNED'
  | 'WORKFLOWS_PERMISSION_ENABLE_TEAM_OWNED'
  | 'WORKFLOWS_PERMISSION_DISABLE_TEAM_OWNED'
  | 'WORKFLOWS_PERMISSION_EDIT_ACTIONS_TEAM_OWNED'
  | 'WORKFLOWS_PERMISSION_EDIT_ENROLLMENT_TEAM_OWNED'
  | 'WORKFLOWS_PERMISSION_EDIT_REENROLLMENT_TEAM_OWNED'
  | 'WORKFLOWS_PERMISSION_MANUAL_ENROLL_TEAM_OWNED'
  | 'WORKFLOWS_PERMISSION_TEST_WORKFLOW_TEAM_OWNED'
  | 'WORKFLOWS_PERMISSION_SET_GOAL_TEAM_OWNED'
  | 'WORKFLOWS_PERMISSION_EDIT_DESCRIPTION_TEAM_OWNED'
  | 'WORKFLOWS_PERMISSION_COMMENT_TEAM_OWNED'
  | 'WORKFLOWS_PERMISSION_CREATE_WORKFLOW_TEAM_OWNED'
  | 'WORKFLOWS_PERMISSION_EDIT_SETTINGS'
  | 'WORKFLOWS_TEMPLATE_BUILDER_ACCESS'
  | 'WORKFLOWS_TEMPLATE_BUILDER_CREATE_TEMPLATE_BUTTON'
  | 'WORKFLOWS_TEMPLATE_BUILDER_UPDATE_TEMPLATE_BUTTON'
  | 'WORKFLOWS_SECRETS_ACCESS'
  | 'WRITE_DEAL_AMOUNT_CALCULATOR_SETTINGS'
  | 'XACTLY_INTEGRATION_ACCESS'
  | 'ZAPIER_ACCESS'
  | 'ZORSE_ADMINISTRATION'
  | 'ZORSE_AGENT'
  | 'ZORSE_CALLBACK'
  | 'ZORSE_CHAT'
  | 'ZORSE_CHATFLOW_TARGETING_ENTERPRISE'
  | 'ZORSE_CHATFLOW_TARGETING_PRO'
  | 'ZORSE_CHATFLOW_TARGETING_STARTER'
  | 'ZORSE_DASHBOARD_ACCESS'
  | 'ZORSE_DATA_DELETION'
  | 'ZORSE_FEEDBACK'
  | 'ZORSE_FORUM'
  | 'ZORSE_NPS_SPECIALIST'
  | 'ZORSE_SETTING_ACCESS'
  | 'ZORSE_SETTING_PROMPT_TESTER'
  | 'ZORSE_STATUS_ACCESS'
  | 'ZORSE_SUGGESTED_ARTICLES_ACCESS'
  | 'ZORSE_SUGGESTED_TICKETS_ACCESS'
  | 'ZORSE_SUPPORT_INBOX_ACCESS'
  | 'ZORSE_SUPPORT_INBOX_ADMIN'
  | 'ZORSE_WEBTICKET'
  | 'COMPANIES_VIEW_ALL'
  | 'COMPANIES_VIEW_TEAM'
  | 'COMPANIES_VIEW_UNASSIGNED'
  | 'COMPANIES_EDIT_ALL'
  | 'COMPANIES_EDIT_OWNED'
  | 'COMPANIES_EDIT_TEAM'
  | 'COMPANIES_EDIT_UNASSIGNED'
  | 'COMPANIES_DELETE_ALL'
  | 'COMPANIES_DELETE_OWNED'
  | 'COMPANIES_DELETE_TEAM'
  | 'COMPANIES_DELETE_UNASSIGNED'
  | 'COMPANIES_COMMUNICATE_ALL'
  | 'COMPANIES_COMMUNICATE_OWNED'
  | 'COMPANIES_COMMUNICATE_TEAM'
  | 'COMPANIES_COMMUNICATE_UNASSIGNED'
  | 'PLAN_CHANGE_ACCESS'
  | 'EXTERNAL_INTEGRATIONS_FORMS_ACCESS'
  | 'PIPELINE_STAGE_CALCULATED_PROPERTIES_WRITE'
  | 'ONBOARDING_CMS_STARTER'
  | 'ONBOARDING_CMS_PRO'
  | 'ONBOARDING_CMS_ENTERPRISE'
  | 'ONBOARDING_MARKETING_STARTER'
  | 'ONBOARDING_MARKETING_PRO'
  | 'ONBOARDING_MARKETING_ENTERPRISE'
  | 'ONBOARDING_OPS_STARTER'
  | 'ONBOARDING_OPS_PRO'
  | 'ONBOARDING_OPS_ENTERPRISE'
  | 'ONBOARDING_SALES_STARTER'
  | 'ONBOARDING_SALES_PRO'
  | 'ONBOARDING_SALES_ENTERPRISE'
  | 'ONBOARDING_SERVICE_STARTER'
  | 'ONBOARDING_SERVICE_PRO'
  | 'ONBOARDING_SERVICE_ENTERPRISE'
  | 'ONBOARDING_HSOC_CORE_SEATS_PROFESSIONAL'
  | 'ONBOARDING_HSOC_CORE_SEATS_ENTERPRISE'
  | 'ONBOARDING_HSOC_FRONT_OFFICE_SEATS_PROFESSIONAL'
  | 'ONBOARDING_HSOC_FRONT_OFFICE_SEATS_ENTERPRISE'
  | 'ONBOARDING_PROFESSIONAL_CORE_SEAT'
  | 'ONBOARDING_ENTERPRISE_CORE_SEAT'
  | 'WALKTHROUGH_GUIDES_UNLIMITED_ACCESS'
  | 'CRM_BOARD_SETTINGS_ALL_PIPELINES'
  | 'CRM_BOARD_SETTINGS_PER_PIPELINE'
  | 'PRIVACY_CENTER_SEND_DATA_SUBJECT_ACCESS_REQUEST'
  | 'WORKFLOWS_LEADS_ACCESS'
  | 'LEADS_READ'
  | 'SECURITY_CENTER_INTERNAL_ADMIN'
  | 'DEAL_MANAGEMENT_ENTERPRISE_ACCESS'
  | 'ATO_INVESTIGATIONS_WRITE'
  | 'ADMIN_MIGRATE_HD'
  | 'DEAL_MANAGEMENT_ADVANCED_ACCESS'
  | 'BI_GDPR_REQUESTS_READ'
  | 'BI_GDPR_REQUESTS_WRITE'
  | 'WEBSITE_SECONDARY_BRAND_DOMAIN'
  | 'BLOG_SECONDARY_BRAND_DOMAIN'
  | 'LANDING_SECONDARY_BRAND_DOMAIN'
  | 'EMAIL_SECONDARY_BRAND_DOMAIN'
  | 'KB_SECONDARY_BRAND_DOMAIN'
  | 'LANDINGPAGES_TEAMS_PARTITIONING'
  | 'SITEPAGES_TEAMS_PARTITIONING'
  | 'BLOG_POSTS_TEAMS_PARTITIONING'
  | 'BLOG_LISTING_PAGE_TEAMS_PARTITIONING'
  | 'CV_AI_CHATBOT_USER'
  | 'ORDERS_READ'
  | 'ORDERS_WRITE'
  | 'CRM_MULTIPLE_PIPELINES_ORDERS'
  | 'CRM_VIEWS_ALL_ORDERS'
  | 'ORDER_LINE_ITEM_READ'
  | 'ORDER_LINE_ITEM_WRITE'
  | 'CARTS_READ'
  | 'CARTS_WRITE'
  | 'CRM_MULTIPLE_PIPELINES_CARTS'
  | 'CRM_VIEWS_ALL_CARTS'
  | 'CART_LINE_ITEM_READ'
  | 'CART_LINE_ITEM_WRITE'
  | 'HELP_DESK_ROUTING'
  | 'LAUNCH_BETA_REQUESTS_ACCESS'
  | 'PRE_RENDERING_CONTROL'
  | 'IMAGE_GENERATION_ACCESS'
  | 'CRM_EXPORT_WITHOUT_APPROVAL'
  | 'CRM_EXPORTS_APPROVE'
  | 'CALLING_IVR_WRITE'
  | 'CALLING_IVR_READ'
  | 'PROSPECT_IDEA_TRACKER_ADMIN'
  | 'HELP_DESK_REPLY_RECOMMENDATIONS'
  | 'SEATS_ADMIN'
  | 'REVENUE_RECOGNITION_READ'
  | 'REVENUE_RECOGNITION_WRITE'
  | 'MH_LEAD_SCORING_VIEW'
  | 'MH_LEAD_SCORING_EDIT'
  | 'MEETINGS_VIEW_ALL'
  | 'CALLS_VIEW_ALL'
  | 'CALLS_VIEW_TEAM'
  | 'MEETINGS_VIEW_TEAM'
  | 'MEETINGS_VIEW_UNASSIGNED'
  | 'CALLS_VIEW_UNASSIGNED'
  | 'SEQUENCES_VIEW'
  | 'SEQUENCES_EDIT'
  | 'SEQUENCES_DELETE'
  | 'USER_OBJECT_CUSTOM_PROPERTY_ACCESS'
  | 'USER_OBJECT_CUSTOM_PROPERTY_READ'
  | 'USER_OBJECT_CUSTOM_PROPERTY_WRITE'
  | 'USER_OBJECT_CUSTOM_PROPERTY_DELETE'
  | 'GLOBAL_NAVIGATIONS_ADMIN'
  | 'LEADS_WRITE'
  | 'FILE_MANAGER_SENSITIVE_ACCESS'
  | 'MERCHANT_DOCUMENTS_REQUEST_READ'
  | 'MERCHANT_DOCUMENTS_READ'
  | 'ROUTING_ENRICHMENT_PIPELINE_CONFIG_WRITE'
  | 'CASE_STUDY_READ'
  | 'CASE_STUDY_WRITE'
  | 'CASE_STUDY_PUBLISH'
  | 'CASE_STUDY_SETTINGS_WRITE'
  | 'DEMO_CONFIG_PRODUCT_TIER_CHANGE_MANAGE'
  | 'CONTENT_TYPE_SCHEMA_READ'
  | 'CONTENT_TYPE_SCHEMA_WRITE'
  | 'CONTENT_TYPE_OPTION_WRITE'
  | 'DWI_SQL_SCHEDULER_EU'
  | 'CRM_PIPELINES_LEAD_TAG_ACCESS'
  | 'SERVICES_OBJECT_ACCESS'
  | 'SERVICES_OBJECT_READ'
  | 'SERVICES_OBJECT_WRITE'
  | 'CRM_PIPELINES_LEAD_TAG_WRITE'
  | 'CRM_PIPELINES_LEAD_TAG_PER_PIPELINE_ACCESS'
  | 'CRM_PIPELINES_LEAD_TAG_READ_PRE_SEAT'
  | 'HSFX_DISCOUNT_ELIGIBILITY_REMOVAL'
  | 'CONVERSATIONS_MESSAGE_HIDING'
  | 'CRM_PIPELINES_LEAD_TAG_READ'
  | 'UBB_BILLING_WRITE'
  | 'HELPDESK_UPGRADE'
  | 'PRODUCT_UPDATES_APPROVAL'
  | 'ONBOARDING_DATA_SYNC_WRITE'
  | 'CRM_SCP_LEADS_ACCESS'
  | 'BULK_ENRICHMENT_OVERRIDE_ACCESS'
  | 'ABUSEDESK_FEEDBACK_WRITE'
  | 'CRM_SCP_LEADS_BACKFILL'
  | 'SEQUENCE_SEND_TEAM_EMAIL_ADDRESS'
  | 'AI_LANDING_PAGES_ACCESS'
  | 'ENRICHMENT_CONTACTS_READ'
  | 'LISTS_AI_ASSISTANT_ACCESS'
  | 'LEGACYING_MIGRATIONS_SCHEDULING_OPT_IN'
  | 'LEGACYING_MIGRATIONS_GRANTED_CORE_SEATS'
  | 'CONTENT_REACT_DATA_FETCHING'
  | 'UBB_USAGE_READ'
  | 'UBB_USAGE_WRITE'
  | 'PORTABILITY_SYNC_READ'
  | 'PORTABILITY_SYNC_WRITE'
  | 'USER_EMAILS_DOMAIN_CHANGE_ACCESS'
  | 'WORKFLOWS_CONVERSION_REPORTING'
  | 'UM_USAGE_READ'
  | 'UM_USAGE_WRITE'
  | 'WORKFLOWS_SIMILAR_FLOWS'
  | 'SUBSCRIPTION_STATUS_BATCH_READ'
  | 'SUBSCRIPTION_STATUS_BATCH_WRITE'
  | 'CUSTOMER_SUCCESS_PORTAL_ACCESS'
  | 'CONTENT_TEXT_EXTRACTION_ACCESS'
  | 'USERS_PERMISSIONS_ADMIN'
  | 'MERCHANT_UNDERWRITING_DECISION_WRITE'
  | 'VISITORS_AND_INTENT'
  | 'USER_OBJECT_MANAGER_PROPERTY_ACCESS'
  | 'USER_OBJECT_MANAGER_PROPERTY_READ'
  | 'USER_OBJECT_MANAGER_PROPERTY_WRITE'
  | 'REPORTING_GLOBAL_DATASETS_ACCESS'
  | 'UNIFIED_USAGE_SCORE_ACCESS'
  | 'LEGACYING_MIGRATIONS_READ_SENSITIVE'
  | 'CRM_RECORD_SHARING_ACCESS'
  | 'CRM_NOTES_EDIT_OWNED'
  | 'CRM_NOTES_EDIT_TEAM'
  | 'CRM_NOTES_EDIT_UNASSIGNED'
  | 'CRM_NOTES_EDIT_ALL'
  | 'CRM_NOTES_DELETE_ALL'
  | 'CRM_NOTES_DELETE_TEAM'
  | 'CRM_NOTES_DELETE_UNASSIGNED'
  | 'CRM_NOTES_DELETE_OWNED'
  | 'CRM_EMAILS_EDIT_OWNED'
  | 'CRM_EMAILS_EDIT_TEAM'
  | 'CRM_EMAILS_EDIT_ALL'
  | 'CRM_EMAILS_EDIT_UNASSIGNED'
  | 'CRM_EMAILS_DELETE_ALL'
  | 'CRM_EMAILS_DELETE_OWNED'
  | 'CRM_EMAILS_DELETE_TEAM'
  | 'CRM_EMAILS_DELETE_UNASSIGNED'
  | 'GITHUB_TOKEN_SCANNING_READ'
  | 'SEQUENCES_PUBLIC_READ_ACCESS'
  | 'SEQUENCES_ENROLLMENTS_PUBLIC_WRITE_ACCESS'
  | 'SEQUENCES_DYNAMIC_SEQUENCE'
  | 'DEVELOPER_CARDS_READ'
  | 'DATA_ENRICHMENT_NOTIFICATION_WRITE'
  | 'CRM_VIEWS_ALL_CAMPAIGNS_ROLE_IRRELEVANT'
  | 'SMS_SERVICE_10DLC_ADDON'
  | 'CARP_NOTIFICATION_READ'
  | 'CARP_NOTIFICATION_WRITE'
  | 'PERSONALIZED_PREF_PAGE_ACCESS'
  | 'CRM_CARD_INFRA_BACKEND_ADMIN'
  | 'CHANNEL_MIGRATION_ACCESS'
  | 'ALLOWED_LOGIN_READ'
  | 'ALLOWED_LOGIN_WRITE'
  | 'HUBSPOT_FORMS_MULTI_STEP'
  | 'HUBSPOT_FORMS_CONDITIONAL_LOGIC'
  | 'CARTS_ACCESS'
  | 'HUBSPOT_FORMS_CUSTOM_STYLING'
  | 'ORDERS_ACCESS'
  | 'HELP_DESK_TICKET_SPLIT'
  | 'DATA_BACKUP_READ'
  | 'DATA_BACKUP_WRITE'
  | 'DATA_BACKUP_DOWNLOAD'
  | 'INTERNAL_DATA_BACKUP_READ'
  | 'PUBLIC_APPS_RISKY_PATCH'
  | 'LANDINGPAGES_PRIVATE_CONTENT_MANAGE'
  | 'PAGES_PRIVATE_CONTENT_MANAGE'
  | 'BLOG_PRIVATE_CONTENT_MANAGE'
  | 'KNOWLEDGE_BASE_PRIVATE_CONTENT_MANAGE'
  | 'HELP_DESK_MACROS'
  | 'EMAIL_REVIEW_WRITE'
  | 'FORMS_REVIEW_WRITE'
  | 'PAGES_REVIEW_WRITE'
  | 'MESSAGES_REVIEW_WRITE'
  | 'CONTENT_REVIEW_READ'
  | 'FINTECH_DISCOUNTS_ADMIN'
  | 'SMS_MARKETING_SHORT_CODE_ADDON'
  | 'HUBSPOT_FORMS_CONDITIONAL_REDIRECT'
  | 'HUBSPOT_FORMS_MEETING_SIMPLE_REDIRECT'
  | 'HUBSPOT_FORMS_MEETING_CONDITIONAL_REDIRECT'
  | 'CARP_DATA_COLLECTION_READ'
  | 'DWI_ORCH_TEAM_WRITE'
  | 'DWI_MODEL_FRAMEWORK_WRITE'
  | 'DWI_MODEL_FRAMEWORK_ADMIN'
  | 'BI_JOB_EXECUTE_HEAVYWEIGHT'
  | 'PRIVATE_APPS_SCOPE_GROUP_FULL_ACCESS'
  | 'CUSTOMER_AGENT_ACCESS'
  | 'DEVELOPER_NAV_ACCESS'
  | 'COURSES_ACCESS'
  | 'LISTINGS_ACCESS'
  | 'APPOINTMENTS_ACCESS'
  | 'COURSES_READ'
  | 'LISTINGS_READ'
  | 'APPOINTMENTS_READ'
  | 'COURSES_WRITE'
  | 'LISTINGS_WRITE'
  | 'APPOINTMENTS_WRITE'
  | 'INTERNAL_DATA_RESTORE_READ'
  | 'HELP_DESK_SEND_OPTIONS'
  | 'DEVELOPER_PORTAL_ACCESS'
  | 'AI_ACCESS_CONTROLS_WRITE'
  | 'COMPANIES_HIGHLY_SENSITIVE_READ'
  | 'COMPANIES_HIGHLY_SENSITIVE_WRITE'
  | 'CONTACTS_HIGHLY_SENSITIVE_READ'
  | 'CONTACTS_HIGHLY_SENSITIVE_WRITE'
  | 'CUSTOM_OBJECTS_HIGHLY_SENSITIVE_READ'
  | 'CUSTOM_OBJECTS_HIGHLY_SENSITIVE_WRITE'
  | 'DEALS_HIGHLY_SENSITIVE_READ'
  | 'DEALS_HIGHLY_SENSITIVE_WRITE'
  | 'TICKETS_HIGHLY_SENSITIVE_READ'
  | 'TICKETS_HIGHLY_SENSITIVE_WRITE'
  | 'HUBSPOT_FORMS_PROGRESS_BAR'
  | 'PROSPECTING_AGENT_ACCESS'
  | 'CRM_COURSES_DELETE_OWNED'
  | 'CRM_COURSES_EDIT_UNASSIGNED'
  | 'CRM_COURSES_EDIT_TEAM'
  | 'CRM_COURSES_DELETE_TEAM'
  | 'CRM_COURSES_DELETE_UNASSIGNED'
  | 'CRM_COURSES_VIEW_TEAM'
  | 'CRM_COURSES_VIEW_UNASSIGNED'
  | 'CRM_COURSES_VIEW_ALL'
  | 'CRM_COURSES_DELETE_ALL'
  | 'CRM_COURSES_EDIT_OWNED'
  | 'CRM_COURSES_EDIT_ALL'
  | 'DATA_QUALITY_MISSING_DATA_ACCESS'
  | 'TRIALS_ACCESS'
  | 'DISCOUNT_ELIGIBILITY_REMOVAL'
  | 'CHADMIN_TEMPLATE_CATEGORIES_EDIT'
  | 'VIDEO_CLIPS_ACCESS'
  | 'TEMPLATES_AND_SNIPPETS_FREE_USER_LIMIT_5'
  | 'SEQUENCES_ENROLLMENTS_READ_ONLY_VIEW'
  | 'COMMERCE_SPECIALISTS_GROWTH_CONTACT_ACCESS'
  | 'ELEVATE_THEME_DELIVERY'
  | 'RECORD_SUMMARY_CARDS'
  | 'CRM_APPOINTMENTS_EDIT_ALL'
  | 'CRM_APPOINTMENTS_VIEW_ALL'
  | 'CRM_APPOINTMENTS_EDIT_TEAM'
  | 'CRM_APPOINTMENTS_VIEW_TEAM'
  | 'CRM_APPOINTMENTS_DELETE_ALL'
  | 'CRM_APPOINTMENTS_EDIT_OWNED'
  | 'CRM_APPOINTMENTS_DELETE_TEAM'
  | 'CRM_APPOINTMENTS_DELETE_OWNED'
  | 'CRM_APPOINTMENTS_EDIT_UNASSIGNED'
  | 'CRM_APPOINTMENTS_VIEW_UNASSIGNED'
  | 'CRM_APPOINTMENTS_DELETE_UNASSIGNED'
  | 'CRM_LISTINGS_EDIT_ALL'
  | 'CRM_LISTINGS_VIEW_ALL'
  | 'CRM_LISTINGS_EDIT_TEAM'
  | 'CRM_LISTINGS_VIEW_TEAM'
  | 'CRM_LISTINGS_DELETE_ALL'
  | 'CRM_LISTINGS_EDIT_OWNED'
  | 'CRM_LISTINGS_DELETE_TEAM'
  | 'CRM_LISTINGS_DELETE_OWNED'
  | 'CRM_LISTINGS_EDIT_UNASSIGNED'
  | 'CRM_LISTINGS_VIEW_UNASSIGNED'
  | 'CRM_LISTINGS_DELETE_UNASSIGNED'
  | 'CRM_SERVICES_EDIT_ALL'
  | 'CRM_SERVICES_VIEW_ALL'
  | 'CRM_SERVICES_EDIT_TEAM'
  | 'CRM_SERVICES_VIEW_TEAM'
  | 'CRM_SERVICES_DELETE_ALL'
  | 'CRM_SERVICES_EDIT_OWNED'
  | 'CRM_SERVICES_DELETE_TEAM'
  | 'CRM_SERVICES_DELETE_OWNED'
  | 'CRM_SERVICES_EDIT_UNASSIGNED'
  | 'CRM_SERVICES_VIEW_UNASSIGNED'
  | 'CRM_SERVICES_DELETE_UNASSIGNED'
  | 'DUPLICATES_CUSTOM_MERGE_ACCESS'
  | 'COLLECTOR_PROFILE_WRITE'
  | 'APPOINTMENTS_SENSITIVE_DATA_READ'
  | 'APPOINTMENTS_SENSITIVE_DATA_WRITE'
  | 'HUBSPOT_FORMS_MACHINE_TRANSLATION'
  | 'BREEZE_INTELLIGENCE_FREE'
  | 'BIDEN_ADMIN_COMPANIES_REFRESHES_WRITE'
  | 'PAYMENTS_TRANSACTION_FEE_RATE_OVERRIDE'
  | 'PROVISIONING_WRITE'
  | 'PROVISIONING_READ'
  | 'BIDEN_ADMIN_WRITE'
  | 'CONTENT_TEXT_EXTRACTION_SETTING_WRITE'
  | 'CONTENT_PERSONALIZATION_API'
  | 'ADVANCED_REPORTING_INSIGHTS'
  | 'MEETING_LINKS_READ'
  | 'POSSIBLE_SCOPE_OWNER_WRITE'
  | 'CUSTOMIZE_CRM_OWNED_VIEWS_ACCESS'
  | 'MINKOWSKI_ENGAGEMENT_SEARCH_ROUTE'
  | 'VIDEO_TRANSCRIPT_EXTRACTION_ONLY'
  | 'ACCOUNT_INSIGHTS_READ'
  | 'ENRICHMENT_PLATFORM_ADMIN'
  | 'SMS_MARKETING_10DLC_ADDON'
  | 'DATA_ENRICHMENT_NOTIFICATIONS_READ'
  | 'TRIAL_MARKETING_HUB_PROFESSIONAL'
  | 'TRIAL_SALES_HUB_PROFESSIONAL'
  | 'TRIAL_SERVICE_HUB_PROFESSIONAL'
  | 'TRIAL_CMS_HUB_PROFESSIONAL'
  | 'TRIAL_OPERATIONS_HUB_PROFESSIONAL'
  | 'TRIAL_MARKETING_HUB_ENTERPRISE'
  | 'TRIAL_SALES_HUB_ENTERPRISE'
  | 'TRIAL_SERVICE_HUB_ENTERPRISE'
  | 'TRIAL_CMS_HUB_ENTERPRISE'
  | 'TRIAL_OPERATIONS_HUB_ENTERPRISE'
  | 'TRIAL_HSOC_CORE_SEATS_PROFESSIONAL'
  | 'TRIAL_HSOC_CORE_SEATS_ENTERPRISE'
  | 'TRIAL_HSOC_FRONT_OFFICE_SEATS_PROFESSIONAL'
  | 'TRIAL_HSOC_FRONT_OFFICE_SEATS_ENTERPRISE'
  | 'DWI_TOOLING_ADMIN'
  | 'FINTECH_CBA_CANCEL_WRITE'
  | 'LEGACY_ASSET_CMS_SESSION_THEME_DELIVERY'
  | 'CREATE_TICKET_ASSOCIATION_ENFORCEMENT'
  | 'CUSTOMER_SUCCESS_WORKSPACE_LIMITED_ACCESS'
  | 'REPORTING_FORMULA_FIELD_FUNCTIONS_ACCESS'
  | 'CRM_MC_CENTRAL_FX_RATES_STARTER'
  | 'UNDERWRITER_RULE_MUTE_READ'
  | 'UNDERWRITER_RULE_MUTE_WRITE'
  | 'DWI_ANALYTICS_PLATFORM_USERS'
  | 'SOCIAL_AI_INBOX_SUMMARIES'
  | 'SNEELI_ACCOUNTING_ACCESS'
  | 'SNEELI_ACCOUNTING_WRITE'
  | 'SNEELI_ACCOUNTING_READ'
  | 'SITE_SPEED_DASHBOARD_READ'
  | 'SITE_SPEED_DASHBOARD_WRITE'
  | 'HELP_DESK_TICKET_LANGUAGE_DETECTION'
  | 'FLYWHEEL_PROSPECTING_WORKSPACE_GS_SMALL_BIZ_ACCESS'
  | 'AI_EXTRACTED_INSIGHTS_ACCESS'
  | 'AI_BLOG_POST_GENERATOR_LEGACY'
  | 'CONNECTED_EMAIL_MULTIPLE_SIGNATURES'
  | 'AI_BLOG_POST_GENERATOR_BASIC_ACCESS'
  | 'CRM_SCP_DUMMY_ACCESS'
  | 'JITA_SETTINGS_WRITE'
  | 'COLLECTION_NOTICE_READ'
  | 'COLLECTION_NOTICE_PUBLISH'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_1'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_10'
  | 'PROSPECTING_AGENT_READ_ACCESS'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_11'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_12'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_13'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_14'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_15'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_16'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_17'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_18'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_19'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_20'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_21'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_22'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_23'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_24'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_25'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_28'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_29'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_3'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_30'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_31'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_32'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_33'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_35'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_4'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_5'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_6'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_7'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_8'
  | 'WORKFLOWS_ACTION_CONTEXTUAL_SOURCE_APP_0_9'
  | 'CARD_INFRA_TEST_SCOPE'
  | 'BYPASS_JITA_DISABLED'
  | 'BILLINGEVENTSINDEX_WRITE'
  | 'BILLINGEVENTSINDEX_READ'
  | 'BALANCE_PROVIDER_READ'
  | 'CAPACITY_LIMITS_V2_READ'
  | 'CAPACITY_LIMITS_V2_WRITE'
  | 'CAPACITY_LIMITS_V2_ACCESS'
  | 'CAPACITY_LIMITS_V2_RETAIN'
  | 'CONTENT_MANAGEMENT_PLATFORM_CONFIG'
  | 'SALES_REPORTING_PROPERTIES_READ'
  | 'CHADMIN_PRODUCT_ACCESS'
  | 'BILLING_ADMIN_HUBAPI_WRITE'
  | 'REACTIVE_AGENTS_CHANNELS_EDIT'
  | 'HACKATHON_SALES_GPT'
  | 'HD_SPACES_EDIT'
  | 'GEFITZPATRICK_TEST_SCOPE'
  | 'DATASETS_SUPER_ADMIN'
  | 'DEMO_EXPERIENCE_ADMIN_ACCESS'
  | 'ACADEMY_CHANNELS_MANAGEMENT'
  | 'COMPANY_ENRICHMENT_ADMIN_READ'
  | 'BLOG_V2_SCHEMA_READ'
  | 'CRM_SCP_APP_OBJECTS_ACCESS'
  | 'HELP_DESK_ISSUES_INTEGRATION_WRITE'
  | 'HELP_DESK_ISSUES_INTEGRATION_READ'
  | 'CREDIT_MEMO_BILLING_APPLY_UNAPPLY'
  | 'HELP_DESK_PORTAL_ACCESS'
  | 'DEBIT_MEMO_CREATE'
  | 'GATING_ADMIN'
  | 'CRM_SCP_TICKET_BACKFILL'
  | 'CRM_SCP_TICKET_ACCESS'
  | 'FREE_V6'
  | 'FREE_V5'
  | 'NAV_TRIAL_BADGES'
  | 'PNP_SELF_SERVICE_PUSH_CHANGE'
  | 'PRODUCT_RELEASE_ELIGIBILITY_READ'
  | 'PRODUCT_RELEASE_ELIGIBILITY_WRITE'
  | 'PRODUCT_RELEASE_ELIGIBILITY_PILOT_ENROLL'
  | 'PNP_SELF_SERVICE_ADMIN'
  | 'CUSTOM_EVENTS_VIEW'
  | 'CUSTOM_EVENTS_EDIT'
  | 'CUSTOM_EVENTS_DELETE'
  | 'MULTI_ACCOUNT_ORGANIZATION_CONFIG_INTERNAL_WRITE'
  | 'MAM_VIRTUAL_USER'
  | 'CRM_ASSOCIATIONS_WRITE_ACCESS'
  | 'DWI_RESTRICTED_DBT_JOB_EXECUTE'
  | 'MULTI_ACCOUNT_CONNECTION_WRITE'
  | 'MULTI_ACCOUNT_ORG_CONFIG_VIEW'
  | 'MULTI_ACCOUNT_ORG_CONFIG_WRITE'
  | 'BUYER_INTENT_EDIT'
  | 'WORKSPACE_SETTINGS_WRITE'
  | 'WORKSPACE_SETTINGS_READ'
  | 'PASSKEY_ADMIN'
  | 'BLOG_SCHEMA_READ'
  | 'JITA_CRM_READ_ONLY'
  | 'JITA_CRM_READ_WRITE'
  | 'DEMO_SPOT_ACCESS'
  | 'DEMO_SPOT_ADMIN_ACCESS'
  | 'COS_RENDERER_DEBUG'
  | 'CRM_MIGRATIONS_INTERNAL_QUERY_SCOPE'
  | 'HUBGPT_TOOL_ASSISTANCE_BETA'
  | 'DSHERIDAN_ACCOUNTING_WRITE'
  | 'DSHERIDAN_ACCOUNTING_READ'
  | 'DSHERIDAN_ACCOUNTING_ACCESS'
  | 'CONVERSATIONS_ROUTING_PORTAL'
  | 'HELP_DESK_SERVICE_SEAT'
  | 'EXTERNAL_INTEGRATIONS_WORDPRESS_MAPPINGS'
  | 'SUBSCRIPTIONS_DELETE'
  | 'ACADEMY_PUBLIC_PLAYLISTS_ADMIN'
  | 'MARKETPLACE_SCHEMATA_EDIT'
  | 'CARP_PROCESS_ADMIN_WRITE'
  | 'HELP_DESK_KB_CARD'
  | 'EMAIL_DEANONYMIZE_ACCESS'
  | 'QUOTE_CUSTOM_DOMAIN_READ'
  | 'QUOTE_CUSTOM_DOMAIN_ACCESS'
  | 'QUOTE_CUSTOM_DOMAIN_WRITE'
  | 'QUOTE_HS_SITES_DOMAIN_WRITE'
  | 'QUOTE_MULTI_DOMAIN_PUBLISHING'
  | 'QUOTE_SECONDARY_BRAND_DOMAIN'
  | 'DATA_ENRICHMENT_OVERAGE_USAGE'
  | 'ACTIVITY_INDEX_PAGE_ACCESS'
  | 'INTEGRATIONS_MANAGEMENT_UNINSTALL_ACCESS'
  | 'JOURNEYS_VIEW'
  | 'JOURNEYS_EDIT'
  | 'JOURNEYS_CREATE'
  | 'JOURNEYS_DELETE'
  | 'JOURNEYS_PUBLISH'
  | 'LEGACYING_MIGRATIONS_OPT_IN_CUSTOMER_LINK'
  | 'HUB_PARCELS_WRITE'
  | 'PRICE_MIGRATION_DISCOUNT_REMOVER'
  | 'HUB_PARCELS_READ'
  | 'CALLING_INBOX_ROUTING'
  | 'CALLING_HELP_DESK_ROUTING'
  | 'QUOTE_APPROVAL_READ'
  | 'QUOTE_APPROVAL_WRITE'
  | 'APP_SERVICE_ACCOUNT_USER'
  | 'PRESALES_GPT'
  | 'HD_TICKET_SENTIMENT_ENT_PLUS_SCOPE'
  | 'APP_SERVICE_ACCOUNTS_ADMIN'
  | 'TICKETS_STARTER_PLUS'
  | 'CASE_STUDIES_BRAND_VOICE'
  | 'PODCASTS_BRAND_VOICE'
  | 'SOCIAL_BRAND_VOICE'
  | 'SALES_EMAIL_BRAND_VOICE'
  | 'CALLING_PORTING'
  | 'CALL_SUMMARIES_WRITE'
  | 'INBOUND_CALLING_ACCESS'
  | 'OUTBOUND_CALLING_ACCESS'
  | 'OUTBOUND_DIALER_ACCESS'
  | 'CALLING_DEFAULT_OUTCOMES_WRITE'
  | 'ADMIN_MEMO_SYNC_EXECUTOR_READ'
  | 'INVOICE_PAYER_READ'
  | 'PAYMENT_SYNC_EXECUTOR_READ'
  | 'CORE_TRANSACTIONS_READ'
  | 'PAYMENT_SCHEDULER_READ'
  | 'CALLING_INTERNATIONAL_PHONE_NUMBER_ACQUISITION'
  | 'CALLING_US_PHONE_NUMBER_ACQUISITION'
  | 'CONTRACTS_DELETE'
  | 'CONTRACTS_WRITE'
  | 'CONTRACTS_READ'
  | 'CONTRACTS_ACCESS'
  | 'CONTRACTS_SETTINGS_WRITE'
  | 'ENGAGEMENTS_HIGHLY_SENSITIVE_WRITE'
  | 'ENGAGEMENTS_HIGHLY_SENSITIVE_READ'
  | 'ENGAGEMENTS_SENSITIVE_DATA_WRITE'
  | 'ENGAGEMENTS_SENSITIVE_DATA_READ'
  | 'CARP_TASKS_ALL'
  | 'PUBLIC_ACTION_BUILDER'
  | 'IN_LIST_FILTERING_ACCESS'
  | 'FISSURE_READ'
  | 'PRODUCT_PACKAGING_ADMIN'
  | 'HELP_DESK_AI_WORKFLOWS'
  | 'CALLING_TWILIO_CONNECT_ACCESS'
  | 'HELPDESK_GPT'
  | 'CRM_PROCESSES_ACCESS'
  | 'OPTINS_WRITE'
  | 'INGESTION_FRAMEWORK_ADMIN'
  | 'CRM_NO_PORTAL_SCOPE'
  | 'HELP_DESK_SPLIT_TICKET_ACTION'
  | 'CUSTOMER_AGENT_UPGRADE'
  | 'SUCCESS_ASSISTANT_ADMIN'
  | 'PERSONALIZE_VIEW'
  | 'PERSONALIZE_EDIT'
  | 'PERSONALIZATION_CONTEXT_READ'
  | 'LIMITS_MANAGEMENT_DB_INTERNAL_READ'
  | 'CASE_STUDY_BRAND_VOICE'
  | 'SALES_BRAND_VOICE'
  | 'CRM_TRANSCRIPTION_API_WRITE'
  | 'CRM_TRANSCRIPTION_API_READ'
  | 'CUSTOMER_AGENT_WRITE'
  | 'CONVERSATIONAL_ENRICHMENT_FREE_ACCESS'
  | 'CALLING_PAID_SEAT_ACCESS'
  | 'GITHUB_BOT_SETTINGS'
  | 'CONVERSATIONAL_ENRICHMENT_BASIC_ACCESS'
  | 'CONVERSATIONAL_ENRICHMENT_PREMIUM_ACCESS'
  | 'SERVICE_ACCOUNT_SEAT_ACCESS'
  | 'SALES_POWER_SEAT_ACCESS'
  | 'CALLING_BYON_REGISTRATION'
  | 'SMS_REVIEW_WRITE'
  | 'CONVERSATIONS_INBOX_EMAIL_REVIEW_WRITE'
  | 'WHATSAPP_REVIEW_WRITE'
  | 'MINKOWSKI_INTERNAL_TEST_SCOPE'
  | 'CS_REP'
  | 'CALL_ENGAGEMENT_BLOCK'
  | 'CALLING_INBOX_CHANNEL_WRITE'
  | 'CALLING_HELP_DESK_CHANNEL_WRITE'
  | 'BUYER_INTENT_VIEW'
  | 'LOG_CALL_BLOCK'
  | 'CALLING_OUTBOUND_DIALER_ACCESS'
  | 'SERVICE_ENTERPRISE_SEAT'
  | 'ACCOUNT_TAKEDOWN_UNDO'
  | 'ELIGIBILITY_ENGINE_READ'
  | 'HELP_DESK_SUPER_ADMIN_TEMP'
  | 'HELP_DESK_SERVICE_ENTERPRISE_SEAT_TEMP'
  | 'HUB_GPT_4_5'
  | 'CALLING_OUTBOUND_ACCESS'
  | 'CALLING_INBOUND_ACCESS'
  | 'LAUNCH_DEV_ACCESS'
  | 'FINTECH_ADMIN_SUPER'
  | 'DEBUG_TICKET_ROLLUP'
  | 'SERVICE_FEEDBACK_COPILOT_ACCESS'
  | 'INVOICES_EDIT_ALL'
  | 'INVOICES_VIEW_ALL'
  | 'INVOICES_EDIT_TEAM'
  | 'INVOICES_VIEW_TEAM'
  | 'INVOICES_DELETE_ALL'
  | 'INVOICES_EDIT_OWNED'
  | 'INVOICES_DELETE_TEAM'
  | 'INVOICES_DELETE_OWNED'
  | 'INVOICES_EDIT_UNASSIGNED'
  | 'INVOICES_VIEW_UNASSIGNED'
  | 'INVOICES_DELETE_UNASSIGNED'
  | 'SALES_GPT_ACCESS'
  | 'TRANSACTION_WORKFLOW_ELIGIBILITY_READ'
  | 'SERVICE_FEEDBACK_AI_ACCESS'
  | 'PRICEPILOT_READ'
  | 'PRICEPILOT_WRITE'
  | 'FLYWHEEL_CUSTOMER_SUCCESS_WORKSPACE_ALERTS'
  | 'USER_PASSWORDS_INVALIDATION_WRITE'
  | 'LEAD_PIPELINES_ACCESS'
  | 'CALLING_ANALYTICS_READ'
  | 'MARKETS_EDIT_ACCESS'
  | 'SERVICE_JOURNEY_ANALYTICS_READ'
  | 'BET_ACTIVITY_TYPES_STRATEGIC_SALES_SPECIALISTS'
  | 'ROLLOUTS_ADMIN'
  | 'REVISION_HISTORY_READ'
  | 'CRM_SCP_SERVICES_BACKFILL'
  | 'CRM_SCP_SERVICES_ACCESS'
  | 'REVISION_HISTORY_WRITE'
  | 'TWILIO_ACCESS'
  | 'PORTAL_RESTRICTIONS_WRITE'
  | 'CREDIT_MEMOS_ACCESS'
  | 'CREDIT_MEMOS_READ'
  | 'CREDIT_MEMOS_WRITE'
  | 'FINTECH_PRICING_EDIT'
  | 'FINTECH_DISCOUNT_EDIT'
  | 'SOCIAL_BROADCAST_APPROVAL_READ'
  | 'SOCIAL_BROADCAST_APPROVAL_WRITE'
  | 'SOCIAL_BROADCAST_APPROVE'
  | 'EXTERNAL_INTEGRATIONS_GOOGLE_WORKSPACE_APP_ACCESS'
  | 'BET_ACTIVITY_TYPES_VALUE_ENGINEER'
  | 'PARTNER_ACCOUNT_NAV_ACCESS'
  | 'ENRICHMENT_PUBLIC_API_ACCESS'
  | 'SOD_ADMIN'
  | 'CUSTOM_EVENTS_PORTAL_ACCESS'
  | 'BAT_PROACTIVE_SQL_CARD_ACCESS'
  | 'COMPOSER_READ_ONLY'
  | 'CONTENT_VIDEO'
  | 'BRAND_IDENTITY_ACCESS'
  | 'RESEARCH_INTENT_20_TOPIC_ACCESS'
  | 'LOOKALIKE_LISTS'
  | 'MERCHANT_UNDERWRITING_KEYWORDS_MANAGE'
  | 'MERCHANT_UNDERWRITING_KEYWORDS_READ'
  | 'RESEARCH_INTENT_ACCESS'
  | 'LISTS_INSIGHTS_ACCESS'
  | 'FLYWHEEL_SOURCING_WORKSPACE_ACCESS'
  | 'FLYWHEEL_SOURCING_WORKSPACE_GOVERNANCE_ACCESS'
  | 'PAYROLL_GPT'
  | 'ALLOW_SKIP_STARTER_LEVEL_PRODUCTS_PACKAGING_VALIDATOR'
  | 'SERVICE_SATISFACTION_FEEDBACK_RECEIVED_WRITE'
  | 'SERVICE_SATISFACTION_FEEDBACK_WRITE'
  | 'CALLING_INTERNAL_PHONE_NUMBERS_INTERNATIONAL_ACQUISITION_WRITE'
  | 'ORDER_PIPELINES_ACCESS'
  | 'FRAMEWORK_FILTERS_READ'
  | 'FRAMEWORK_FILTERS_WRITE'
  | 'HD_COACHING_TAB_ACCESS'
  | 'LLM_INTEGRATION_ACCESS'
  | 'MULTI_ACCOUNT_REPORTS_READ'
  | 'HUBGPT_PLAYGROUND_BETA'
  | 'AI_FRAME_TOOLING_ACCESS'
  | 'PARTNER_SUSPENSION_ACCESS'
  | 'HUB_LIMIT_USAGE_READ'
  | 'KNOWLEDGE_BOX_READ'
  | 'KNOWLEDGE_BOX_WRITE'
  | 'SALES_WORKSPACE_BOARD_CARD_CUSTOMIZATION_ACCESS'
  | 'SALES_WORKPSACE_BOARD_CARD_CUSTOMIZATION_WRITE'
  | 'FLYWHEEL_AI_EMAIL_ACCESS'
  | 'HELP_DESK_SNOOZE_TICKET'
  | 'ASSIGN_CONVERSATION_OWNER_ACCESS'
  | 'CUSTOMER_SUPPORT_PRODUCT_ROLLOUTS_UPDATE'
  | 'CONTENT_SYNC'
  | 'REPORT_INSIGHTS_ACCESS'
  | 'TWO_FACTOR_SMS'
  | 'CRM_SCP_ALERT_ACCESS'
  | 'DEVELOPER_PLATFORM_SECRETS_READ'
  | 'DEVELOPER_PLATFORM_SECRETS_WRITE'
  | 'APPROVAL_RULE_EDIT'
  | 'NO_TWO_FACTOR_SMS'
  | 'MULTI_ACCOUNT_REPORTS_VIEWER_ACCESS'
  | 'DEFAULT_ALERTS_PIPELINES'
  | 'CRM_SCP_COMPANIES_ACCESS'
  | 'CRM_SCP_COMPANIES_BACKFILL'
  | 'BAT_SNOWFLAKE_PROXY_SERVICE_ACCESS'
  | 'CRM_PROPERTIES_AUTOSAVE_SETTINGS'
  | 'ALLOWED_TWO_FACTOR_METHODS_WRITE'
  | 'APPROVALS_UAT_BYPASS'
  | 'HUB_GPT_PLAYGROUND_ACCESS'
  | 'SETTINGS_PARTNER_DATA_ACCESS'
  | 'SH_LEAD_SCORING_VIEW'
  | 'SH_LEAD_SCORING_EDIT'
  | 'BILLINGCOMMUNICATIONS_RECIPIENT_READ'
  | 'AI_CONNECTOR'
  | 'AI_NLP_REVIEW_WRITE'
  | 'DEVELOPER_SEAT_ACCESS'
  | 'CRM_SCP_CUSTOM_OBJECT_BACKFILL'
  | 'CRM_SCP_CUSTOM_OBJECT_ACCESS'
  | 'OBJECTS_API_INTERNAL_ACCESS'
  | 'CONTENT_EMBED_EXTERNAL_RENDER'
  | 'CUSTOMER_PORTAL_HS_SITES_DOMAIN_WRITE'
  | 'DSI_MDM_VENDOR_API_READ'
  | 'DEAL_REGISTRATIONS_READ'
  | 'DEAL_REGISTRATIONS_WRITE'
  | 'DEAL_REGISTRATIONS_DELETE'
  | 'WHATSAPP_PRODUCT_ACCESS'
  | 'WHATSAPP_VIEW'
  | 'WHATSAPP_EDIT'
  | 'WHATSAPP_PUBLISH'
  | 'WHATSAPP_SETTINGS_MANAGER_ACCESS'
  | 'CMS_URL_SIGNING'
  | 'AI_TICKET_CATEGORY_IDENTIFICATION'
  | 'CALLING_INTERNAL_PHONE_NUMBERS_PORTING_WRITE'
  | 'LISTS_EVAL_READ'
  | 'LIST_DEBUGGING'
  | 'MANUAL_PAYMENTS_WRITE'
  | 'WAITLIST_READ'
  | 'DWI_ADMIN'
  | 'WAITLIST_WRITE'
  | 'FLYWHEEL_DOMAIN_REVIEW_HISTORY_ACCESS'
  | 'PROJECT_OBJECT_ACCESS'
  | 'PROJECT_OBJECT_READ'
  | 'PROJECT_OBJECT_WRITE'
  | 'WEBHOOKS_JOURNAL_SUBSCRIPTION_MANAGEMENT'
  | 'WEBHOOKS_JOURNAL_DATA_ACCESS'
  | 'CRM_EVENTS_METADATA_READ'
  | 'FINTECH_DISCOUNTS_BYPASS_DISCOUNT_RANGES'
  | 'FINTECH_DISCOUNTS_BYPASS_STEPDOWN_POLICY'
  | 'POLICY_ENGINE_EVENT_AUDITS_READ'
  | 'AUTOSCALE_WRITE'
  | 'AUTOSCALE_READ_ONLY'
  | 'AUTOSCALE_READ'
  | 'CREDITS_DISCOUNT_ENROLLMENT_EDIT'
  | 'CRM_PIPELINES_CLONE'
  | 'SERVICE_FEEDBACK_ENTERPRISE_ACCESS'
  | 'CREATE_PAYMENT_RECORD'
  | 'COMMERCE_PROFESSIONAL_SEAT_ACCESS'
  | 'COMMERCE_ENTERPRISE_SEAT_ACCESS'
  | 'COMMERCE_PROFESSIONAL_TRIAL_SEAT_ACCESS'
  | 'COMMERCE_ENTERPRISE_TRIAL_SEAT_ACCESS'
  | 'SALES_WORKSPACE_DEALS_TAB_ACCESS'
  | 'WEBHOOKS_JOURNAL_SUBSCRIPTION_READ'
  | 'SALES_WORKSPACE_LEADS_TAB_ACCESS'
  | 'SALES_WORKSPACE_TARGET_ACCOUNTS_TAB_ACCESS'
  | 'REACTIVE_AGENTS_CALLING_READ'
  | 'REACTIVE_AGENTS_CALLING_WRITE'
  | 'DEAL_DESK_CHECKOUT'
  | 'INTEGRATIONS_MSTEAMS_READ'
  | 'INTERNAL_PORTAL_ACCESS'
  | 'INTEGRATIONS_MSTEAMS_WRITE'
  | 'DEMO_DATA_GENERATOR_ACCESS'
  | 'WEBHOOKS_JOURNAL_SNAPSHOT_MANAGEMENT'
  | 'WEBHOOKS_JOURNAL_SNAPSHOT_READ'
  | 'CRM_VIEW_ALL_PROJECTS'
  | 'CRM_VIEW_TEAM_PROJECTS'
  | 'CRM_VIEW_UNASSIGNED_PROJECTS'
  | 'CRM_EDIT_ALL_PROJECTS'
  | 'CRM_EDIT_TEAM_PROJECTS'
  | 'CRM_EDIT_OWNED_PROJECTS'
  | 'CRM_EDIT_UNASSIGNED_PROJECTS'
  | 'CRM_DELETE_ALL_PROJECTS'
  | 'CRM_DELETE_TEAM_PROJECTS'
  | 'CRM_DELETE_OWNED_PROJECTS'
  | 'CRM_DELETE_UNASSIGNED_PROJECTS'
  | 'ACADEMY_RATINGS_ADVANCED'
  | 'SUCCESS_ASSISTANT_USER'
  | 'PARCEL_RELATED_DELETE'
  | 'BREEZE_AGENT_EDIT'
  | 'QUOTE_APPROVALS_AUTOMATION'
  | 'QUOTES_APPROVE'
  | 'TASK_RECOMMENDATION_READ'
  | 'DEAL_DESK_CHECKOUT_ADMIN'
  | 'EMAIL_ENGAGEMENT_OPTIMIZATION'
  | 'CRM_SCP_PROJECT_ACCESS'
  | 'ACCESS_PROFILES_SCOPES_WRITE'
  | 'ACCESS_PROFILES_ROLES_WRITE'
  | 'ACCESS_PROFILES_FLS_WRITE'
  | 'ACCESS_PROFILES_CUSTOM_OBJECTS_WRITE'
  | 'ACCESS_PROFILES_HIGH_RISK_PERMISSIONS_WRITE'
  | 'PDM_WORKSPACE_READ_ACCESS'
  | 'PRODUCT_PACKAGING_AI_ACCESS'
  | 'MULTI_ACCOUNT_DATA_SHARING_COMPANY_READ'
  | 'SEATS_LEGACYING_MIGRATIONS_IN_PROGRESS'
  | 'DUPLICATES_CUSTOM_RULES_WRITE'
  | 'DUPLICATES_CUSTOM_RULES_READ'
  | 'USER_PERSONAS_READ'
  | 'DEMO_CONTENT_GENERATION_AGENT_ACCESS'
  | 'COMPANY_DISCOVERY_ADMIN'
  | 'COMPANY_DISCOVERY_ADMINISTRATOR'
  | 'AVAILABILITY_TIMER_ACCESS'
  | 'AVAILABILITY_TIMER_READ'
  | 'AVAILABILITY_TIMER_WRITE'
  | 'ADD_ONS_VIEW'
  | 'PRODUCT_PACKAGING_AI_VIEW'
  | 'PORTAL_CAPACITY_LIMITS_VIEW'
  | 'TIERED_PRODUCTS_ACCESS'
  | 'AWAY_STATUS_TIMER_ACCESS'
  | 'AWAY_STATUS_TIMER_READ'
  | 'AWAY_STATUS_TIMER_WRITE'
  | 'DUPLICATES_AUTOMATION'
  | 'DUPLICATES_AUTOMATION_ACCESS'
  | 'CARP_SYSTEMS_TECHNICAL_DATA_WRITE'
  | 'CARP_SYSTEMS_DEPLOYABLES_WRITE'
  | 'FLYWHEEL_CAPACITY_WORKSPACE_ACCESS'
  | 'PARTNER_ASSISTANT'
  | 'BREEZE_AGENT_ACCESS'
  | 'CPQ_QUOTE_ACCESS'
  | 'NETSUITE_ENTITY_READ'
  | 'BREEZE_AGENT_RUN'
  | 'PARTNER_COMMISSION_INTERNAL_READ'
  | 'BLOG_RESEARCH_AGENT_ACCESS'
  | 'AI_CONTEXT_MINING'
  | 'CLOSING_AGENT_ACCESS'
  | 'CPQ_QUOTE_CREATE'
  | 'PROPERTY_FORMATTER_BULK_ACTIONS'
  | 'PROPERTY_FORMATTER_AUTOMATION_ACCESS'
  | 'WORKFLOWS_MANUAL_ENROLL_ALL'
  | 'WORKFLOWS_ENABLE_ALL'
  | 'DUPLICATES_REALTIME_DEDUPE'
  | 'CRM_INDEX_DATA_WELL_OVERVIEW_ACCESS'
  | 'DUPLICATES_PRO_ACCESS'
  | 'PRODUCT_USAGE_READ'
  | 'DATASETS_SYNC_TO_CRM_READ'
  | 'DATASETS_SYNC_TO_CRM_WRITE'
  | 'GONG_AI_TRANSCRIPT_EXPLORER'
  | 'QUEUE_ORCHESTRATOR_ADMIN'
  | 'QUEUE_ORCHESTRATOR_ADMIN_READ'
  | 'QUEUE_ORCHESTRATOR_ADMIN_WRITE'
  | 'SEGMENTS_UI_JOURNEY_REPORT'
  | 'HUBSPOT_FORMS_AI_GENERATION_ACCESS'
  | 'QUOTING_FUTURE_PENDING_PURCHASE'
  | 'RE_QUOTING_FUTURE_PENDING_RENEWAL_PURCHASE'
  | 'DATA_QUALITY_AUTO_SCAN_ACCESS'
  | 'DATA_QUALITY_PRO_FEATURES'
  | 'WERNICKE_INTERNAL'
  | 'INDEX_PAGE_INSIGHTS_READ'
  | 'PROSPECTING_AGENT_ADMIN_ACCESS'
  | 'UNIFIED_DEV_PLATFORM_ACCESS'
  | 'BUYING_GROUP_READ_ACCESS'
  | 'BUYING_GROUP_WRITE_ACCESS'
  | 'ACCOUNT_MAP_READ_ACCESS'
  | 'ACCOUNT_MAP_WRITE_ACCESS'
  | 'ACCOUNT_CLEANUP_READ'
  | 'CRM_INDEX_TABLE_CONDITIONAL_HIGHLIGHTING_ACCESS'
  | 'AUTOMATED_SALES_TAX'
  | 'CRM_CATCH_UP_FULL_ACCESS'
  | 'DATA_AGENT_ACCESS'
  | 'CUSTOMER_SUCCESS_TEAM_WORKSPACES_ACCESS'
  | 'VOID_PAYMENT_RECORD'
  | 'INDEX_PAGE_INSIGHTS_ADVANCED_READ'
  | 'EMBEDDED_PROJECT_AUTOMATION_ACCESS'
  | 'CALLS_WRITE'
  | 'CALLS_READ'
  | 'EMAILS_WRITE'
  | 'EMAILS_READ'
  | 'MEETINGS_READ'
  | 'MEETINGS_WRITE'
  | 'NOTES_WRITE'
  | 'NOTES_READ'
  | 'TASKS_WRITE'
  | 'TASKS_READ'
  | 'CRM_OBJECT_GANTT_ACCESS'
  | 'CRM_PIPELINES_PROJECT_TAG_READ'
  | 'FLYWHEEL_SALES_WORKSPACE_ACCESS'
  | 'BREEZE_AGENT_ADMIN'
  | 'EMAIL_CAMPAIGN_STO_ACCESS'
  | 'EMAIL_CONTACT_STO_ACCESS'
  | 'UNTRUSTED_SCOPES_ENFORCEMENT_WRITE'
  | 'CRM_OBJECT_CALENDAR_ACCESS'
  | 'REPORTING_TAGS'
  | 'HELP_DESK_ADMIN_TEMP'
  | 'HELP_DESK_ADMIN'
  | 'WORKFLOWS_CREATE_TEMPLATES'
  | 'ABM_BREEZE_CARDS_ACCESS'
  | 'CRM_REPORT_CARDS'
  | 'PRODUCT_PACKAGING_BE_ADMIN'
  | 'CRM_REPORT_COMPONENTS'
  | 'WORKFLOWS_ISSUES'
  | 'WORKFLOWS_ANALYZE'
  | 'WORKFLOWS_HEALTH'
  | 'BRANDED_THEME_PRESETS'
  | 'ONBOARDING_COMMERCE_PRO'
  | 'ONBOARDING_COMMERCE_ENTERPRISE'
  | 'TRIAL_COMMERCE_HUB_PROFESSIONAL'
  | 'TRIAL_COMMERCE_HUB_ENTERPRISE'
  | 'CRM_PIPELINES_OBJECT_LABEL_SEATED_ACCESS'
  | 'CRM_PIPELINES_OBJECT_LABEL_SEATED_WRITE'
  | 'CRM_PIPELINES_OBJECT_LABEL_SEATED_PER_PIPELINE'
  | 'WAREHOUSE_DATA_INTEGRATION_ACCESS'
  | 'REPORTING_DATASETS_SYNC'
  | 'CRM_OBJECT_REPORT_ACCESS'
  | 'CRM_PIPELINES_PROJECT_TAG_READ_PRE_SEAT'
  | 'SEGMENTS_OVERVIEW_ACCESS'
  | 'SEGMENTS_CUSTOM_GOAL_ACCESS'
  | 'DATA_AGENT_PLATFORM_ACCESS'
  | 'DEAL_INSIGHTS'
  | 'SERVICE_SMS_PRODUCT_ACCESS'
  | 'BILLING_TAX_WRITE'
  | 'DEFAULT_THEME_PRESETS'
  | 'CRM_OBJECTS_DEBUG_READONLY'
  | 'DATA_STUDIO_ACCESS'
  | 'SMS_BILLING'
  | 'WHATSAPP_BILLING'
  | 'REPORTS_SALES_STARTER_ACCESS'
  | 'DWI_JOB_LAUNCHER_PROPOSE_BYPASS'
  | 'QUEUE_ADMIN_READ_ONLY'
  | 'QUEUE_ADMIN_WRITE'
  | 'WEB_VISITOR_SEGMENTS'
  | 'BILLING_ADMIN_PAYMENT_PLANS_ACCESS'
  | 'CONVERSATIONAL_ENRICHMENT_TRANSCRIPTS_ACCESS'
  | 'LANDING_PAGES_PERSONALIZATION_ACCESS'
  | 'EMAIL_DYNAMIC_TEXT_TOKENS'
  | 'EMAIL_MESSAGING_INSIGHTS_READ_ONLY'
  | 'NAV_MANAGER_UI_APPROVERS_SETTINGS'
  | 'NAV_MANAGER_UI_APPROVERS_DEFAULT'
  | 'CONNECTED_APPS_ASSISTANT'
  | 'PROJECTS_SENSITIVE_DATA_READ'
  | 'PROJECTS_SENSITIVE_DATA_WRITE'
  | 'SEGMENTATION_GOALS_ACCESS'
  | 'SINGLE_HUB_RESTRICTION_WRITE'
  | 'SERVICE_QUALITY_ASSESSMENT_READ'
  | 'MARKETPLACE_ADMIN_PORTAL_ACCESS'
  | 'SIGNUP_QA_ACCESS'
  | 'BET_OWNERS_BULK_WRITE_53'
  | 'DATA_HUB_BRANDING'
  | 'QUARTER_IN_REVIEW_ACCESS'
  | 'GIVEME_APPROVAL_TEST'
  | 'OAUTHOR_FLUENT_ENDPOINTS'
  | 'PRODUCT_BUNDLES_ACCESS'
  | 'TICKET_EMAIL_EDIT'
  | 'INTEGRATION_ENQUEUE_WRITE'
  | 'AI_EMAIL_TEMPLATE_UPLOAD_ACCESS'
  | 'PAYOUTS_READ'
  | 'SUGGESTED_TASK_ACCESS'
  | 'AEO_DASHBOARD_ACCESS'
  | 'CRM_PROCESSES_WRITE'
  | 'CALLABLE_TEXT_PROPERTIES_READ'
  | 'CALLABLE_TEXT_PROPERTIES_WRITE'
  | 'IS_FORMER_DEVELOPER_TOOLS_PORTAL'
  | 'APPLY_UNAPPLY_PAYMENT_RECORD'
  | 'CRM_PROCESSES_READ'
  | 'CRM_EVENTS_FILTER_VISIBILITY_ACCEPTANCE_TEST_SCOPE'
  | 'AEO_ACCESS'
  | 'HISTORICAL_EMAIL_IMPORT_ACCESS'
  | 'ACADEMY_STUDIO_LMS_CONTENT_WRITE'
  | 'PARTER_DEAL_PORTAL_JITA_ACCESS'
  | 'PNP_LEGAL_APPROVERS'
  | 'PNP_FINOPS_APPROVERS'
  | 'ACADEMY_STUDIO_CATALOG_CONTENT_WRITE'
  | 'WRITE_OFF_PAYMENT_RECORD'
  | 'TRANSFER_PAYMENT_RECORD'
  | 'SALES_HUB_NO_LEGACY_QUOTES_ACCESS'
  | 'TRIAL_AI_CREDITS_ACTIVE'
  | 'DATA_STUDIO_SIGNUP_ELIGIBLE'
  | 'SERVICE_KNOWLEDGE_BASE_AGENT'
  | 'SOCIAL_VIEW'
  | 'SOCIAL_EDIT'
  | 'PROJECTS_HIGHLY_SENSITIVE_WRITE'
  | 'PROJECTS_HIGHLY_SENSITIVE_READ'
  | 'SENSITIVE_DATA_ENGAGEMENTS_ACCESS'
  | 'FORECASTING_ELEVATED_JITA'
  | 'DATA_ENRICHMENT_READ'
  | 'KNOWLEDGE_BASE_AGENT'
  | 'CALLING_NUMBER_VERIFICATION_READ'
  | 'CALLING_NUMBER_VERIFICATION_WRITE'
  | 'CALLING_POWER_DIALER_ACCESS'
  | 'DDA_DATA_DEVEX_CONV_RPC_ADMIN'
  | 'KNOWLEDGE_BOX_ADMIN'
  | 'QUOTING_WATERFALL_ALLOW_MRR_DOWNGRADE'
  | 'NOTETAKER_ACCESS'
  | 'ADS_ACCESS_MANAGEMENT'
  | 'APPROVAL_RULE_EDIT_CMS'
  | 'APPROVAL_RULE_EDIT_DEAL_DESK'
  | 'APPROVAL_RULE_EDIT_HIGH_MRR_SHORT_TERM_COMMIT_RULE'
  | 'APPROVAL_RULE_EDIT_INTERNAL'
  | 'APPROVAL_RULE_EDIT_LEGAL'
  | 'APPROVAL_RULE_EDIT_MIGRATION_SERVICES'
  | 'APPROVAL_RULE_EDIT_PARTNER_DEVELOPMENT_MANAGEMENT'
  | 'APPROVAL_RULE_EDIT_QTC'
  | 'APPROVAL_RULE_EDIT_RENEWAL_DISCOUNTING'
  | 'APPROVAL_RULE_EDIT_SALES_OPS'
  | 'APPROVAL_RULE_EDIT_SERVICES_PRODUCT'
  | 'APPROVAL_RULE_EDIT_SOLUTIONS_ENGINEERING'
  | 'APPROVAL_RULE_EDIT_SPEND_BASED'
  | 'APPROVAL_RULE_EDIT_TRANSACTIONAL_EMAIL_SKU_MIGRATION'
  | 'NOTETAKER_SETTINGS_WRITE'
  | 'API_KEY_WRITE'
  | 'CALLING_VOICEMAIL_DROP_WRITE'
  | 'CALLING_VOICEMAIL_DROP_READ'
  | 'SITEMAP_REFRESH_WRITE'
  | 'CRM_SMART_CARDS'
  | 'BRAND_INTELLIGENCE_READ'
  | 'FLEX_SEAT_ACCESS'
  | 'BET_ALERT_OWNERS_WRITE_53'
  | 'PNP_TESTING_APPROVERS'
  | 'LEGAL_TERMS_HUBAPI_READ'
  | 'WORK_ACCESS'
  | 'REPORTS_LIST_CUSTOM_VIEWS_ACCESS'
  | 'SITE_PAGES_PERSONALIZATION_ACCESS'
  | 'HUBSHOT_SERVICE_ACCESS'
  | 'FINTECH_ANSWERS_READ_ONLY'
  | 'PNP_UBB_APPROVERS'
  | 'MARKETPLACE_LISTED_APP_INSTALL_ACCESS'
  | 'PRIVATELY_DISTRIBUTED_APP_INSTALL_ACCESS'
  | 'UNLISTED_APP_INSTALL_ACCESS'
  | 'MARKETPLACE_APP_INSTALL_ACCESS'
  | 'HUBSPOT_ON_CREDITS'
  | 'FRONT_OFFICE_SEAT_ACCESS'
  | 'INTEGRATIONS_MANAGEMENT'
  | 'MOBILE_APP_CONFIG'
  | 'CORE_SEAT_ACCESS'
  | 'CALLS_TO_ACTION_AI_GENERATION_ACCESS'
  | 'SERVICE_KEY_WRITE'
  | 'GENERATIVE_AI_EVALS'
  | 'CPQ_QUOTE_PARTNER'
  | 'PARTNER_MAP_WRITE'
  | 'PARTNER_MAP_READ'
  | 'PARTNER_MAP_ACCESS'
  | 'PNP_PANDS_APPROVERS'
  | 'API_CLIENTS_ACCESS'
  | 'FINTECH_PORTAL_REVIEW_WRITE'
  | 'FRONT_OFFICE_TRIAL_SEAT_ACCESS'
  | 'CORE_TRIAL_SEAT_ACCESS'
  | 'PNP_REVACCOUNTING_APPROVERS'
  | 'UNTRUSTED_SCOPES_READ'
  | 'CONTENT_SITE_SPEED'
  | 'CRM_IMPORT_EXPORT_INCREASED_LIMITS'
  | 'HD_BREEZE_QA'
  | 'MEETING_EXECUTION_BE_ADMIN'
  | 'SEQUENCES_ADVANCED_FEATURES'
  | 'COMPANY_DOCUMENT_WRITE'
  | 'HUBSPOTTER_SEAT_ACCESS'
  | 'TEAM_IMPORT_ACCESS'
  | 'TOPIC_ACCESS'
  | 'TOPIC_READ'
  | 'TOPIC_WRITE'
  | 'CONTEXT_INSIGHT_WRITE'
  | 'CALLS_SENSITIVE_DATA_READ'
  | 'CALLS_SENSITIVE_DATA_WRITE'
  | 'EMAILS_SENSITIVE_DATA_READ'
  | 'EMAILS_SENSITIVE_DATA_WRITE'
  | 'MEETINGS_SENSITIVE_DATA_READ'
  | 'NOTES_SENSITIVE_DATA_READ'
  | 'TASKS_SENSITIVE_DATA_READ'
  | 'MEETINGS_SENSITIVE_DATA_WRITE'
  | 'NOTES_SENSITIVE_DATA_WRITE'
  | 'TASKS_SENSITIVE_DATA_WRITE'
  | 'PDM_WORKSPACE_VIEWS_CREATE_WRITE'
  | 'DATA_INTEGRATION_FILE_DATASOURCE_READ'
  | 'DATA_INTEGRATION_FILE_DATASOURCE_WRITE'
  | 'CALL_PREPARATION_53_NOTIFICATIONS'
  | 'CONTEXT_INSIGHT_READ'
  | 'BREEZE_ASSISTANT_ADMINS_ACCESS'
  | 'EMAIL_SEND'
  | 'STAGGER_MARKETING_EMAILS'
  | 'APP_GOVERNANCE_READ'
  | 'APP_GOVERNANCE_WRITE'
  | 'BRAND_SETTINGS_EDIT'
  | 'BRAND_SETTINGS_VIEW'
  | 'SENSITIVE_DATA_OPT_IN_ACCESS_PRO'
  | 'CUSTOMER_SUPPORT_EMAIL_SUPPORT_TOOLS'
  | 'HYDRA_CONFIG'
  | 'APP_PERMISSION_PROMOTION_ACCESS'
  | 'TICKET_EMAIL_CREATE'
  | 'BUCKETED_OBJECTS_USAGE_BASED_BILLING'
  | 'CALLING_MINUTES_USAGE_BASED_BILLING'
  | 'CUSTOM_EVENTS_USAGE_BASED_BILLING'
  | 'EMAIL_SENDS_USAGE_BASED_BILLING'
  | 'NON_AI_WORKFLOW_USAGE_BASED_BILLING'
  | 'QUOTES_USAGE_BASED_BILLING'
  | 'WHATSAPP_USAGE_BASED_BILLING'
  | 'BUCKETED_OBJECTS_MODEL'
  | 'USAGE_LIBRARY_READ'
  | 'USAGE_LIBRARY_WRITE'
  | 'BREEZE_ASSISTANT_CHADMIN_ACCESS'
  | 'BUYING_GROUPS_READ'
  | 'BUYING_GROUPS_WRITE'
  | 'FILTER_INSIGHTS_ACCESS'
  | 'CONTENT_SUGGESTION_ACCESS'
  | 'CONTENT_SUGGESTION_READ'
  | 'CONTENT_SUGGESTION_WRITE'
  | 'OUTREACH_AGENT_WRITE'
  | 'AI_WEBSITE_PAGES_ACCESS'
  | 'COMMERCE_BUYER_PORTAL_CONFIG_READ'
  | 'COMMERCE_BUYER_PORTAL_CONFIG_WRITE'
  | 'SERVICE_KEY_READ'
  | 'CRM_SMART_CARDS_STARTER'
  | 'HELP_DESK_CRM_EMAIL_SEND'
  | 'OUTREACH_AGENT_ACCESS'
  | 'SLA_CONDITIONAL_ACCESS'
  | 'WORKFLOWS_CONTACT_ACTION_ACCESS'
  | 'WORKFLOWS_COMPANY_ACTION_ACCESS'
  | 'WORKFLOWS_ORDER_ACTION_ACCESS'
  | 'WORKFLOWS_PROJECT_ACTION_ACCESS'
  | 'WORKFLOWS_CONTACT_ACCESS_2'
  | 'WORKFLOWS_COMPANY_ACCESS'
  | 'WORKFLOWS_ORDER_ACCESS'
  | 'WORKFLOWS_PROJECT_ACCESS'
  | 'AUTOMATION_ACTION_WRITE'
  | 'UNIFIED_RESTORE_READ'
  | 'DEFAULT_TOPICS_WRITE'
  | 'EMAIL_REAUTH_VISIBLE'
  | 'UNIFIED_RESTORE_WRITE'
  | 'PDM_WORKSPACE_DEMO_MODE'
  | 'PARTNER_COMMISSION_STATEMENTS_UPLOAD'
  | 'REPORTING_UNUSED_ASSET_ACCESS'
  | 'PREDICTIVE_CX_SCORE_ACCESS'
  | 'CRM_SMART_CARDS_FREE'
  | 'HELP_DESK_REPLY_EDITOR_JITA_ACCESS'
  | 'ASSIGN_TASKS_TO_CONTACTS'
  | 'BET_HUB_DEACTIVATE'
  | 'CONTACT_ASSIGNED_TASK_ACCESS'
  | 'PDM_WORKSPACE_DASHBOARD_ADMIN'
  | 'SENSITIVE_DATA_NOTIFICATION_SETTING_WRITE'
  | 'PRE_RENDERED_STATUS_READ'
  | 'CRM_SCP_USER_ACCESS'
  | 'PRE_RENDERED_STATUS_WRITE'
  | 'EMAIL_VARIANT_ACCESS'
  | 'CRM_SCP_ACCESS'
  | 'AEO_PROMPT_WRITE'
  | 'AEO_RUN_PROMPTS'
  | 'AEO_MULTI_ENGINE'
  | 'RECURRING_TASKS_READ'
  | 'AEO_STANDALONE_ACCESS'
  | 'AUTOMATION_INDEX_READ'
  | 'FE_AT_COVERAGE'
  | 'AUTOMATION_INDEX_WRITE'
  | 'CONVERSATIONS_AI_HANDOFF_SUMMARIES'
  | 'SUSPEND_HUBS'
  | 'CRM_DOWNMARKET_EXPERIENCE'
  | 'CRM_UPMARKET_EXPERIENCE'
  | 'NUDGE_SEAT_UPGRADE_ELIGIBILITY_ACCESS'
  | 'APP_GOVERNANCE_APPROVE'
  | 'APP_GOVERNANCE_APPROVAL_READ'
  | 'APP_GOVERNANCE_APPROVAL_WRITE'
  | 'HELP_DESK_MACROS_WRITES_ACCESS'
  | 'HUBSPOTTER_ACCESS_GATEWAY_DEBUG'
  | 'IP_RANGES_WEBHOOK_SUBSCRIPTIONS_READ'
  | 'EMAIL_SENDS'
  | 'IP_RANGES_WEBHOOK_SUBSCRIPTIONS_WRITE'
  | 'MARKETING_REPORT_ACCESS'
  | 'REPORTS_MARKETING_STARTER_ACCESS'
  | 'REPORTS_SERVICE_STARTER_ACCESS'
  | 'DEAL_PROGRESSION_EMAIL_ACCESS'
  | 'BRAND_IDENTITY_FREE'
  | 'USER_CUSTOM_EMAIL_INVITE'
  | 'MARKETPLACE_APP_PROVIDER_READ_ONLY'
  | 'DEAL_PLAN_WRITE'
  | 'DEAL_PLAN_ACCESS'
  | 'DEAL_PLAN_MILESTONE_ACCESS'
  | 'MENTIONS_WRITE'
  | 'MENTIONS_READ'
  | 'PNP_LOCALIZATION_APPROVERS'
  | 'DEAL_PLAN_MILESTONE_WRITE'
  | 'FINTECH_SKU_PURCHASE_TERMS_EDIT'
  | 'SIGNUP_INTEGRATION_TOKEN_GENERATION'
  | 'PRODUCT_RELEASE_ELIGIBILITY_PILOT_ENROLL_SELF_SERVICE'
  | 'SMART_DATA_CAPTURE_SETTINGS_ACCESS'
  | 'AUTOPROSPECTOR_WORKBENCH_WRITE'
  | 'CRM_DOWNMARKET_EXPERIENCE_STARTER_ONLY'
  | 'CEM_SIDEKICK'
  | 'PNP_EXP_UI_ACCESS'
  | 'LEGAL_TERMS_CHANNEL_TEXT'
  | 'ACADEMY_LABS_ADMIN'
  | 'CUSTOMER_AGENT_JITA_ACCESS'
  | 'DEAL_PLAN_PORTAL_CONFIG_READ'
  | 'DEAL_PLAN_PORTAL_CONFIG_WRITE'
  | 'KNOWLEDGE_BOX_WRITE_HS_OTHER'
  | 'JITA_AUDIT_READ'
  | 'HAWKEYE_SLA_EDIT'
  | 'ABM_CLOSED_TESTING'
  | 'BOARD_SETTINGS_LANE_INSIGHTS_DEFAULTS'
  | 'EXTERNAL_DATA_SOURCES_ACCESS'
  | 'SENSITIVE_DATA_AI_ACCESS'
  | 'ACCESS_PROFILES_HIGH_RISK_ADMIN'
  | 'OUTREACH_AGENT_READ'
  | 'DASHBOARD_BLUEPRINT_ACCESS'
  | 'COOKIE_SCANNING_ACCESS_GRANDFATHERED'
  | 'AUTOMATION_EMBEDDED_ACCESS'
  | 'DEAL_CATCHUPTAB'
  | 'BATCH_EMAIL_SUPPORT_CANCEL'
  | 'TEAMWORK_PRIVATE_JITA'
  | 'AUTOMATED_INACTIVE_USER_DEACTIVATION'
  | 'BREEZE_BUILDER'
  | 'FLYWHEEL_PROSPECTING_WORKSPACE_SALES_SPECIALIST_ACCESS'
  | 'PRODUCT_APPROVALS_READ'
  | 'SOLUTIONS_PARTNER'
  | 'DOCUMENTS_PAID_ACCESS'
  | 'VIEW_LIBRARY_ADMIN'
  | 'CEM_CUSTOM_IMAGE'
  | 'WORKFORCE_MANAGEMENT_SETTINGS_EDIT'
  | 'WORKFORCE_MANAGEMENT_SETTINGS_VIEW'
  | 'CALLING_ENHANCED_CALL_SUMMARIES'
  | 'ACADEMY_ONBOARDING'
  | 'DEVELOPER_PLATFORM_LOGS_READ'
  | 'CONVERSATIONAL_ENRICHMENT_SIGNATURE_EXTRACTION_ACCESS'
  | 'NOTIFICATIONS_ELEVATED_PERMISSIONS'
  | 'SUSPICIOUS_APPS_REVIEW_WRITE'
  | 'LABORATORY_CUSTOM_AUDIENCES'
  | 'LABORATORY_ALLOW_CREATION_CMS_EXPERIMENTS'
  | 'LABORATORY_ALLOW_CREATION_SCRIPT_EXPERIMENTS'
  | 'LABORATORY_ALLOW_QA_ACCESS'
  | 'LABORATORY_ADMINISTRATIVE_ACCESS'
  | 'NOTETAKER_ADMIN'
  | 'SNIPPETS_CORE_ACCESS'
  | 'TEMPLATES_CORE_LIMIT'
  | 'WORKFORCE_MANAGEMENT_SETTINGS_ACCESS'
  | 'ECHOES_INSPECTOR_ACCESS'
  | 'PRICE_BOOK_READ'
  | 'PRICE_BOOK_WRITE'
  | 'DATA_INTEGRATION_JSON_DATASOURCE_READ'
  | 'DATA_INTEGRATION_JSON_DATASOURCE_WRITE'
  | 'SUSPICIOUS_APP_REVIEW_WRITE'
  | 'CONTENT_AGENT_ACCESS'
  | 'LOGIN_PERSONA_NOTIFICATION_MIGRATION'
  | 'AEO_PREMIUM_ENGINES'
  | 'LANDINGPAGES_READ'
  | 'SMS_TRANSACTIONAL_10DLC_ADDON'
  | 'AUTOPROSPECTOR_WORKBENCH_READ'
  | 'SEQUENCES_PUBLIC_WRITE'
  | 'PRICE_BOOK_ACCESS'
  | 'APPROVALS_INTERNAL'
  | 'BRAND_VOICE_EDIT'
  | 'FINTECH_DISCOUNTS_PORTAL_ENROLLMENT_WRITE'
  | 'PAYOUTS_WRITE'
  | 'COSEMAIL_RELEASE_INTERNAL'
  | 'PAYOUTS_ACCESS'
  | 'SITEPAGES_READ'
  | 'EMAIL_CONTEXTUAL_AUTOMATION_RESTRICTED_ACCESS'
  | 'EMAIL_CAMPAIGN_BUSINESS_UNIT_BLOCKED'
  | 'TEAMS_PARTITIONING_GROUP_2_BLOCKED'
  | 'REVENUE_CONTEXT_ACCESS'
  | 'WORKFLOWS_DELETE'
  | 'CUSTOMER_STATE_PIPELINES'
  | 'FLYWHEEL_PROSPECTING_PLAYS_MANAGEMENT_ACCESS'
  | 'ALLOW_TEST_SEND_IN_FREE_GRANDFATHERED'
  | 'EMAIL_HUBL_SUPPORT_GRANDFATHERED'
  | 'TEAMS_ADVANCED_MODELING_WRITE'
  | 'TEAMS_ADVANCED_MODELING_READ'
  | 'TEAMS_MULTITEAM_READ'
  | 'TEAMS_MULTITEAM_WRITE'
  | 'WORKFLOWS_READ'
  | 'DEMO_DATA_GENERATOR_ADMIN_ACCESS'
  | 'BILLING_ADMIN_SETTINGS_WRITE'
  | 'REVENUE_CONTRACTS_PUBLIC_API_WRITE'
  | 'TRIAL_MANAGEMENT_UI'
  | 'HAWKEYE_ADMIN'
  | 'USER_TYPES_READ'
  | 'SEQUENCES_PUBLIC_DELETE'
  | 'PERM_MPM_QUOTE_MANAGEMENT'
  | 'BET_PARTNER_ADMIN_BONUS_POINTS_WRITE'
  | 'CEM_NUDGE_PERSONALIZATION'
  | 'CONVERSATIONS_BLOCK_IP_ADDRESS'
  | 'BUYING_DIRECT_TO_BUY_ADMIN'
  | 'SALES_TEMPLATES_PUBLIC_READ'
  | 'PIPELINE_LIMITS_BUCKET'
  | 'CEM_SEGMENT_TARGETING'
  | 'ROUTING_CUSTOMER_AGENT_WRITE'
  | 'CEM_SYNC_TO_PROD'
  | 'EINVOICE_SETTINGS_READ'
  | 'EINVOICE_SETTINGS_WRITE'
  | 'EINVOICE_SEND_ELIGIBLE'
  | 'GTM_SEAT_ACCESS'
  | 'BUYING_PRODUCT_GROUPS_ADMIN'
  | 'OBJECT_TYPE_MODIFICATION'
  | 'CREDIT_ORACLE'
  | 'EMAIL_SENDING_IP_MITIGATIONS'
  | 'LOVABLE_APP_READ'
  | 'SALES_TEMPLATES_PUBLIC_WRITE'
  | 'CASH_APPS_READONLY'
  | 'CASH_APPS_WRITE'
  | 'DEAL_SPLITS_WRITE_NEW'
  | 'PAPIMAN_AI_FEATURES_ACCESS'
  | 'OPS_SEAT_ACCESS'
  | 'CQT_QUOTES_ACCESS'
  | 'CORE_SEAT_EXCLUDED'
  | 'WFC_NEW_CUSTOMER_ACCESS'
  | 'AGENT_SEAT_ACCESS'
  | 'AEO_WRITE'
  | 'CRM_RECORD_CUSTOMIZATION_READ'
  | 'CONVERSATION_RECORD_VIEW'
  | 'IP_ADDRESS_BLOCKS_ACCESS'
  | 'AEO_RECS_ACTIONS'
  | 'PAYMENTS_CHECKOUT_SETTINGS_READ'
  | 'MARKETING_EVENT_PIPELINE_ACCESS'
  | 'AGENT_IDLE_ACCESS'
  | 'MILESTONES_READ'
  | 'MILESTONES_WRITE'
  | 'MILESTONES_ACCESS'
  | 'MEETING_PREP_ACTIVITY_ACCESS'
  | 'SMART_DATA_CAPTURE_ACCESS'
  | 'CONTACTS_SCHEMA_READ'
  | 'AI_FOUNDATIONAL_CONTEXT_WRITE'
  | 'TASKS_UI_ADMIN'
  | 'SMART_DATA_CAPTURE_SETTINGS_ACCESS_TRIAL'
  | 'SMART_DATA_CAPTURE_ACCESS_TRIAL'
  | 'LIVE_DATA_SIGNING_KEYS_READ'
  | 'WORKFLOWS_WRITE'
  | 'LIVE_DATA_SIGNING_KEYS_WRITE'
  | 'DASHBOARD_SECTIONS_EDIT'
  | 'CRM_SMART_TRANSFER_AUDIT_READ'
  | 'CRM_SMART_TRANSFER_AUDIT_WRITE'
  | 'TRIALS_WRITE_ACCESS'
  | 'CRM_SMART_TRANSFER_TRANSFER_READ'
  | 'CRM_SMART_TRANSFER_TRANSFER_WRITE'
  | 'CRM_SMART_TRANSFER_REVERT_READ'
  | 'CRM_SMART_TRANSFER_REVERT_WRITE'
  | 'SEQUENCES_ENROLL_ON_BEHALF_ACCESS'
  | 'SIMILAR_DEALS_ACCESS'
  | 'QUOTE_TEMPLATES_ACCESS'
  | 'EMBEDDING_USAGE_READ'
  | 'PERM_MPM_ACCESS'
  | 'GTM_TRIAL_SEAT_ACCESS'
  | 'SALES_METHODOLOGY_ANALYZER_ACCESS'
  | 'OPS_TRIAL_SEAT_ACCESS'
  | 'STALLED_DEALS'
  | 'DEAL_RECOMMENDED_ACTIONS'
  | 'HD_TOPICS_TAB_ACCESS'
  | 'PARTNER_HUB'
  | 'MOBILE_OFFLINE'
  | 'SENSITIVE_DATA_HELPDESK_ACCESS'
  | 'FLYWHEEL_PROSPECTING_WORKSPACE_SDR_ACCESS'
  | 'DEAL_PROGRESSION_AGENT_ACCESS'
  | 'NURTURE_AGENT_ACCESS'
  | 'WORK_PRIVATE_JITA'
  | 'WORK_WRITE'
  | 'SUCCESS_PLANS_PUBLISHING_ACCESS'
  | 'LEGAL_AND_COMPLIANCE_CONTENT_LIBRARY_WRITE'
  | 'BET_ACTIVITY_TYPES_GS_SMALL_BIZ'
  | 'TASKS_DELETE_ALL'
  | 'TASKS_DELETE_OWNED_ONLY'
  | 'TASKS_DELETE_TEAM_ONLY'
  | 'TASKS_DELETE_UNASSIGNED'
  | 'TRANSCRIPTS_PUBLIC_API_PORTAL_LEVEL_WRITE'
  | 'TRANSCRIPTS_PUBLIC_API_PORTAL_LEVEL_READ'
  | 'CUSTOMER_AGENT_CONTENT_SOURCE_ACCESS'
  | 'CUSTOMER_AGENT_CONTENT_SOURCE_READ'
  | 'CUSTOMER_AGENT_CONTENT_SOURCE_WRITE'
  | 'BREEZE_CONVERSATION_ACCESS'
  | 'BREEZE_CONVERSATION_READ'
  | 'BREEZE_CONVERSATION_WRITE'
  | 'MARKETING_EVENT_INTERACTION_ACCESS'
  | 'MARKETING_EVENT_INTERACTION_READ'
  | 'MARKETING_EVENT_INTERACTION_WRITE'
  | 'BREEZE_ARTIFACT_ACCESS'
  | 'BREEZE_ARTIFACT_READ'
  | 'BREEZE_ARTIFACT_WRITE'
  | 'ASSET_QA_MARKETING_EMAIL'
  | 'VIDEO_GENERATION_ACCESS'
  | 'FLYWHEEL_PREP_ACCESS'
  | 'AEO_USAGE_BASED_BILLING'
  | 'DATA_SYNC_WRITE'
  | 'DATA_SYNC_READ'
  | 'WEIERSTRASS_INTERNAL'
  | 'REVENUE_MILESTONES_PUBLIC_API_READ'
  | 'REVENUE_MILESTONES_PUBLIC_API_WRITE'
  | 'PERM_MPM_ADMIN'
  | 'DATA_MODEL_WRITE'
  | 'SURVEY_MANAGER_REQUEST_MANAGE'
  | 'ENTERPRISE_MANAGED_AUTH_READ'
  | 'ENTERPRISE_MANAGED_AUTH_WRITE'
  | 'COMMUNICATIONS_VIEW_TEAM'
  | 'COMMUNICATIONS_VIEW_UNASSIGNED'
  | 'AEO_CLAUDE_ENGINE'
  | 'COMMUNICATIONS_VIEW_ALL'
  | 'COMMUNICATIONS_READ'
  | 'LEAST_PRIVILEGES_ACCESS'
  | 'CONVERSATIONAL_CONTEXT_USAGE_BASED'
  | 'FORECASTING_ADMIN'
  | 'MAX_DISCOUNT_OVERRIDE_ACCESS'
  | 'DESIGN_MANAGER_PRIMARY_CSS_ACCESS'
  | 'SEAT_SHARING_RESTRICTED'
  | 'WORKFLOWS_PUBLISH'
  | 'MEETING_ROTATIONS_SETTINGS_READ'
  | 'MARKETING_STUDIO_ACCESS'
  | 'ONBOARDING_FSC_GTM_PROFESSIONAL'
  | 'ONBOARDING_FSC_GTM_ENTERPRISE'
  | 'TRIAL_FSC_GTM_ENTERPRISE'
  | 'TRIAL_FSC_GTM_PROFESSIONAL'
  | 'PORTABILITY_SYNC_ACCESS'
  | 'CONVERSATIONS_API_SENSITIVE_READ'
  | 'CONVERSATIONS_API_SENSITIVE_WRITE'
  | 'MESSAGING_OUTGOING_ACCESS'
  | 'CRM_OBJECTS_USERS_EMAIL_CONNECTION_READ'
  | 'ORDERS_VIEW_ALL'
  | 'ORDERS_VIEW_TEAM'
  | 'ORDERS_VIEW_UNASSIGNED'
  | 'ORDERS_EDIT_ALL'
  | 'ORDERS_EDIT_TEAM'
  | 'ORDERS_EDIT_OWNED'
  | 'ORDERS_EDIT_UNASSIGNED'
  | 'ORDERS_DELETE_ALL'
  | 'ORDERS_DELETE_TEAM'
  | 'ORDERS_DELETE_OWNED'
  | 'ORDERS_DELETE_UNASSIGNED'
  | 'WORK_WORKSPACES_WRITE'
  | 'OBJECT_TYPE_CUSTOMIZE_PUBLIC'
  | 'OBJECT_TYPE_ACTIVATE_PUBLIC'
  | 'PERM_SEGMENT_FOUNDATIONS_TOOLS_ACCESS'
  | 'CRM_MULTI_OBJECT_INDEX_READ_ALL'
  | 'CRM_MULTI_OBJECT_INDEX_WRITE'
  | 'WAITLIST_SETTINGS_WRITE'
  | 'OPS_SEAT_EXCLUDED'
  | 'FLYWHEEL_PREP_VIEW'
  | 'DASHBOARDS_DATE_FILTERS_RESTRICTION'
  | 'DOMAIN_CONTROLS_PARTNER_RESTRICTION_ADMIN'
  | 'REVENUE_RECOGNITION_REPAIR'
  | 'CALLS_SETTINGS_WRITE'
  | 'WORKFLOWS_TRIGGER'
  | 'API_USAGE_READ'
  | 'CEM_BREEZE_CTA'
  | 'BREEZE_ASSISTANT_CRM_DATA_UPDATES_ACCESS'
  | 'BREEZE_ASSISTANT_BULK_DATA_UPDATES_ACCESS'
  | 'BREEZE_ASSISTANT_EXTERNAL_WEB_REQUESTS_ACCESS'
  | 'SEQUENCES_INTERNAL_ADMIN'
  | 'CEM_RE_ELIGIBILITY'
  | 'WEB_INTERACTIVES_UNPUBLISH'
  | 'CONTACTS_SCHEMA_WRITE'
  | 'CONTACTS_SCHEMA_DELETE'
  | 'COMMUNICATIONS_WRITE'
  | 'POSTAL_MAIL_WRITE'
  | 'POSTAL_MAIL_READ'
  | 'CONTRACTS_SCHEMA_WRITE'
  | 'BACKFILL_DEAL_CATCH_UP_TAB'
  | 'COMPANIES_SCHEMA_WRITE'
  | 'COMPANIES_SCHEMA_DELETE'
  | 'CONTACTS_IMPORT'
  | 'COMMUNICATIONS_SCHEMA_READ'
  | 'POSTAL_MAIL_SCHEMA_READ'
  | 'COMPANIES_SCHEMA_READ'
  | 'DEALS_SCHEMA_WRITE'
  | 'DEALS_SCHEMA_READ'
  | 'LISTS_TEAM_SETTING_PERMISSIONS'
  | 'TICKETS_SCHEMA_READ'
  | 'TICKETS_SCHEMA_WRITE'
  | 'CASH_APPS_ADMIN_WRITE'
  | 'WORKFLOWS_MARKETING_EMAIL_TRIGGER_RESTRICTED_ACCESS'
  | 'TICKETS_SCHEMA_DELETE'
  | unhandledEnumCase;

export type GetInstallCountRequestType = Requestify<InstallCountRequest>;
export type GetInstallCountResponseType = InstallCountResponse;
export type GetInstallCountErrorType = InstallsError & HubspotMetadata;
export const getInstallCountRpc: ChirpAvroRpcDetails<
  GetInstallCountRequestType,
  GetInstallCountResponseType,
  GetInstallCountErrorType,
  false
> = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc',
  rpcName: 'getInstallCount',
  auth: 'app',
  fingerprint: '1GVyj-c0nbbLhlmz-StH-2abcsFx5_XF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetInstallCountBatchRequestType =
  Requestify<InstallCountBatchRequest>;
export type GetInstallCountBatchResponseType = InstallCountBatchResponse;
export type GetInstallCountBatchErrorType = InstallsError & HubspotMetadata;
export const getInstallCountBatchRpc: ChirpAvroRpcDetails<
  GetInstallCountBatchRequestType,
  GetInstallCountBatchResponseType,
  GetInstallCountBatchErrorType,
  false
> = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc',
  rpcName: 'getInstallCountBatch',
  auth: 'app',
  fingerprint: 'DNd7wgjU8CH7NryORdFGcmabcsFx5_XF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type SendInstallIntentRequestType = Requestify<InstallIntentRequest>;
export type SendInstallIntentResponseType = ChirpVoid;
export type SendInstallIntentErrorType = EmptyError & HubspotMetadata;
export const sendInstallIntentRpc: ChirpAvroRpcDetails<
  SendInstallIntentRequestType,
  SendInstallIntentResponseType,
  SendInstallIntentErrorType,
  false
> = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc',
  rpcName: 'sendInstallIntent',
  auth: 'app',
  fingerprint: 'kRfYehF9JMeOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetInstallCompatibilityRequestType =
  Requestify<InstallCompatibilityRequest>;
export type GetInstallCompatibilityResponseType = InstallCompatibilityResponse;
export type GetInstallCompatibilityErrorType = InstallsError & HubspotMetadata;
export const getInstallCompatibilityRpc: ChirpAvroRpcDetails<
  GetInstallCompatibilityRequestType,
  GetInstallCompatibilityResponseType,
  GetInstallCompatibilityErrorType,
  false
> = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc',
  rpcName: 'getInstallCompatibility',
  auth: 'app',
  fingerprint: 'EMEKYpDHguAT-ezggfE8rGabcsFx5_XF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetInstallabilityRequestType = Requestify<InstallabilityRequest>;
export type GetInstallabilityResponseType = InstallabilityResponse;
export type GetInstallabilityErrorType = InstallsError & HubspotMetadata;
export const getInstallabilityRpc: ChirpAvroRpcDetails<
  GetInstallabilityRequestType,
  GetInstallabilityResponseType,
  GetInstallabilityErrorType,
  false
> = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc',
  rpcName: 'getInstallability',
  auth: 'app',
  fingerprint: '2g_WAhcPm2ZQGCCIAI23tGabcsFx5_XF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetOAuthUrlRequestType = Requestify<OAuthUrlRequest>;
export type GetOAuthUrlResponseType = OAuthUrlResponse;
export type GetOAuthUrlErrorType = InstallsError & HubspotMetadata;
export const getOAuthUrlRpc: ChirpAvroRpcDetails<
  GetOAuthUrlRequestType,
  GetOAuthUrlResponseType,
  GetOAuthUrlErrorType,
  false
> = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc',
  rpcName: 'getOAuthUrl',
  auth: 'app',
  fingerprint: 'JZt2TrxwxYT5LYzHdF922mabcsFx5_XF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetInstallExemptionStatusRequestType =
  Requestify<GetInstallExemptionStatusRequest>;
export type GetInstallExemptionStatusResponseType =
  GetInstallExemptionStatusResponse;
export type GetInstallExemptionStatusErrorType = EmptyError & HubspotMetadata;
export const getInstallExemptionStatusRpc: ChirpAvroRpcDetails<
  GetInstallExemptionStatusRequestType,
  GetInstallExemptionStatusResponseType,
  GetInstallExemptionStatusErrorType,
  false
> = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc',
  rpcName: 'getInstallExemptionStatus',
  auth: 'app',
  fingerprint: 'eK15BktC1bQB-PCeIJe2pZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetRequiredScopeGroupsRequestType =
  Requestify<RequiredScopeGroupRequest>;
export type GetRequiredScopeGroupsResponseType = RequiredScopeGroupResponse;
export type GetRequiredScopeGroupsErrorType = InstallsError & HubspotMetadata;
export const getRequiredScopeGroupsRpc: ChirpAvroRpcDetails<
  GetRequiredScopeGroupsRequestType,
  GetRequiredScopeGroupsResponseType,
  GetRequiredScopeGroupsErrorType,
  false
> = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc',
  rpcName: 'getRequiredScopeGroups',
  auth: 'app',
  fingerprint: '1fUg7LvEQIRiVJsVpGvLTGabcsFx5_XF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CheckRequiredScopeGroupsInSyncRequestType =
  Requestify<RequiredScopeGroupInSyncRequest>;
export type CheckRequiredScopeGroupsInSyncResponseType =
  RequiredScopeGroupInSyncResponse;
export type CheckRequiredScopeGroupsInSyncErrorType = InstallsError &
  HubspotMetadata;
export const checkRequiredScopeGroupsInSyncRpc: ChirpAvroRpcDetails<
  CheckRequiredScopeGroupsInSyncRequestType,
  CheckRequiredScopeGroupsInSyncResponseType,
  CheckRequiredScopeGroupsInSyncErrorType,
  false
> = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc',
  rpcName: 'checkRequiredScopeGroupsInSync',
  auth: 'app',
  fingerprint: 'ft54UptMTO8fbIa0DVDg22abcsFx5_XF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
